/* eslint-disable */
import certificationModalTemplate from '../../app/main/common/certificationModalList.html'
import authenticationModalTemplate from '../../app/main/common/authenticationModalList.html'
class httpRequest {
    constructor($q, $http, $state, logger, $uibModal) {
        this.$q = $q
        this.$http = $http
        this.$state = $state
        this.logger = logger
        this.$uibModal = $uibModal
    }
    /**
     *
     * @param {*}
     * @param {*}
     */
    checkErrorCode(code) {
        if (!code) return
        const codeArr = String(code).split('')
        const codeStr = codeArr[0] + codeArr[1]
        if (codeStr == '13' || codeStr == '14' || codeStr == '15' || codeStr == '16') {
            return 'error'
        } else {
            return 'warn'
        }
    }

    request(httpApi, msg) {
        const deferred = this.$q.defer()
        httpApi().then(
            (res) => {
                const apiCodeStr = this.checkErrorCode(res.data.msgCode)
                try {
                    // 这里根据具体的业务返回数据 进行装饰需要
                    if (res.data.success == false) {
                        deferred.reject(res.data.message)
                        // this.logger.logError(res.data.message || '接口异常')
                        if (msg !== false) this.logger.logTips(res.data.message || '接口异常', apiCodeStr || 'error')
                        // 2002 短信
                        // -99998 实人认证
                        if (res.data.msgCode === -99998) {
                            this.$uibModal.open({
                                template: certificationModalTemplate,
                                controller: 'certificationModalCtrl',
                                backdrop: 'static',
                                openedClass: 'mod-modal mod-modal-lg',
                                resolve: {
                                    items1() {
                                        return { authorizeId: res.data.emsg }
                                    },
                                },
                            })
                        } else if (res.data.msgCode === 2002 || res.data.msgCode === 2003) {
                            let startIndex = res.data.message.length - 11
                            let endIndex = res.data.message.length
                            this.$uibModal.open({
                                template: authenticationModalTemplate,
                                controller: 'authenticationModalCtrl',
                                backdrop: 'static',
                                openedClass: 'mod-modal mod-modal-lg',
                                resolve: {
                                    items1() {
                                        return {
                                            authorizeId: res.data.emsg,
                                            mobile: res.data.message.substring(startIndex, endIndex),
                                        }
                                    },
                                },
                            })
                        }
                        return // 预期不继续执行后续的 成功弹框
                    }
                } catch (e) {
                    deferred.reject(e)
                    console.error(e)
                }
                deferred.resolve(res)
                if (typeof msg === 'string') this.logger.logSuccess(msg)
                if (msg === true) this.logger.logSuccess(res.data.message)
            },
            (err) => {
                const errCode = this.checkErrorCode(err.data.msgCode)
                deferred.reject(err)
                if (err.data && err.data.message) {
                    // Begin:add by wxb for [清除所有本地存在] on 2017-11-27
                    if (err.data.msgCode == 10005) {
                        // 没权限
                        // TODO
                    } else if (err.data.msgCode == 10001 || err.data.msgCode == 10002) {
                        // 没有登陆
                        localStorage.clear()
                        localStorage.eVersion = eVersion
                        this.$state.go('login')
                    }
                    return this.logger.logTips(err.data.message || '接口异常', errCode || 'error')
                    // END
                }
                this.logger.logError('接口访问存在网络异常.')
            }
        )
        return deferred.promise
    }
    request1(httpApi, msg) {
        const deferred = this.$q.defer()
        httpApi().then(
            (res) => {
                const apiCodeStr = this.checkErrorCode(res.data.msgCode)
                if (res.data.success == false) {
                    // deferred.reject(res.data.message);
                    // this.logger.logError(res.data.message || '接口异常')
                    if (msg !== false) this.logger.logTips(res.data.message || '接口异常', apiCodeStr || 'error')
                }
                deferred.resolve(res)
                if (typeof msg === 'string') this.logger.logSuccess(msg)
                if (msg === true) this.logger.logSuccess(res.data.message)
            },
            (err) => {
                const errCode = this.checkErrorCode(err.data.msgCode)
                deferred.reject(err)
                if (err.data && err.data.message) {
                    // Begin:add by wxb for [清除所有本地存在] on 2017-11-27
                    if (err.data.msgCode == 10005) {
                        // 没权限
                        // TODO
                    } else if (err.data.msgCode == 10001 || err.data.msgCode == 10002) {
                        // 没有登陆
                        localStorage.clear()
                        localStorage.eVersion = eVersion
                        this.$state.go('login')
                    }
                    return this.logger.logTips(err.data.message || '接口异常', errCode || 'error')
                    // END
                }
                this.logger.logError('接口访问存在网络异常.')
            }
        )
        return deferred.promise
    }
    getParamUrl(data, url) {
        if (!data) return url
        // body... 请求序列化
        const _url = url
        let dataStr = '' // 数据拼接字符串
        Object.keys(data).forEach((key) => {
            dataStr += `${key}=${encodeURI(data[key])}&`
        })
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
        const newurl = `${_url}?${dataStr}`
        return newurl
    }

    // 获取验证码
    getfreshCode(msg) {
        return this.request(() => this.$http.get(`${host.etcloud}auth/login/freshCode`), msg)
    }

    // 分页查询机构 /ems/sysOrganization/getSysOrganizationList
    post_getSysOrganizationList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysOrganization/getSysOrganizationList`, postData), msg)
    }
    // ems/sysOrganization/qryByCondition
    post_qryByCondition(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysOrganization/qryByCondition`, postData))
    }
    // 根据机构树 id 查 机构表
    get_organization(orgId, msg) {
        var _url
        orgId ? (_url = `${host.etcloud}ems/sysOrganization/getSysOrgChildsTree?orgId=${orgId}&flag=${true}`) : (_url = `${host.etcloud}ems/sysOrganization/getSysOrgChilds?orgId=${orgId}`)
        return this.request(() => this.$http.get(_url), msg)
    }
    // 新增机构
    post_addOrganization(data, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysOrganization/addOrganization`, data), msg)
    }
    //GET /ems/sysOrganization/getPackOfTenantOrOrg 获取租户或机构下功能包
    get_PackOfTenantOrOrg(orgId) {
        if (orgId || orgId == 0) {
            return this.request(() => this.$http.get(`${host.etcloud}ems/sysOrganization/getPackOfTenantOrOrg?orgId=${orgId}`))
        } else {
            return this.request(() => this.$http.get(`${host.etcloud}ems/sysOrganization/getPackOfTenantOrOrg`))
        }
    }
    //POST /ems/sysOrganization/updatePacksOfOrg 机构功能包更新
    post_updatePacksOfOrg(data, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysOrganization/updatePacksOfOrg`, data), msg)
    }
    // POST 获取机构列表
    post_organizationList(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysOrganization/getSysOrganizationList`, postDate), msg)
    }
    // GET 获取可分配权限列表
    get_enableFunctionList(msg) {
        return this.request(() => this.$http.get(`${host.etcloud}auth/sysFunction/getEnableFunctionList`), msg)
    }
    // GET 获取机构可分配权限列表
    get_orgEnableFunctionList(orgId, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}auth/sysFunction/getOrgEnableFuncList?orgId=${orgId}`), msg)
    }
    // GET 全部菜单数结构
    get_syncSysFunctionList(msg) {
        return this.request(() => this.$http.get(`${host.etcloud}auth/sysFunction/syncSysFunctionList`), msg)
    }
    //  GET 获取当前可操作权限  /auth/sysFunction/getFunctionListByUser
    get_getFunctionListByUser(msg) {
        return this.request(() => this.$http.get(`${host.etcloud}auth/sysFunction/${IS_PROVIDER ? 'getSupFunctionListByUser' : 'getFunctionListByUser'}`), msg)
    }
    //POST /ems/sysOrganization/qryOrgDetail 获取机构详情V2.0
    post_qryOrgDetail(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysOrganization/qryOrgDetail`, postData))
    }
    //POST /ems/sysOrganization/getTenantDetail 获取机构详情V2.0
    post_getTenantDetail(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysOrganization/getTenantDetail`, postData))
    }
    //GET /ems/sysOrganization/removeByOrgId 删除机构
    get_removeByOrgId(orgId) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysOrganization/removeByOrgId?orgId=${orgId}`))
    }

    // 获取用户自定义缓存  GET /ems/sysUserCustomized/getUserCustomized
    get_getUserCustomized(id, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysUserCustomized/getUserCustomized?type=${id}`), msg)
    }

    // POST 用户自定义缓存  /ems/sysUserCustomized/saveUserCustomized
    post_saveUserCustomized(data, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysUserCustomized/saveUserCustomized`, data), msg)
    }

    // 更新管理员
    post_updateOrgAdminUser(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysOrganization/updateOrgAdminUser`, postDate), msg)
    }
    // 更新编辑机构
    post_updateOrganization(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysOrganization/updateOrganization`, postDate), msg)
    }

    // 查看权限列表
    // GET /settings/sysOwnerInfo/getSysLicenseFunctionList
    get_sysFunctionList(tenantId, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}settings/sysOwnerInfo/getSysLicenseFunctionList`), msg)
    }

    // 获取密码策略
    get_passwordPolicy(tenantId, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}settings/sysPasswordPolicy/getSysPasswordPolicy?tenantId=${tenantId}`), msg)
    }
    // 提交密码策略
    post_passwordPolicy(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysPasswordPolicy/saveSysPasswordPolicy`, postDate), msg)
    }

    // 税务证管理分页查询
    post_getSysSaleInfoList(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierSaleInfo' : 'ems/sysSaleInfo'}/getSysSaleInfoList`, postDate), msg)
    }

    // 新增税务证POST
    post_addSaleInfo(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysSaleInfo/addSaleInfo`, postDate), msg)
    }

    // GET获取税务证信息管理

    get_getSaleInfo(postDate, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierSaleInfo/getSaleInfo?supplierSaleId=' : 'ems/sysSaleInfo/getSaleInfo?saleId='}${postDate}`), msg)
    }

    // 修改销方信息管理POST /ems/sysSaleInfo/updateSaleInfo
    post_updateSaleInfo(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierSaleInfo' : 'ems/sysSaleInfo'}/updateSaleInfo`, postDate), msg)
    }

    post_updateSaleBaseInfo(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysSaleInfo/updateSaleBaseInfo`, postData), msg)
    }

    post_updateSaleOvatInfo(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysSaleInfo/updateSaleOvatInfo`, postData), msg)
    }

    post_updateSaleIvatInfo(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysSaleInfo/updateSaleIvatInfo`, postData), msg)
    }

    // 删除销方信息管理POST /ems/sysSaleInfo/delSaleInfo
    post_delSaleInfo(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysSaleInfo/delSaleInfo`, postData), msg)
    }

    // GET 根据机构id 获取详细  /ems/sysOrganization/getSysOrgById
    get_getSysOrgById(orgId, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysOrganization/getSysOrgById?orgId=${orgId}`), msg)
    }

    // 获取企业信息
    get_companyInfo(tenantId, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}settings/sysOwnerInfo/getSysOwnerInfo?tenantId=${tenantId}`), msg)
    }
    // 上传企业信息 POST
    post_companyInfo(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysOwnerInfo/saveSysOwnerInfo`, postDate), msg)
    }

    // 获取用户信息
    post_usersInfo(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}auth/sysUser/getPageUserList`, postDate), msg)
    }
    // 修改密码
    post_updatePassword(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}auth/sysUser/updatePassword`, postDate), msg)
    }

    // 获取用户登陆信息GET /auth/login/getLoginInfo
    get_getLoginInfo(getDate, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}${IS_PROVIDER ? 'supplier/supLogin' : 'auth/login'}/getLoginInfo`, getDate), msg)
    }
    //GET auth/sysUser/qryUserInfo根据登录账户查询用户信息
    get_qryUserInfo(getDate) {
        return this.request(() => this.$http.get(`${host.etcloud}auth/sysUser/qryUserInfo?accessToken=${getDate.accessToken}&userName=${getDate.userName}`))
    }

    // 切换用户角色POST
    get_changeOrg(orgId, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/supLogin/changeCustOrg?custOrgId' : 'auth/login/changeOrg?orgId'}=${orgId}`), msg)
    }

    // 退出登陆
    get_loginOut(getDate, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}auth/login/loginOut`, getDate), msg)
    }

    // 字典数据  GET /ems/sysDictionary/getDictionaryByType
    get_dictByType(typecode, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysDictionary/getDictionaryByType?type=${typecode}`), msg)
    }

    // 字典数据  GET /ems/sysDictionary/getDictionaryByTypeArr
    get_dictByTypeArr(typecodeArr, emptyFlag, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysDictionary/getDictionaryByTypeArr?emptyFlag=${emptyFlag}`, typecodeArr), msg)
    }

    // 获取当前机构角色
    get_userOrgRole(orgId, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}auth/sysRole/getUserOrgRole?orgId=${orgId}`), msg)
    }

    // 获取用户列表
    post_usersList(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}auth/sysUser/getPageUserList`, postDate), msg)
    }
    // 获取用户信息
    get_userInfo(userId, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupUser' : 'auth/sysUser'}/getUserById?userId=${userId}`), msg)
    }
    // 权限管理   分页获取 [ 角色 ] 信息
    get_permissionRoleList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}auth/sysRole/getPageRoleList`, postData), msg)
    }

    // 权限管理   新增角色
    add_permissionRole(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}auth/sysRole/addRole`, postData), msg)
    }
    // 权限管理   获取单个角色信息
    get_permissionRoleInfo(roleId, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}auth/sysRole/getRole?roleId=${roleId}`), msg)
    }
    // 权限管理   修改角色信息
    post_permissionRoleInfo(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}auth/sysRole/updateRole`, postData), msg)
    }
    // 权限管理  删除角色功能
    post_permissionRemoveRole(roleId, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}auth/sysRole/delRole?roleId=${roleId}`), msg)
    }
    // 查询角色用户
    get_getRoleUserList(data, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}auth/sysRole/getRoleUserList?roleId=${data.roleId}&orgId=${data.orgId}`), msg)
    }

    // 查询机构用户
    get_getOrgUserList(orgId, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}auth/sysRole/getOrgUserList?orgId=${orgId}`), msg)
    }
    // 更新角色用户
    post_updateRoleUser(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}auth/sysRole/updateRoleUser`, postData), msg)
    }

    // 上传license
    post_mportClientLic(file, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysOwnerInfo/importClientLic`), msg)
    }
    // 用户管理 重置密码
    resetPassword(userName, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupUser' : 'auth/sysUser'}/restPassword?userName=${userName}`), msg)
    }
    // 用户管理 添加用户
    add_userInfo(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupUser' : 'auth/sysUser'}/addUser`, postData), msg)
    }
    // 用户管理  编辑用户
    updata_userInfo(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupUser' : 'auth/sysUser'}/updateUser`, postData), msg)
    }
    // 用户管理  删除用户
    remove_userInfo(userId, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}auth/sysUser/delUserById?userId=${userId}`), msg)
    }
    // 用户管理  取消授权
    post_cancelEmpowerment(userId, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}auth/sysUser/cancelRoleR?userId=${userId}`), msg)
    }
    // 用户管理  用户赋权
    post_updateUserRoleR(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}auth/sysUser/updateUserRoleR`, postData), msg)
    }

    // 退出登陆
    del_loginOut(getDate, msg) {
        return this.request(() => this.$http.delete(`${host.etcloud}auth/login/loginOut`, getDate), msg)
    }

    // // 获取机构 银卡列表
    post_bankBySale(saleId, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierSaleBankAccount' : 'ems/sysSaleBankAccount'}/getBankOfOrg`), msg)
    }
    // POST /ems/sysSaleBankAccount/addSaleBankAccount
    post_addSaleBankAccount(req, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierSaleBankAccount' : 'ems/sysSaleBankAccount'}/addSaleBankAccount`, req), msg)
    }
    // 更新银行卡  POST /ems/sysSaleBankAccount/updateSaleBankAccount
    post_updateSaleBankAccount(req, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierSaleBankAccount' : 'ems/sysSaleBankAccount'}/updateSaleBankAccount`, req), msg)
    }
    // 删除银行账号
    get_delSaleBankAccount(saleBankAccountId) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysSaleBankAccount/delSaleBankAccount?saleBankAccountId=${saleBankAccountId}`))
    }

    // 获取商品类别list
    // GET /settings/sysGoodsType/qryLoginUserGoodsTypeList
    get_goodsTypeList(msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsType' : 'settings/sysGoodsType'}/qryLoginUserGoodsTypeList`), msg)
    }

    // 根据“车辆编码”的类型管理与“货物或应税劳务、服务”的类别管理区分获取商品类别list
    // GET /settings/sysGoodsType/getLoginUserGoodsTypeList
    get_getLoginUserGoodsTypeList(type, msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsType' : 'settings/sysGoodsType'}/getLoginUserGoodsTypeList?type=${type}`), msg)
    }
    // 更新商品类别名称
    // /settings/sysGoodsType/modGoodsType
    post_modGoodsType(req, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsType' : 'settings/sysGoodsType'}/modGoodsType`, req), msg)
    }
    // 新增商品类别 POST /settings/sysGoodsType/addGoodsType
    post_addGoodsType(req, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsType' : 'settings/sysGoodsType'}/addGoodsType`, req), msg)
    }
    // 删除商品类别
    post_delGoodsType(typeId, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsType' : 'settings/sysGoodsType'}/delGoodsType?typeId=${typeId}`), msg)
    }

    // 获取销方信息 /ems/sysSaleInfo/getUserSaleInfo
    get_getUserSaleInfo(msg) {
        return this.request(() => this.$http.get(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierSaleInfo' : 'ems/sysSaleInfo'}/getUserSaleInfo`), msg)
    }

    // 分页查询开票点信息
    post_getSysUkeyList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierUkey' : 'ems/sysUkey'}/getSysUkeyList`, postData), msg)
    }

    // 分页查询开票点POST /ems/sysTaxDisk/getPageQrySysUkey
    post_getPageQrySysUkeyList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierTaxDisk' : 'ems/sysTaxDisk'}/pageQrySysUkey`, postData), msg)
    }
    // POST /ems/sysTaxDisk/addTaxDisk 新增金税盘信息
    post_addTaxDisk(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierTaxDisk' : 'ems/sysTaxDisk'}/addTaxDisk`, postData), msg)
    }

    // POST /ems/sysTaxDisk/updateTaxDisk 修改金税盘信息
    post_updateTaxDisk(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierTaxDisk' : 'ems/sysTaxDisk'}/updateTaxDisk`, postData), msg)
    }
    // GET /ems/sysTaxDisk/getTaxDisk 获取金税盘信息
    get_getTaxDisk(ukeyId, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierTaxDisk' : 'ems/sysTaxDisk'}/getTaxDisk?ukeyId=${ukeyId}`), msg)
    }

    // POST /ems/sysUkey/getSysUkeyList 分页查询开票点
    post_getSysUkeyList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierUkey' : 'ems/sysUkey'}/getSysUkeyList`, postData), msg)
    }
    // 获取机构可用银行账号   /ems/sysSaleBankAccount/getEnableBankOfOrg
    post_getEnableBankOfOrg(msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierSaleBankAccount' : 'ems/sysSaleBankAccount'}/getEnableBankOfOrg`), msg)
    }

    // 获取税分编码list
    // /settings/sysTaxClass/getSysTaxClassList
    post_getSysTaxClassList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}settings/sysTaxClass/getSysTaxClassList`, postData), msg)
    }
    // 商品信息分页查询
    post_pageGoodsInfo(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsInfo' : 'settings/sysGoodsInfo'}/pageGoodsInfo`, postData), msg)
    }
    // 新增开票点  /ems/sysUkey/addUkey
    post_addUkey(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierUkey' : 'ems/sysUkey'}/addUkey`, postData), msg)
    }
    // 通过ukeyId 获取开票点信息  /ems/sysUkey/getUkey
    get_geUkey(ukeyId, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierUkey' : 'ems/sysUkey'}/getUkey?ukeyId=${ukeyId}`), msg)
    }
    // 提交修改后的开票点信息  /ems/sysUkey/updateUkey
    post_updateUkey(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierUkey' : 'ems/sysUkey'}/updateUkey`, postData), msg)
    }
    // 分页获取购方信息 /settings/sysCustomer/getPageCustomerList
    post_getPageCustomerList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}settings/sysCustomer/getPageCustomerList`, postData), msg)
    }

    // 获取GET 查询税分编码信息（商品信息选择）
    get_qryTaxClassInfo(taxMergeCode, msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsInfo' : 'settings/sysGoodsInfo'}/qryTaxClassInfo?taxMergeCode=${taxMergeCode}`), msg)
    }
    // POST /settings/sysGoodsInfo/addGoodsInfo
    post_addGoodsInfo(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsInfo' : 'settings/sysGoodsInfo'}/addGoodsInfo`, postData), msg)
    }

    // POST /settings/sysGoodsInfo/modGoodsInfo  修改商品信息
    post_modGoodsInfo(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsInfo' : 'settings/sysGoodsInfo'}/modGoodsInfo`, postData), msg)
    }

    // settings/sysGoodsInfo/importToExcel 导出商品excel
    get_importToExcel(getdata) {
        const _url = `${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsInfo' : 'settings/sysGoodsInfo'}/importToExcel`
        let dataStr = '' // 数据拼接字符串
        Object.keys(getdata).forEach((key) => {
            dataStr += `${key}=${encodeURI(getdata[key])}&`
        })
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
        const url = `${_url}?${dataStr}`
        window.open(url)
    }

    // GET /settings/sysGoodsInfo/qryGoodsInfo 商品信息-详情
    get_qryGoodsInfo(goodsId, msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsInfo' : 'settings/sysGoodsInfo'}/qryGoodsInfo?goodsId=${goodsId}`), msg)
    }

    // GET /settings/sysGoodsInfo/qryGoodsInfoTax 查询商品税率
    get_qryGoodsInfoTax(data, msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsInfo' : 'settings/sysGoodsInfo'}/qryGoodsInfoTax?accessToken=${data.accessToken}&taxMergeCode=${data.taxMergeCode}&privilegeType=${data.privilegeType}`), msg)
    }

    // POST /settings/sysGoodsInfo/delGoodsInfo 删除商品信息

    post_delGoodsInfo(goodsIdList, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsInfo' : 'settings/sysGoodsInfo'}/delGoodsInfo?goodsIdList=${goodsIdList}`), msg)
    }
    // 启用禁用开票点   /ems/sysUkey/enableUkey
    post_enableUkey(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierUkey' : 'ems/sysUkey'}/enableUkey`, postdata), msg)
    }
    // 新增购方信息  /settings/sysCustomer/addSysCustomer
    post_addSysCustomer(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}settings/sysCustomer/addSysCustomer`, postdata), msg)
    }

    // 编辑购方信息 /settings/sysCustomer/updateSysCustomer
    post_updateSysCustomer(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}settings/sysCustomer/updateSysCustomer`, postdata), msg)
    }
    // 获取购方信息  /settings/sysCustomer/getSysCustomerById

    get_getSysCustomerById(customerId, msg) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}settings/sysCustomer/getSysCustomerById?customerId=${customerId}`), msg)
    }
    // POST /settings/sysGoodsInfo/modGoodsInfoStatus 启用|禁用

    post_modGoodsInfoStatus(getdata, msg) {
        const _url = `${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsInfo' : 'settings/sysGoodsInfo'}/modGoodsInfoStatus`
        let dataStr = '' // 数据拼接字符串
        Object.keys(getdata).forEach((key) => {
            dataStr += `${key}=${getdata[key]}&`
        })
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
        const url = `${_url}?${dataStr}`
        return this.request(() => this.$http.post(url), msg)
    }
    // 根据导入批次号分页查询错误信息 /dl/dlTaskService/getPageDlBatchInfoList

    // post_getPageDlBatchInfoList(postdata, msg) {
    //     return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/dl/supDlTaskService' : 'dl/dlTaskService'}/getPageDlBatchInfoList`, postdata), msg)
    // }

    // GET /dl/dlTaskService/downBatchInfoDetail 获取导出信息详细数据
    get_downBatchInfoDetail(batchNo, msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scDlTaskService' : host.etcloud + 'dl/dlTaskService'}/downBatchInfoDetail?batchNo=${batchNo}`), msg)
    }
    // dl/dlTaskService/getPageDlBatchInfoList 根据导入批次号分页查询错误信息
    // post_getPageDlBatchInfoList(postdata, msg) {
    //     return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/dl/supDlTaskService' : 'dl/dlTaskService'}/getPageDlBatchInfoList`, postdata), msg)
    // }
    // 查询密码策略  /settings/sysPasswordPolicy/getSysPasswordPolicy
    get_getSysPasswordPolicy(msg) {
        return this.request(() => this.$http.get(`${host.etcloud}/settings/sysPasswordPolicy/getSysPasswordPolicy`), msg)
    }
    // settings/sysGoodsInfo/qryGoodsInfoTax 查询商品税率
    get_qryGoodsInfoTax(getdata, msg) {
        const _url = `${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsInfo' : 'settings/sysGoodsInfo'}/qryGoodsInfoTax`
        let dataStr = '' // 数据拼接字符串
        Object.keys(getdata).forEach((key) => {
            dataStr += `${key}=${getdata[key]}&`
        })
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
        const url = `${_url}?${dataStr}`
        return this.request(() => this.$http.get(url), msg)
    }

    // GET /settings/sysGoodsInfo/queryGoodsTax 查询商品税率 发票
    get_queryGoodsTax(getdata, msg) {
        const _url = `${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierGoodsInfo' : 'settings/sysGoodsInfo'}/queryGoodsTax`
        let dataStr = '' // 数据拼接字符串
        Object.keys(getdata).forEach((key) => {
            dataStr += `${key}=${getdata[key]}&`
        })
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
        const url = `${_url}?${dataStr}`
        return this.request(() => this.$http.get(url), msg)
    }

    // POST ems/sysTaxDisk/enableTaxDisk 启用|禁用 金税盘

    post_enableTaxDisk(getdata, msg) {
        const _url = `${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierTaxDisk' : 'ems/sysTaxDisk'}/enableTaxDisk`
        let dataStr = '' // 数据拼接字符串
        Object.keys(getdata).forEach((key) => {
            dataStr += `${key}=${getdata[key]}&`
        })
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
        const url = `${_url}?${dataStr}`
        return this.request(() => this.$http.post(url), msg)
    }

    // 测试销项接口
    // POST /ovatInvoiceWait/getOvatInvoiceWaitList 查询待开发票列表
    post_getOvatInvoiceWaitList(postdata, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/getOvatInvoiceWaitList`, postdata), msg)
    }
    post_immediateElectronOpenInv(postdata) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/immediateElectronOpenInv`, postdata))
    }

    // /ovatInvoiceWait/scratchOvatInvoiceWait  暂存操作

    post_scratchOvatInvoiceWait(postdata) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/scratchOvatInvoiceWait`, postdata))
    }
    // POST /ovatInvoiceWait/submitOvatInvoiceWait 待开发票提交
    post_submitOvatInvoiceWait(postdata, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/submitOvatInvoiceWait`, postdata), msg)
    }

    // 待开发票编码
    get_getBeanId_dkfp(msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloudSupplier : host.etcloudOvat}common/common/getBeanId?type=DKFP`), msg)
    }
    // 生成批次号
    get_getBeanId(msg) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}common/common/getBeanId?type=collect`), msg)
    }
    // POST /ovatInvoiceWait/delOvatInvoiceWait 删除待开发票
    post_delOvatInvoiceWait(getdata, msg) {
        const _url = `${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/delOvatInvoiceWait`
        let dataStr = '' // 数据拼接字符串
        Object.keys(getdata).forEach((key) => {
            dataStr += `${key}=${getdata[key]}&`
        })
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
        const url = `${_url}?${dataStr}`
        return this.request(() => this.$http.post(url), msg)
    }

    // /ovatInvoiceWait/queryOvatInvoiceWait 查询待开发票详情
    get_queryOvatInvoiceWait(getdata, msg) {
        const _url = `${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/queryOvatInvoiceWait`
        let dataStr = '' // 数据拼接字符串
        Object.keys(getdata).forEach((key) => {
            dataStr += `${key}=${getdata[key]}&`
        })
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
        const url = `${_url}?${dataStr}`
        return this.request(() => this.$http.get(url), msg)
    }
    //POST /ovatInvoiceWait/getPageInvoiceWaitDetail 清单发票分页查询详情列表
    post_getPageInvoiceWaitDetail(postData, msg) {
        const url = `${host.etcloudOvat + 'ovatInvoiceWait'}/getPageInvoiceWaitDetail`
        return this.request(() => this.$http.post(url, postData), msg)
    }
    // /ovatInvoiceWait/qryOvatInvoiceCopyList 复制蓝票查询
    post_qryOvatInvoiceCopyList(postData, msg) {
        const url = `${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/qryOvatInvoiceCopyList`
        return this.request(() => this.$http.post(url, postData), msg)
    }
    // GET /ovatInvoiceWait/queryOvatInvoiceWaitByIssue
    get_queryOvatInvoiceWaitByIssue(getdata, msg) {
        const _url = `${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/queryOvatInvoiceWaitByIssue`
        let dataStr = '' // 数据拼接字符串
        Object.keys(getdata).forEach((key) => {
            dataStr += `${key}=${getdata[key]}&`
        })
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
        const url = `${_url}?${dataStr}`
        return this.request(() => this.$http.get(url), msg)
    }
    // GET /ovatInvoiceWait/queryOvatInvoiceWaitVehicleByIssue  查询机动车待开发票详情，用作开票请求报文
    get_queryOvatInvoiceWaitVehicleByIssue(getdata, msg) {
        const _url = `${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/queryOvatInvoiceWaitVehicleByIssue`
        let dataStr = '' // 数据拼接字符串
        Object.keys(getdata).forEach((key) => {
            dataStr += `${key}=${getdata[key]}&`
        })
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
        const url = `${_url}?${dataStr}`
        return this.request(() => this.$http.get(url), msg)
    }
    // /ovatBillRule/qryBillRuleInfo  获取拆合规则
    get_qryBillRuleInfo(msg) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}ovatBillRule/qryBillRuleInfo`), msg)
    }

    // POST /ovatInvoiceWait/lockOvatInvoiceWait 更新待开发票状态
    post_lockOvatInvoiceWait(postdata, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/lockOvatInvoiceWait`, postdata), msg)
    }

    // ovatInvoiceWait/writeBackToInv 发票回调回写信息
    post_writeBackToInv(postdata, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/writeBackToInv`, postdata), msg)
    }
    //电子票发票回调回写信息
    post_writeBackToElectronInv(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceWait/writeBackToElectronInv`, postdata), msg)
    }
    // ovatInvoiceWait/writeBackToVehicleInv 机动车发票回调回写信息
    post_writeBackToVehicleInv(postdata, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/writeBackToVehicleInv`, postdata), msg)
    }
    // POST /ovatInvoiceWait/writeBackToElectronInv 电子发票回调回写信息
    post_writeBackToElectronInv(postdata, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/writeBackToElectronInv`, postdata), msg)
    }

    // 查询当前机构可分配的开票点  /ems/sysUkey/getAssignUkeyList
    post_getAssignUkeyList(msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierUkey/getAssignUkeyList' : 'ems/sysUkey/getAssignUkeyList'}`), msg)
    }
    //* 销售单分页查询  /ovatBill/pageBill
    post_pageBill(postdata, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBill' : host.etcloudOvat + 'ovatBill'}/pageBill`, postdata), msg)
    }

    // POST /ovatInvoiceWait/batchSubmitOvatInvoiceWait 批量提交待开发票

    post_batchSubmitOvatInvoiceWait(postdata, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/batchSubmitOvatInvoiceWait`, postdata), msg)
    }

    // POST /ovatInvoiceWait/getCanRedAmt 获取待开发票可红冲金额
    post_getCanRedAmt(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/getCanRedAmt`, postData), msg)
    }

    // POST /ovatInvoiceWait/batchElectronOpenInv 批量电子票开具
    post_batchElectronOpenInv(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/batchElectronOpenInv`, postData), msg)
    }
    // POST /ovatInvoiceWait/electronOpenInv 电子发票开具
    post_electronOpenInv(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/electronOpenInv`, postData), msg)
    }
    // get /ovatBill/mergeBill 合并销售单
    get_mergeBill(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBill' : host.etcloudOvat + 'ovatBill'}/mergeBill`, postData), msg)
    }
    // get    /ovatBill/abolishBill  作废销售单

    get_abolishBill(billId, msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBill' : host.etcloudOvat + 'ovatBill'}/abolishBill?billId=${billId}`), msg)
    }

    // /ovatBill/cancelAbolishBill   取消作废销售单
    get_cancelAbolishBill(billId, msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBill' : host.etcloudOvat + 'ovatBill'}/cancelAbolishBill?billId=${billId}`), msg)
    }
    // /ovatBill/reductionBill   还原销售单
    get_reductionBill(billId, msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBill' : host.etcloudOvat + 'ovatBill'}/reductionBill?billId=${billId}`), msg)
    }

    // get /ovatBill/billCommit  销售单提交
    get_billCommit(billId, billRuleCode, msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBill' : host.etcloudOvat + 'ovatBill'}/billCommit?billId=${billId}&billRuleCode=${billRuleCode}`), msg)
    }
    // get /ovatBill/billBatchCommit  销售单批量提交
    get_billBatchCommit(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBill' : host.etcloudOvat + 'ovatBill'}/billBatchCommit`, postData), msg)
    }

    // POST /openedInvoice/getOpenedInvoiceList 获取已开发票列表
    post_getOpenedInvoiceList(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOpenedInvoice' : host.etcloudOvat + 'openedInvoice'}/getOpenedInvoiceList`, postData), msg)
    }
    // POST /openedInvoice/getInvoiceStatics 获取已开合计
    post_getInvoiceStatics(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat + 'openedInvoice'}/getInvoiceStatics`, postData))
    }
    // POST /openedInvoice/getOvatInvoice 获取已开发票详细信息
    post_getOvatInvoice(postData, msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOpenedInvoice' : host.etcloudOvat + 'openedInvoice'}/getOvatInvoice?invoiceId=${postData}`), msg)
    }
    //POST /openedInvoice/batchReddingInvoice 批量红冲发票
    post_batchReddingInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOpenedInvoice' : host.etcloudOvat + 'openedInvoice'}/batchReddingInvoice`, postData), msg)
    }
    // POST /openedInvoice/reddingFailedBackWrite 红冲失败回写
    post_reddingFailedBackWrite(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOpenedInvoice' : host.etcloudOvat + 'openedInvoice'}/reddingFailedBackWrite?`, postData), msg)
    }
    // POST /openedInvoice/batchSendInvoice 批量/单个邮箱发送信息
    post_batchSendInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOpenedInvoice' : host.etcloudOvat + 'openedInvoice'}/batchSendInvoice`, postData), msg)
    }
    //POST /openedInvoice/getPageInvoiceDetail 已开清单发票查询商品清单
    post_getPageInvoiceDetail(postData, msg) {
        const url = `${host.etcloudOvat + 'openedInvoice'}/getPageInvoiceDetail`
        return this.request(() => this.$http.post(url, postData), msg)
    }
    //POST /openedInvoice/getOvatInvoiceForPrint 打印助手获取发票信息
    post_getOvatInvoiceForPrint(postData, msg) {
        const url = `${host.etcloudOvat + 'openedInvoice'}/getOvatInvoiceForPrint`
        return this.request(() => this.$http.post(url, postData), msg)
    }
    // get /ovatBillRule/qryAllRule   查询所有拆合规则

    get_qryAllRule(msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBillRule' : host.etcloudOvat + 'ovatBillRule'}/qryAllRule`), msg)
    }
    // post /ovatBillRule//ovatBillRule/add  新增规则
    post_addOvatBillRule(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBillRule' : host.etcloudOvat + 'ovatBillRule'}/add`, postData), msg)
    }
    // post /ovatBillRule/editorRule 编辑规则
    post_editorRule(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBillRule' : host.etcloudOvat + 'ovatBillRule'}/editorRule`, postData), msg)
    }
    // get  /ovatBillRule/qryRuleInfo  查询规则信息
    get_qryRuleInfo(ruleCode, msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBillRule' : host.etcloudOvat + 'ovatBillRule'}/qryRuleInfo?ruleCode=${ruleCode}`), msg)
    }
    // post /ovatBillRule/setupRule   设置规则
    post_setupRule(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBillRule' : host.etcloudOvat + 'ovatBillRule'}/setupRule`, postData), msg)
    }
    // get /ovatBillRule/delRule  删除规则
    get_delRule(ruleSchemaId, msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBillRule' : host.etcloudOvat + 'ovatBillRule'}/delRule?ruleSchemaId=${ruleSchemaId}`), msg)
    }
    // get /ovatBillRule/isEnableRule  启用禁用规则
    get_isEnableRule(ruleSchemaId, validStatus, msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBillRule' : host.etcloudOvat + 'ovatBillRule'}/isEnableRule?ruleSchemaId=${ruleSchemaId}&validStatus=${validStatus}`), msg)
    }

    // POST /ovatRedInfo/getPageRedInfoList   分页红字信息表信息
    post_getPageRedInfoList(postDate, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatRedInfo' : host.etcloudOvat + 'ovatRedInfo'}/getPageRedInfoList`, postDate), msg)
    }
    post_addRedInfo(postDate, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatRedInfo' : host.etcloudOvat + 'ovatRedInfo'}/addRedInfo`, postDate), msg)
    }
    // 删除红字信息表 http://192.168.51.38:8540/ovatRedInfo/delRedInfo
    post_delRedInfo(getdata, msg) {
        const _url = `${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatRedInfo' : host.etcloudOvat + 'ovatRedInfo'}/delRedInfo`
        let dataStr = '' // 数据拼接字符串
        Object.keys(getdata).forEach((key) => {
            dataStr += `${key}=${getdata[key]}&`
        })
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
        const url = `${_url}?${dataStr}`

        return this.request(() => this.$http.post(url), msg)
    }

    // POST /ovatRedInfo/submitWorkflow 批量提交审核
    post_submitWorkflow(getdata, msg) {
        const _url = `${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatRedInfo' : host.etcloudOvat + 'ovatRedInfo'}/submitWorkflow`
        let dataStr = '' // 数据拼接字符串
        Object.keys(getdata).forEach((key) => {
            dataStr += `${key}=${getdata[key]}&`
        })
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
        const url = `${_url}?${dataStr}`
        return this.request(() => this.$http.post(url), msg)
    }

    // POST /ovatRedInfo/saveInvoiceWaitRet 批量提交红字信息表到待开
    post_saveInvoiceWaitRet(getdata, msg) {
        const _url = `${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatRedInfo' : host.etcloudOvat + 'ovatRedInfo'}/saveInvoiceWaitRet`
        let dataStr = '' // 数据拼接字符串
        Object.keys(getdata).forEach((key) => {
            dataStr += `${key}=${getdata[key]}&`
        })
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
        const url = `${_url}?${dataStr}`
        return this.request(() => this.$http.post(url), msg)
    }

    // GET /ovatRedInfo/getOvatRedInfoById 根据id获取红字信息表信息
    get_getOvatRedInfoById(getdata, msg) {
        const _url = `${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatRedInfo' : host.etcloudOvat + 'ovatRedInfo'}/getOvatRedInfoById`
        let dataStr = '' // 数据拼接字符串
        Object.keys(getdata).forEach((key) => {
            dataStr += `${key}=${getdata[key]}&`
        })
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
        const url = `${_url}?${dataStr}`
        return this.request(() => this.$http.get(url), msg)
    }

    // POST /ovatRedInfo/getRedInfoListByIds 根据id批量获取红字信息表信息
    post_getRedInfoListByIds(getdata, msg) {
        const _url = `${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatRedInfo' : host.etcloudOvat + 'ovatRedInfo'}/getRedInfoListByIds`
        let dataStr = '' // 数据拼接字符串
        Object.keys(getdata).forEach((key) => {
            dataStr += `${key}=${getdata[key]}&`
        })
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
        const url = `${_url}?${dataStr}`
        return this.request(() => this.$http.post(url), msg)
    }

    // POST /ovatRedInfo/updateRedInfo 根据id修改红字信息表
    post_updateRedInfo(postDate, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatRedInfo' : host.etcloudOvat + 'ovatRedInfo'}/updateRedInfo`, postDate), msg)
    }

    // POST /ovatRedInfo/updateRedInfo 根据id修改红字信息表
    post_reductionOvatRedInfo(postDate, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatRedInfo' : host.etcloudOvat + 'ovatRedInfo'}/reductionOvatRedInfo`, postDate), msg)
    }

    // /ovatRedInfo/updateRedInfoForDownloads 批量更新或插入新红字信息表（批量上传、下载后调用）
    post_updateRedInfoForDownloads(postDate, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatRedInfo' : host.etcloudOvat + 'ovatRedInfo'}/updateRedInfoForDownloads`, postDate), msg)
    }

    // POST /ovatRedInfo/getRedInfoForUploadParam 获取调用上传接口的参数
    post_getRedInfoForUploadParam(getdata, msg) {
        const _url = `${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatRedInfo' : host.etcloudOvat + 'ovatRedInfo'}/getRedInfoForUploadParam`
        let dataStr = '' // 数据拼接字符串
        Object.keys(getdata).forEach((key) => {
            dataStr += `${key}=${getdata[key]}&`
        })
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
        const url = `${_url}?${dataStr}`
        return this.request(() => this.$http.post(url), msg)
    }

    // POST /ovatSource/getPageSourceList 分页查询异常单据信息
    post_getPageSourceList(postDate, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatSource' : host.etcloudOvat + 'ovatSource'}/getPageSourceList`, postDate), msg)
    }
    // POST /ovatRedInfo/getRedInfoByBlueInvoice 根据蓝票号码和代码生成红字信息表
    post_getRedInfoByBlueInvoice(postDate, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatRedInfo' : host.etcloudOvat + 'ovatRedInfo'}/getRedInfoByBlueInvoice`, postDate), msg)
    }

    // GET /ovatSource/getOvatSourceById 根据id获取异常单据信息

    get_getOvatSourceById(billId, msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatSource' : host.etcloudOvat + 'ovatSource'}/getOvatSourceById?billId=${billId}`), msg)
    }
    // /ovatBill/delBill  删除销售单
    get_delBill(billId, msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBill' : host.etcloudOvat + 'ovatBill'}/delBill?billId=${billId}`), msg)
    }
    // get /ovatBill/qryBillInfo  *明细查询：销售单表头
    get_qryBillInfo(billId, msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBill' : host.etcloudOvat + 'ovatBill'}/qryBillInfo?billId=${billId}`), msg)
    }

    // POST /ovatInvoiceWait/base64DeCode 接受接口返回信息,进行base64解码
    post_base64DeCode(postDate, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/base64DeCode`, postDate), msg)
    }
    // post /ovatBill/modBill   编辑销售单提交
    post_modBill(postData) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBill' : host.etcloudOvat + 'ovatBill'}/modBill`, postData))
    }
    // post /ovatBill/qryBillDetailList *明细查询：销售单明细(包括被合并)

    post_qryBillDetailList(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBill' : host.etcloudOvat + 'ovatBill'}/qryBillDetailList`, postData), msg)
    }
    // post /ovatBill/qryBillInvoice  *明细查询：发票部分
    post_qryBillInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBill' : host.etcloudOvat + 'ovatBill'}/qryBillInvoice`, postData), msg)
    }

    // POST /ovatInvoiceWait/getAllOvatInvoiceList 查询发票列表
    post_getAllOvatInvoiceList(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/getAllOvatInvoiceList`, postData), msg)
    }

    // POST /openedInvoice/getNormalBlueInvoice 查询机构下已开的正常蓝字发票
    post_getNormalBlueInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOpenedInvoice' : host.etcloudOvat + 'openedInvoice'}/getNormalBlueInvoice`, postData), msg)
    }

    // post /dlTaskService/getPageDlBatchInfoList  销售单导入根据批次后分页查询错误信息
    post_getPageDlBatchInfoList(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scDlTaskService' : host.etcloudOvat + 'dlTaskService'}/getPageDlBatchInfoList`, postData), msg)
    }
    // POST /ovatInvoiceWait/reductionOvatInvoiceWait 回退待开发票状态
    post_reductionOvatInvoiceWait(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/reductionOvatInvoiceWait`, postData), msg)
    }

    // POST /ovatRedInfo/updateRedInfoStatus 根据红字信息表流水号更新上传状态、红字信息表编号
    post_updateRedInfoStatus(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatRedInfo' : host.etcloudOvat + 'ovatRedInfo'}/updateRedInfoStatus`, postData), msg)
    }
    // get /ovatBill/autoSpiltBill   自动拆分销售单提交
    get_autoSpiltBill(billId, billRuleCode, msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBill' : host.etcloudOvat + 'ovatBill'}/autoSpiltBill?billId=${billId}&billRuleCode=${billRuleCode}`), msg)
    }
    // POST /openedInvoice/getOpenedInvoiceList 获取已开发票列表
    // post_getOpenedInvoiceList(postdata, msg) {
    //     return this.request(() => this.$http.post(`${host.etcloudOvat}openedInvoice/getOpenedInvoiceList`, postdata), msg)
    // }
    // POST /ovatRedInfo/getCurrentDate 获取后台当前日期yyyy-MM-dd
    post_getCurrentDate(postdata, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatRedInfo' : host.etcloudOvat + 'ovatRedInfo'}/getCurrentDate`, postdata), msg)
    }
    // POST /ovatRedInfo/updateRedInfoStatus 根据红字信息表流水号更新上传状态、红字信息表编号
    post_updateRedInfoStatus(postdata, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatRedInfo' : host.etcloudOvat + 'ovatRedInfo'}/updateRedInfoStatus`, postdata), msg)
    }

    // POST /openedInvoice/getInvalidReopenInvoiceList 获取作废与重开发票列表
    post_getInvalidReopenInvoiceList(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scCancelAndReopenInvoice' : host.etcloudOvat + 'cancelAndReopenInvoice'}/getInvalidReopenInvoiceList`, postData), msg)
    }
    // get  /ovatBillRule/qryAllValidRule 查询所有有效规则
    get_qryAllValidRule(msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBillRule/qryAllRule' : host.etcloudOvat + 'ovatBillRule/qryAllValidRule'}`), msg)
    }

    // POST /openedInvoice/applyReopenInvoice 重开申请
    post_applyReopenInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scCancelAndReopenInvoice' : host.etcloudOvat + 'cancelAndReopenInvoice'}/applyReopenInvoice`, postData), msg)
    }

    // POST /openedInvoice/applyReopenInvoice 重开提交
    post_submitReopenOvatInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scCancelAndReopenInvoice' : host.etcloudOvat + 'cancelAndReopenInvoice'}/submitReopenOvatInvoice`, postData), msg)
    }

    // 发票重开
    post_reopenInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scCancelAndReopenInvoice' : host.etcloudOvat + 'cancelAndReopenInvoice'}/reopenInvoice`, postData), msg)
    }

    // 回退
    post_backReopenInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scCancelAndReopenInvoice' : host.etcloudOvat + 'cancelAndReopenInvoice'}/backReopenInvoice`, postData), msg)
    }

    // 回写
    post_writeBackReopenInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scCancelAndReopenInvoice' : host.etcloudOvat + 'cancelAndReopenInvoice'}/writeBackReopenInvoice`, postData), msg)
    }

    // 空白作废申请
    post_applyBlankCancelInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scCancelAndReopenInvoice' : host.etcloudOvat + 'cancelAndReopenInvoice'}/applyBlankCancelInvoice`, postData), msg)
    }

    // 增加空白作废
    post_blankCancelInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scCancelAndReopenInvoice' : host.etcloudOvat + 'cancelAndReopenInvoice'}/blankCancelInvoice`, postData), msg)
    }
    post_getReInvoiceStatics(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat + 'cancelAndReopenInvoice'}/getReInvoiceStatics`, postData))
    }
    // /ovatRedInfo/updateRedInfoStatusAndSaveInvoiceWait 根据红字信息表id更新上传状态、红字信息表编号并提交待开（手动增加编号调用）
    post_updateCodeSaveInvoiceWait(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatRedInfo' : host.etcloudOvat + 'ovatRedInfo'}/updateRedInfoStatusAndSaveInvoiceWait`, postData), msg)
    }
    // 已开发票 - 打印发票回写
    post_printBackToInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOpenedInvoice' : host.etcloudOvat + 'openedInvoice'}/printBackToInvoice`, postData), msg)
    }
    // 已开发票 - 作废申请
    post_applyCancelOvatInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOpenedInvoice' : host.etcloudOvat + 'openedInvoice'}/applyCancelOvatInvoice`, postData), msg)
    }
    // 已开发票 - 作废回写
    post_cancelOvatInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOpenedInvoice' : host.etcloudOvat + 'openedInvoice'}/cancelOvatInvoice`, postData), msg)
    }

    // 已开发票 - 作废申请回退
    post_backCancelInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOpenedInvoice' : host.etcloudOvat + 'openedInvoice'}/backCancelInvoice`, postData), msg)
    }
    // 已开发票 - 电子发票下载
    post_downloadBackToInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOpenedInvoice' : host.etcloudOvat + 'openedInvoice'}/downloadBackToInvoice`, postData), msg)
    }
    // 拆分销售单提交
    // post /ovatBill/spiltBill
    post_spiltBill(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBill' : host.etcloudOvat + 'ovatBill'}/spiltBill`, postData), msg)
    }
    // 已开发票 - 发票作废校验
    post_submitCancelOvatInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOpenedInvoice' : host.etcloudOvat + 'openedInvoice'}/submitCancelOvatInvoice`, postData), msg)
    }

    // 已开发票 - 数据同步
    post_synInvoiceData(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOpenedInvoice' : host.etcloudOvat + 'openedInvoice'}/synInvoiceData`, postData), msg)
    }

    // get /ems/sysTaxDisk/getSysTaxDiskByUkey  根据开票点获取金税盘信息
    get_getSysTaxDiskByUkey(ukeyId, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierTaxDisk' : 'ems/sysTaxDisk'}/getSysTaxDiskByUkey?ukeyId=${ukeyId}`), msg)
    }

    // get /ovatBill/isShowManualSpilt  *是否显示手动拆分按钮
    get_isShowManualSpilt(billId, msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatBill' : host.etcloudOvat + 'ovatBill'}/isShowManualSpilt?billId=${billId}`), msg)
    }
    // POST /ovatInvoiceWait/getOvatInvoiceWaitBillList 查询待开发票关联的销售单列表
    post_getOvatInvoiceWaitBillList(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/getOvatInvoiceWaitBillList`, postData), msg)
    }
    // 外部对接系统--start
    // 查询外部对接系统设置详细信息
    post_outSystemInfo(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysBusinessSystem/qrySysBusinessSystem`, postData), msg)
    }
    // 查询所有外部对接系统设置
    post_outSystemList(msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysBusinessSystem/getSysBusinessSystemList`), msg)
    }
    // 分页查询所有外部对接系统设置
    post_querySysBusinessSystemList(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysBusinessSystem/querySysBusinessSystemList`, postData))
    }
    // settings/sysBusinessSystem/delSysBusinessSystem 删除外部系统
    post_delSysBusinessSystem(id) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysBusinessSystem/delSysBusinessSystem`, id))
    }
    // 新增外部对接系统设置
    post_outSystemAdd(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysBusinessSystem/addSysBusinessSystem`, postData), msg)
    }
    // 更新外部对接系统设置
    post_outSystemUpdate(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysBusinessSystem/updateSysBusinessSystem`, postData), msg)
    }
    // 外部对接系统--end

    // 消息中心--start
    // 获取用户的消息
    post_getNoticeByUser(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysNotice/getNoticeByUser`, postData), msg)
    }
    // 修改消息为已读
    get_updateReadForNotice(postData, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}settings/sysNotice/updateReadForNotice?noticeId=${postData}`), msg)
    }
    // POST /settings/sysNotice/updateUserNoticeRead 修改用户的所有消息为已读
    post_updateUserNoticeRead(msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysNotice/updateUserNoticeRead`), msg)
    }
    // 消息中心--end

    // 我的工作台--start
    // 待办任务列表
    post_getHisTaskDTOList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudWorkflow}ovat/workFlow/getHisTaskDTOList`, postData), msg)
    }
    // 查询任务详情
    get_getTaskById(taskId, msg) {
        return this.request(() => this.$http.get(`${host.etcloudWorkflow}ovat/workFlow/getTaskById?taskId=${taskId}`), msg)
    }
    // 已办任务列表
    post_getRunTaskDTOList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudWorkflow}ovat/workFlow/getRunTaskDTOList`, postData), msg)
    }
    // 流程审批  通过，不通过
    post_submitTask(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudWorkflow}/ovat/workFlow/submitTask`, postData), msg)
    }
    // GET /ovat/workFlow/getTracksByKey 根据业务主键获取最新的流程轨
    // get_getTracksByKey(data, msg) {
    //     return this.request(() => this.$http.get(`${host.etcloudWorkflow}/ovat/workFlow/getTracksByKey?bussinessKey=${data}`), msg)
    // }
    // GET /ovat/workFlow/getTracks 根据申请编号获取流程轨迹
    get_getTracks(data, msg) {
        return this.request(() => this.$http.get(`${host.etcloudWorkflow}/ovat/workFlow/getTracks?applyCode=${data}`), msg)
    }
    // 我的工作台--end

    // GET /settings/sysCustomer/qryCustomerCodeAndOrg 根据社会信用代码查询客户信息
    get_qryCustomerCodeAndOrg(code, orgId, msg) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}settings/sysCustomer/qryCustomerCodeAndOrg?customerCode=${code}&orgId=${orgId}`), msg)
    }
    // ovatInvoiceWait/getLimitNumber
    get_getLimitNumber(invType, msg) {
        return this.request(() => this.$http.get(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/getLimitNumber?invType=${invType}`), msg)
    }
    // GET /ovat/approveConfig/qryApproveConfigList 审批流设置列表
    get_qryApproveConfigList(msg) {
        return this.request(() => this.$http.get(`${host.etcloudWorkflow}ovat/approveConfig/qryApproveConfigList`), msg)
    }
    // GET /ovat/approveConfig/setApproveValidStatus 启用|禁用
    get_setApproveValidStatus(getdata, msg) {
        const _url = `${host.etcloudWorkflow}ovat/approveConfig/setApproveValidStatus`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }

    // GET /ovat/approveConfig/qryApproveBranchList 查询某一审核类型分支列表
    get_qryApproveBranchList(getdata, msg) {
        const _url = `${host.etcloudWorkflow}ovat/approveConfig/qryApproveBranchList`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }
    // GET /ovat/approveConfig/delApproveBranch 删除审核分支
    get_delApproveBranch(getdata, msg) {
        const _url = `${host.etcloudWorkflow}ovat/approveConfig/delApproveBranch`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }

    // POST /ovat/approveConfig/addApproveBranch 添加审核分支

    post_addApproveBranch(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudWorkflow}ovat/approveConfig/addApproveBranch`, postData), msg)
    }

    // POST /ovat/approveConfig/modApproveBranch 修改审核分支

    post_modApproveBranch(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudWorkflow}ovat/approveConfig/modApproveBranch`, postData), msg)
    }

    // GET /ovat/approveConfig/qryApproveBranch 查询审核分支

    get_qryApproveBranch(getdata, msg) {
        const _url = `${host.etcloudWorkflow}ovat/approveConfig/qryApproveBranch`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }

    // POST /settings/sysFileTemplet/getFileTempletList 获取系统导入模板配置
    post_getFileTempletList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysFileTemplet/getFileTempletList`, postData), msg)
    }

    // auth/sysRole/qryOrgRoleAndUser

    // 获取当前机构角色
    get_qryOrgRoleAndUser(msg) {
        return this.request(() => this.$http.get(`${host.etcloud}auth/sysRole/qryOrgRoleAndUser`), msg)
    }

    // GET /ovat/approveConfig/adjustPriority 审核分支优先级调整
    get_adjustPriority(getdata, msg) {
        const _url = `${host.etcloudWorkflow}ovat/approveConfig/adjustPriority`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }

    // POST /settings/sysFileTemplet/enableAndDisableSysFileTemplet 启用禁用系统导入模板

    post_enableAndDisableSysFileTemplet(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysFileTemplet/enableAndDisableSysFileTemplet`, postData), msg)
    }

    // POST /settings/sysFileTemplet/getSysFileFields 获取导入模板字段设置

    post_getSysFileFields(getdata, msg) {
        const _url = `${host.etcloud}settings/sysFileTemplet/getSysFileFields`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.post(url), msg)
    }

    // POST /settings/sysFileTemplet/getSysFileTypeFields 获取导入模板类型字段

    post_getSysFileTypeFields(getdata, msg) {
        const _url = `${host.etcloud}settings/sysFileTemplet/getSysFileTypeFields`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.post(url), msg)
    }

    // POST /settings/sysFileTemplet/addSysFileTypeFields 新增导入基础模板字段定义
    post_addSysFileTypeFields(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysFileTemplet/addSysFileTypeFields`, postData), msg)
    }

    // POST /settings/sysFileTemplet/updateSysFileFields 修改导入模板字段设置

    post_updateSysFileFields(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysFileTemplet/updateSysFileFields`, postData), msg)
    }

    // POST /settings/sysFileTemplet/saveSysFileFields 保存导入模板字段设置
    post_saveSysFileFields(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysFileTemplet/saveSysFileFields`, postData), msg)
    }

    // 获取审批流开启或关闭状态ApproveConfigController.qryFlowIsValid

    post_qryFlowIsValid(getdata, msg) {
        const _url = `${host.etcloudWorkflow}ovat/approveConfig/qryFlowIsValid`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }

    // POST /openedInvoice/qryOpenedOvatInvoiceList 统计报表中查询已开发票列表

    // POST /tax4/invoiceStatistics/qryOpenedOvatInvoiceList 统计报表分页查询已开发票列表
    post_qryOpenedOvatInvoiceList(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}tax4/invoiceStatistics/qryOpenedOvatInvoiceList`, postdata), msg)
    }

    // POST /ems/sysOrganization/getUserOrgChilds 获取当前用户机构下所有有权限的机构及其子机构

    post_getUserOrgChilds(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysOrganization/getUserOrgChilds`, postData), msg)
    }

    // GET /ems/sysOrganization/getUserOrgList 获取授权机构列表机构管理
    get_getUserOrgList(getdata, msg) {
        const _url = `${host.etcloud}ems/sysOrganization/getUserOrgList`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }

    // POST /ems/sysUkey/getUserOrgUkeyList 查询机构下用户有权限的开票点

    post_getUserOrgUkeyList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierUkey' : 'ems/sysUkey'}/getUserOrgUkeyList`, postData), msg)
    }

    // POST /ems/sysUkey/qryUkeyListOfOrgIds 查询机构下所有的开票点

    post_qryUkeyListOfOrgIds(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierUkey' : 'ems/sysUkey'}/qryUkeyListOfOrgIds`, postData), msg)
    }

    // GET /ems/sysSaleInfo/getOrgIdSaleInfo 根据该机构的税务证信息
    get_getOrgIdSaleInfo(getdata, msg) {
        const _url = `${host.etcloud}ems/sysSaleInfo/getOrgIdSaleInfo`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }

    // GET /ems/sysSaleInfo/getIsDrawbackEnterprises 获取当前企业是否是退税企业
    get_getIsDrawbackEnterprises() {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysSaleInfo/getIsDrawbackEnterprises`))
    }

    // POST /openedInvoice/qryOpenedOvatInvoiceDetailList 统计报表中查询已开发票的商品明细列表

    post_qryOpenedOvatInvoiceDetailList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}openedInvoice/qryOpenedOvatInvoiceDetailList`, postData), msg)
    }

    // POST /tax4/invoiceStatistics/qryOpenedInvoiceGoodsDetailList 统计报表分页查询已开发票的商品明细列表
    post_qryOpenedInvoiceGoodsDetailList(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}tax4/invoiceStatistics/qryOpenedInvoiceGoodsDetailList`, postdata), msg)
    }

    // GET /tax4/invoiceStatistics/exportGoodsDetailToXLS 商品明细报表导出excel
    get_exportGoodsDetailToXLS(getdata, msg) {
        const _url = `${host.etcloudBiApp}tax4/invoiceStatistics/exportGoodsDetailToXLS`
        const url = this.getParamUrl(getdata, _url)
        window.open(url)
    }

    // POST /statistics/biInvoiceStatus/qryBiInvoiceStatusList 统计报表中查询发票状态列表

    post_qryBiInvoiceStatusList(postData, msg) {
        console.log(`${host.etcloudBiApp}statistics/biInvoiceStatus/qryBiInvoiceStatusList`)
        return this.request(() => this.$http.post(`${host.etcloudBiApp}statistics/biInvoiceStatus/qryBiInvoiceStatusList`, postData), msg)
    }

    // POST /statistics/biInvoiceStatus/qryBiInvoiceStatusQryOrgList 机构为粒度钻取列表

    post_qryBiInvoiceStatusQryOrgList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}statistics/biInvoiceStatus/qryBiInvoiceStatusQryOrgList`, postData), msg)
    }

    // POST /statistics/biInvoiceStatus/qryBiInvoiceStatusQryUkeyList 开票点为粒度钻取列表

    post_qryBiInvoiceStatusQryUkeyList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}statistics/biInvoiceStatus/qryBiInvoiceStatusQryUkeyList`, postData), msg)
    }

    // GET /statistics/biStatistics/queryStatTime 查询数据更新时间
    get_queryStatTime(getdata, msg) {
        const _url = `${host.etcloudBiApp}statistics/biStatistics/queryStatTime`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }

    // POST /statistics/biInvoiceRate/qryBiInvoiceRateList 统计报表中查询发票税率列表

    post_qryBiInvoiceRateList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}statistics/biInvoiceRate/qryBiInvoiceRateList`, postData), msg)
    }

    // POST /statistics/biInvoiceRate/qryBiInvoiceRateQryOrgList 机构为粒度钻取列表

    post_qryBiInvoiceRateQryOrgList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}statistics/biInvoiceRate/qryBiInvoiceRateQryOrgList`, postData), msg)
    }

    // POST /statistics/biInvoiceRate/qryBiInvoiceRateQryUkeyList 开票点为粒度钻取列表

    post_qryBiInvoiceRateQryUkeyList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}statistics/biInvoiceRate/qryBiInvoiceRateQryUkeyList`, postData), msg)
    }

    // GET /tax4/invoiceStatistics/exportOpenedOvatInvoiceToXLS 已开发票报表导出excel
    get_exportOpenedOvatInvoiceToXLS(getdata, msg) {
        const _url = `${host.etcloudBiApp}tax4/invoiceStatistics/exportOpenedOvatInvoiceToXLS`
        const url = this.getParamUrl(getdata, _url)
        window.open(url)
    }

    // 导出商品明细

    get_exportOpenedOvatInvoiceDetailToXLS(getdata, msg) {
        const _url = `${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOpenedInvoice' : host.etcloudOvat + 'openedInvoice'}/exportOpenedOvatInvoiceDetailToXLS`
        const url = this.getParamUrl(getdata, _url)
        window.open(url)
    }

    // GET /statistics/biInvoiceStatus/exportInvoiceStatusToXLS 发票状态统计导出excel

    get_exportInvoiceStatusToXLS(getdata, msg) {
        const _url = `${host.etcloudBiApp}statistics/biInvoiceStatus/exportInvoiceStatusToXLS`
        const url = this.getParamUrl(getdata, _url)
        window.open(url)
    }
    get_exportInvoiceStatusUkeyToXLS(getdata, msg) {
        const _url = `${host.etcloudBiApp}statistics/biInvoiceStatus/exportInvoiceStatusUkeyToXLS`
        const url = this.getParamUrl(getdata, _url)
        window.open(url)
    }

    // GET /statistics/biInvoiceRate/exportInvoiceRateToXLS 发票税率统计导出excel

    get_exportInvoiceRateToXLS(getdata, msg) {
        const _url = `${host.etcloudBiApp}statistics/biInvoiceRate/exportInvoiceRateToXLS`
        const url = this.getParamUrl(getdata, _url)
        window.open(url)
    }
    get_exportInvoiceTaxUkeyToXLS(getdata, msg) {
        const _url = `${host.etcloudBiApp}statistics/biInvoiceRate/exportInvoiceStatusUkeyToXLS`
        const url = this.getParamUrl(getdata, _url)
        window.open(url)
    }

    // POST /ovatInvoiceWait/checkReductionOvatInvoiceWait 检查回退待开发票状态

    post_checkReductionOvatInvoiceWait(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/checkReductionOvatInvoiceWait`, postData), msg)
    }

    // GET /ovat/approveConfig/qryApproveCondition 查询某一个审核类型条件

    get_qryApproveCondition(getdata, msg) {
        const _url = `${host.etcloudWorkflow}ovat/approveConfig/qryApproveCondition`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }

    // POST /ovatInvoiceWait/checkOvatInvoiceList 检查待开发票

    post_checkOvatInvoiceList(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/checkOvatInvoiceList`, postData), msg)
    }

    // GET /ovat/workFlow/getTracksByKey 根据业务主键获取最新的流程轨迹

    get_getTracksByKey(getdata, msg) {
        const _url = `${host.etcloudWorkflow}ovat/workFlow/getTracksByKey`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }

    // POST /ems/sysSaleInfo/getSaleInfoListByOrgIds 查询机构列表下的销方信息

    post_getSaleInfoListByOrgIds(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysSaleInfo/getSaleInfoListByOrgIds`, postData), msg)
    }

    // POST /ovatInvoiceWait/writeOvatInvoiceFailReason 回写待开发票失败原因

    post_writeOvatInvoiceFailReason(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/writeOvatInvoiceFailReason`, postData), msg)
    }

    // POST /settings/sysNotice/getNoticeCount 获取用户的消息类型汇总数

    post_getNoticeCount(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysNotice/getNoticeCount`, postData), msg)
    }

    // GET /ovat/workFlow/getRunTaskCount 待办任务分类统计

    get_getRunTaskCount(getData, msg) {
        return this.request(() => this.$http.get(`${host.etcloudWorkflow}ovat/workFlow/getRunTaskCount`, getData), msg)
    }

    // GET /alarm/alarmSetting/qryAlarmList 查看预警列表
    get_qryAlarmList(getdata, msg) {
        const _url = `${host.etcloudBiApp}alarm/alarmSetting/qryAlarmList`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }
    // GET /alarm/alarmSetting/modStatus 启用|禁用
    get_modStatus(getdata, msg) {
        const _url = `${host.etcloudBiApp}alarm/alarmSetting/modStatus`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }

    // GET /alarm/alarmSetting/qryOrgAlarm 查询机构预警详情

    get_qryOrgAlarm(getdata, msg) {
        const _url = `${host.etcloudBiApp}alarm/alarmSetting/qryOrgAlarm`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }

    // GET /alarm/alarmSetting/qryOrgAlarmCondition 查询机构预警条件：监控指标下拉框以及规则字段

    get_qryOrgAlarmCondition(getdata, msg) {
        const _url = `${host.etcloudBiApp}alarm/alarmSetting/qryOrgAlarmCondition`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }

    // POST /alarm/alarmSetting/settingAlarm 设置机构预警

    post_settingAlarm(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}alarm/alarmSetting/settingAlarm`, postData), msg)
    }

    // GET /auth/confirmCheck/qryOrgTaxPeriod *确认勾选页面查询当前机构税款所属期
    get_qryOrgTaxPeriod(orgId, msg) {
        return this.request1(() => this.$http.get(`${host.etcloudIvatApp}auth/confirmCheck/qryOrgTaxPeriod?orgId=${orgId}`), msg)
    }

    // POST /auth/confirmCheck/pageConfirmCheck *确认勾选-分页查询
    post_pageConfirmCheck(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/confirmCheck/pageConfirmCheck`, postData), msg)
    }

    // GET /auth/confirmCheck/confirmCheckFirst *确认勾选-第一步：确认;错误msgCode为20000时，需要进行弹窗进行选择；其他错误进行弹出提示
    get_confirmCheckFirst(getData, msg) {
        return this.request(() => {
            const _url = `${host.etcloudIvatApp}auth/confirmCheck/confirmCheckFirst`
            const url = this.getParamUrl(getData, _url)
            return this.$http.get(url)
        })
    }

    // POST auth/confirmCheck/confirmCheckSecond *确认勾选-第二步：提交
    post_confirmCheckSecond(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/confirmCheck/confirmCheckSecond`, postData), msg)
    }
    // GET /auth/confirmCheck/qryHisPeriodBatchParam *查询当前机构所属期以及对应最大批次数
    get_qryHisPeriodBatchParam(msg) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}auth/confirmCheck/qryHisPeriodBatchParam?checkType=${msg}`))
    }

    // GET /auth/confirmCheck/qryHisStatisticDTO *查询历史确认明细
    get_qryHisStatisticDTO(getData, msg) {
        return this.request(() => {
            const _url = `${host.etcloudIvatApp}auth/confirmCheck/qryHisStatisticDTO`
            const url = this.getParamUrl(getData, _url)
            return this.$http.get(url)
        })
    }

    // GET /auth/confirmCheck/exportToExcel *导出确认勾选发票
    get_historyExportToExcel(getData) {
        const _url = `${host.etcloudIvatApp}auth/confirmCheck/exportToExcel`
        const url = this.getParamUrl(getData, _url)
        window.open(url)
    }
    // POST manage/ivatBill/exportToExcel *导出确认勾选发票
    post_billExportToExcel(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatBill/exportToExcel`, postData), msg)
    }

    // POST /auth/confirmCheckLocal/qryIvatConfig *确认勾选单机版查询进项接口程序配置
    post_qryIvatConfig(msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/confirmCheckLocal/qryIvatConfig`), msg)
    }

    // POST /auth/confirmCheckLocal/confirmCheckFirstLocal 单机版确认勾选-第一步：确认;错误msgCode为20000时，需要进行弹窗进行选择；其他错误进行弹出提示
    post_confirmCheckFirstLocal(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/confirmCheckLocal/confirmCheckFirstLocal`, postData), msg)
    }
    // POST /auth/confirmCheckLocal/confirmCheckSecondLocal *确认勾选-第二步：提交
    post_confirmCheckSecondLocal(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/confirmCheckLocal/confirmCheckSecondLocal`, postData), msg)
    }

    // POST /auth/ivatInvoiceCheck/pageInvoiceCheck 发票勾选页面分页查询
    post_pageInvoiceCheck(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatInvoiceCheck/pageInvoiceCheck`, postData), msg)
    }

    // POST /auth/ivatInvoiceCheck/updateStatusLocal 发票勾选状态更改(单机版)
    post_updateStatusLocal(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatInvoiceCheck/updateStatusLocal`, postData), msg)
    }

    // POST /auth/ivatInvoiceCheck/updateStatus 发票勾选状态更改(服务器版)
    post_updateStatus(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatInvoiceCheck/updateStatus`, postData), msg)
    }

    // POST /manage/ivatInputInvoice/pageInputInvoice *发票管理 发票信息分页查询
    post_pageInputInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatInputInvoice/pageInputInvoice`, postData), msg)
    }
    // GET /GET /manage/ivatInputInvoice/exportToExcel *发票管理 进项发票信息导出excel
    get_invoiceManagerExportToExcel(getdata, msg) {
        const _url = `${host.etcloudIvatApp}manage/ivatInputInvoice/exportToExcel`
        const url = this.getParamUrl(getdata, _url)
        window.open(url)
    }
    // /settings/sysTaxClass/exportTaxClassToExcel 税分编码导出对象
    get_exportTaxClassToExcel(param) {
        let url = `${host.etcloudOvat}settings/sysTaxClass/exportTaxClassToExcel`
        url = this.getParamUrl(param, url)
        window.open(url)
    }
    // POST settings/sysTaxClass/taxClassToBusinessSystem税收分类编码回调调业务系统接口
    post_taxClassToBusinessSystem(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}settings/sysTaxClass/taxClassToBusinessSystem`, postData))
    }
    // GET /settings/sysTaxClass/qryVehicleTaxClass 获取机动车开票税收分类默认版本号
    get_qryVehicleTaxClass(getData, msg) {
        return this.request(() => {
            const _url = `${host.etcloudOvat}settings/sysTaxClass/qryVehicleTaxClass`
            const url = this.getParamUrl(getData, _url)
            return this.$http.get(url)
        })
    }
    // GET /manage/ivatInputInvoice/getInvoice *发票管理 查询进项发票详情
    // get_getInvoice(getdata,msg){
    //     var _url = host.etcloudIvatApp + 'manage/ivatInputInvoice/getInvoice';
    //     var url = this.getParamUrl(getdata,_url);
    //     return this.request(() => {
    //         return this.$http.get(url);
    //     }, msg)
    // }
    // GET /verify/iIvatInvoiceVerify/getIvatInvoice *发票管理 查询进项发票详情
    get_getInvoice(getdata, msg) {
        const _url = `${host.etcloudIvatApp}verify/iIvatInvoiceVerify/getIvatInvoice`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }
    // POST /manage/scanInvoice/getScanInitParam *发票扫描 初始化扫描参数
    post_getScanInitParam(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/scanInvoice/getScanInitParam`, postData), msg)
    }
    // POST /manage/scanInvoice/scanEndCallBack *发票扫描 扫描结束回写接口,返回扫描张数和识别张数
    post_scanEndCallBack(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/scanInvoice/scanEndCallBack`, postData), msg)
    }
    //GET /manage/scanInvoice/ftpGetImage ftp获取影像文件
    get_ftpGetImage(getdata, msg) {
        const _url = `${host.etcloudIvatApp}manage/scanInvoice/ftpGetImage`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }
    // GET /manage/scanInvoice/getInputBatchInfo *发票扫描 扫描结果更新,batchStatus == 2 结束更新
    get_getInputBatchInfo(getdata, msg) {
        const _url = `${host.etcloudIvatApp}manage/scanInvoice/getInputBatchInfo`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }
    // POST /manage/scanInvoice/uploadPdf *发票扫描 PDF上传扫描，支持多个PDFzip上传
    post_uploadPdf(postData) {
        return this.request(() =>
            this.$http.post(`${host.etcloudIvatAppZuul}manage/scanInvoice/uploadPdf`, postData, {
                headers: {
                    'Content-Type': undefined,
                },
                transformRequest: angular.identity,
            })
        )
    }
    // POST /manage/ivatProofreadDetail/pageIvatProofreadDetail *发票收集 校验记录查询
    post_pageIvatProofreadDetail(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatProofreadDetail/pageIvatProofreadDetail`, postData), msg)
    }
    // GET /manage/inputInvoiceCollect/getInputInvoice *发票收集 读取发票
    get_getInputInvoice(getdata, msg) {
        const _url = `${host.etcloudIvatApp}manage/inputInvoiceCollect/getInputInvoice`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }
    // GET /manage/ivatInputInvoice/getIvatFiles *发票收集 查询PDF，影像图片数据
    get_getIvatFiles(getdata, msg) {
        const _url = `${host.etcloudIvatApp}manage/ivatInputInvoice/getIvatFiles`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }
    // POST /manage/ivatInputInvoice/queryInputInoivce *发票收集 发票收集列表查询
    post_queryInputInoivce(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatInputInvoice/queryInputInoivce`, postData), msg)
    }
    // POST /manage/ivatInputInvoice/saveInputInvoice *发票收集 保存手工录入
    post_saveInputInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatInputInvoice/saveInputInvoice`, postData), msg)
    }
    // POST /manage/inputInvoiceCollect/saveInputInvoice *发票收集 保存校对发票
    post_saveCollectInputInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/inputInvoiceCollect/saveInputInvoice`, postData), msg)
    }
    // POST /manage/inputInvoiceCollect/proofread *发票收集 发票校对
    post_proofread(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/inputInvoiceCollect/proofread`, postData), msg)
    }
    // POST /manage/inputInvoiceCollect/delInputInvoice *发票收集 删除进项发票
    post_delInputInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/inputInvoiceCollect/delInputInvoice`, postData), msg)
    }
    // POST /manage/inputInvoiceCollect/queryInputInvoiceDetail *发票收集 分页查询进项发票明细行
    post_queryInputInvoiceDetail(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/inputInvoiceCollect/queryInputInvoiceDetail`, postData), msg)
    }
    // POST /manage/inputInvoiceCollect/queryInvoiceDetail *发票收集 分页查询全票明细行
    post_queryInvoiceDetail(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/inputInvoiceCollect/queryInvoiceDetail`, postData), msg)
    }
    // GET /manage/inputInvoiceCollect/getInputInvoiceDetail *发票收集 查询进项发票票面详情
    get_getInputInvoiceDetail(getdata, msg) {
        const _url = `${host.etcloudIvatApp}manage/inputInvoiceCollect/getInputInvoiceDetail`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }
    // GET /manage/inputInvoiceCollect/exportToExcel *发票收集 进项发票信息导出excel
    get_exportToExcel(getdata, msg) {
        const _url = `${host.etcloudIvatApp}manage/inputInvoiceCollect/exportToExcel`
        const url = this.getParamUrl(getdata, _url)
        window.open(url)
    }
    // GET /manage/inputInvoiceCollect/getFileKey *发票收集 查询存储key
    get_getFileKey(getdata, msg) {
        const _url = `${host.etcloudIvatApp}manage/inputInvoiceCollect/getFileKey`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }
    post_getCollectParam(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/collectBatch/getCollectParam`, postData), msg)
    }

    post_saveIvatCollectBatch(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/collectBatch/saveIvatCollectBatch`, postData), msg)
    }

    // 电子底账列表
    post_getOriginalInvoiceListByCollect(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/originalInvoice/getOriginalInvoiceListByCollect`, postData), msg)
    }
    // 电子底账批量收票
    post_batchReceiveOriginalInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/originalInvoice/batchReceiveOriginalInvoice`, postData), msg)
    }
    // 电子底账批量取消收票
    post_batchCancelReceiveOriginalInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/originalInvoice/batchCancelReceiveOriginalInvoice`, postData), msg)
    }

    // POST /auth/originalInvoice/batchCalReceiveOriginalInvoice  批量取消收票
    post_batchCalReceiveOriginalInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/originalInvoice/batchCalReceiveOriginalInvoice`, postData), msg)
    }
    // 电子抵账导出
    get_exportOriginAccout(getdata) {
        const _url = `${host.etcloudIvatApp}auth/originalInvoice/exportToExcel`
        const url = this.getParamUrl(getdata, _url)
        window.open(url)
    }

    post_saveIvatCollectBatchByRemote(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/collectBatch/saveIvatCollectBatchByRemote`, postData), msg)
    }
    // POST /report/ivatAuthReport/queryCurentUserAllTaxPeriod 查询当前登录用户权限机构的税款所属期
    post_queryCurentUserAllTaxPeriod() {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}report/ivatAuthReport/queryCurentUserAllTaxPeriod`))
    }

    // POST /report/ivatAuthReport/queryNotAuthDataByCreditCodeAndAuthDate根据机构ID和期数获取未认证数据
    post_queryNotAuthDataByCreditCodeAndAuthDate(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}report/ivatAuthReport/queryNotAuthDataByCreditCodeAndAuthDate`, postData), msg)
    }

    // POST /report/ivatAuthReport/queryLastestUpdateTime 查询最近更新时间
    post_queryLastestUpdateTime(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}report/ivatAuthReport/queryLastestUpdateTime`, postData), msg)
    }

    // POST /report/ivatAuthReport/queryIvatAuthStatisticReport 进项认证汇总统计
    post_pageAuthStatisticsReport(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}statistics/ivatAuthStatistics/pageAuthStatisticsReport`, postData), msg)
    }

    // POST /report/ivatAuthReport/queryIvatAuthInvoiceDetail 进项认证发票详情
    post_queryIvatAuthInvoiceDetail(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}report/ivatAuthReport/queryIvatAuthInvoiceDetail`, postData), msg)
    }

    // POST /report/ivatAuthReport/queryAuthInvoiceTaxonomy 分类汇总查询
    post_queryAuthInvoiceTaxonomy(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}report/ivatAuthReport/queryAuthInvoiceTaxonomy`, postData), msg)
    }

    // GET /statistics/ivatAuthStatistics/exportInvoiceDetail 导出已认证进项发票详情
    get_exportInvoiceDetail(getData) {
        const _url = `${host.etcloudIvatApp}statistics/ivatAuthStatistics/exportInvoiceDetail`
        const url = this.getParamUrl(getData, _url)
        window.open(url)
    }

    // POST /report/ivatAuthReport/queryNotAuthDeailsByCreditCodeAndAuthDate 根据机构ID和期数查询未认证明细
    post_queryNotAuthDeailsByCreditCodeAndAuthDate(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}report/ivatAuthReport/queryNotAuthDeailsByCreditCodeAndAuthDate`, postData), msg)
    }

    // GET /report/ivatAuthReport/exportDPFIvatAuthReport 打印进项认证报表
    get_exportDPFIvatAuthReport(getData) {
        const _url = `${host.etcloudBiApp}report/ivatAuthReport/exportDPFIvatAuthReport`
        const url = this.getParamUrl(getData, _url)
        window.open(url)
    }

    // GET /report/ivatAuthReport/exportPDFOfNotAuthDatas 导出未认证明细
    get_exportPDFOfNotAuthDatas(getData) {
        const _url = `${host.etcloudBiApp}report/ivatAuthReport/exportPDFOfNotAuthDatas`
        const url = this.getParamUrl(getData, _url)
        window.open(url)
    }
    // POST /report/ivatAuthReport/getCurrentUserTaxpayers 查询当前用户的权限纳税人
    post_currentUserTaxpayers() {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}report/ivatAuthReport/getCurrentUserTaxpayers`))
    }

    // 获取进项规则配置
    get_getIvatProofreadRegularConfig(msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/inputInvoiceCollect/getIvatProofreadRegularConfig`), msg)
    }
    // 保存进项规则配置
    post_saveIvatProofreadRegularConfig(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/inputInvoiceCollect/saveIvatProofreadRegularConfig`, postData), msg)
    }

    post_scanningGunSave(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/scanInvoice/scanningGunSave?content=${postData}`), msg)
    }
    // GET /version/softwareVersion/getSoftwareVersion 获取软件版本信息
    get_getSoftwareVersion(msg) {
        return this.request(() => this.$http.get(`${host.etcloud}version/softwareVersion/getSoftwareVersion`), msg)
    }
    // GET /settings/sysSfdqDm/getProvince 得到省份 城市 @zhaojm
    get_getProvince(msg) {
        return this.request(() => this.$http.get(`${host.etcloud}/settings/sysSfdqDm/getProvince`), msg)
    }
    // taxpolicy/sbJmszcDm/getSbJmszcDmList
    post_getSbJmszcDmList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudSb}taxpolicy/sbJmszcDm/getSbJmszcDmList`, postData))
    }
    // template/sbMbDqR/getModelByDqSz 得到 省份 税务种类的 模板
    get_getModelByDqSz(getdata, msg) {
        const _url = `${host.etcloudSb}template/sbMbDqR/getModelByDqSz`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url), msg)
    }
    // /taxpolicy/sbYgzsdYsxmmxb/getSbYgzsdYsxmmxbList 查询增值税应税项目
    post_getSbYgzsdYsxmmxbList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudSb}taxpolicy/sbYgzsdYsxmmxb/getSbYgzsdYsxmmxbList`, postData))
    }
    // /taxpolicy/sbJmszcDm/exportSbJmszcDmToExcel 减免税政策导出Excel
    get_exportSbJmszcDmToExcel(param) {
        const _url = `${host.etcloudSb}taxpolicy/sbJmszcDm/exportSbJmszcDmToExcel`
        const url = this.getParamUrl(param, _url)
        window.open(url)
    }
    // /taxpolicy/sbSwkjkmDm/exportSbKjkmDmToExcel 税务会计科目导出Excel
    get_exportSbKjkmDmToExcel(param) {
        const _url = `${host.etcloudSb}taxpolicy/sbSwkjkmDm/exportSbKjkmDmToExcel`
        const url = this.getParamUrl(param, _url)
        window.open(url)
    }
    // /taxpolicy/sbYgzsdYsxmmxb/exportSbYgzsdYsxmmxbToExcel 增值税应税项目导出excel
    get_exportSbYgzsdYsxmmxbToExcel(param) {
        const _url = `${host.etcloudSb}taxpolicy/sbYgzsdYsxmmxb/exportSbYgzsdYsxmmxbToExcel`
        const url = this.getParamUrl(param, _url)
        window.open(url)
    }
    // POST /template/sbMbDqR/modelManage 模板管理（新增/删除） @zhaojm
    post_modelManage(postData) {
        return this.request(() => this.$http.post(`${host.etcloudSb}template/sbMbDqR/modelManage`, postData))
    }
    //GET /template/sbMbDqR/getOrgModel 查询机构下的所有模板 @zhaojm
    get_getOrgModel(getData) {
        const _url = `${host.etcloudSb}template/sbMbDqR/getOrgModel`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    ///template/sbMbDqR/getOrgModelByRuuid 根据 ruuid 查询机构下 某一张模板 @zhaojm
    get_getOrgModelByRuuid(getData, msg) {
        const _url = `${host.etcloudSb}template/sbMbDqR/getOrgModelByRuuid`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url), msg)
    }
    // POST /manage/sbSbqk/sbSbqkInit 初始化申报模板
    post_sbSbqkInit(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudSb}manage/sbSbqk/sbSbqkInit`, postData))
    }
    //GET /manage/sbSbqk/getSbSbqkInfoBySbuuid 查询 模板的所有详情 @zhaojm
    get_getSbSbqkInfoBySbuuid(getData) {
        return this.request(() => this.$http.get(`${host.etcloudSb}manage/sbSbqk/getSbSbqkInfoBySbuuid?sbuuid=${getData}`))
    }
    //POST /template/sbMbDqR/forbidFlzl 禁用 附列资料 @zhaojm
    post_forbidFlzl(postData) {
        return this.request(() => this.$http.post(`${host.etcloudSb}template/sbMbDqR/forbidFlzl`, postData))
    }
    // POST /manage/sbSbqk/submitAudit 申报提交审核@wangxiaobo
    post_submitAudit(postData) {
        return this.request(() => this.$http.post(`${host.etcloudSb}manage/sbSbqk/submitAudit`, postData))
    }
    // /manage/sbSbqk/getSbqkInfoList 申报表（分页）查询 @zhaojm
    post_getSbqkInfoList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudSb}manage/sbSbqk/getSbqkInfoList`, postData))
    }

    // POST /ems/sysUkey/getUkeyListByDiskIds 查询金税盘关联的开票点
    post_getUkeyListByDiskIds(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierUkey' : 'ems/sysUkey'}/getUkeyListByDiskIds`, postData))
    }
    //GET /ems/sysTaxDisk/getDiskBySaleIdAndDiskCode
    get_getDiskBySaleIdAndDiskCode(getData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierTaxDisk' : 'ems/sysTaxDisk'}/getDiskBySaleIdAndDiskCode`, postData))
    }

    //POST /ems/sysUkey/getUkeyListByDiskCodes
    post_getUkeyListByDiskCodes(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierUkey' : 'ems/sysUkey'}/getUkeyListByDiskCodes`, postData))
    }

    //  销项-库存管理-明细查询-分领明细 @sujj
    post_getInvoiceAllotDetails(getdata) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/invoiceAllot/getInvoiceAllotDetails`, getdata))
    }
    //POST /stock/stockOnlineApply/queryOvatOnlineApplyRecordDetail 查询申领明细
    post_queryOvatOnlineApplyRecordDetail(getdata) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/stockOnlineApply/queryOvatOnlineApplyRecordDetail`, getdata))
    }
    // POST /stock/invoiceCollect/getInvoiceCollectDetails 获取发票收回明细
    post_getInvoiceCollectDetails(getdata) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/invoiceCollect/getInvoiceCollectDetails`, getdata))
    }
    //GET /stock/stockOnlineApply/queryInvoiceTypeName 发票种类名称查询
    get_queryInvoiceTypeName(getData) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}stock/stockOnlineApply/queryInvoiceTypeName`))
    }

    //GET /ems/sysTaxDisk/getDiskBySaleId 根据销方ID获取金税盘
    get_getDiskBySaleId(getData) {
        const _url = `${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierTaxDisk' : 'ems/sysTaxDisk'}/getDiskBySaleId`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }

    // 获取服务器版库存
    // GET /stock/invoiceAllot/qryServerDiskStockData 服务器版盘库存查询
    get_QueryStock(getData) {
        const _url = `${host.etcloudOvat}stock/invoiceAllot/qryServerDiskStockData`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    // /stock/stockOnlineApply/addOperator新增经办人信息
    post_addOperator(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/stockOnlineApply/addOperator`, postData))
    }
    // /stock/stockOnlineApply/updateOperator 更新经办人信息
    post_updateOperator(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/stockOnlineApply/updateOperator`, postData))
    }
    // POST /stock/stockOnlineApply/deleteOperator 删除经办人信息
    post_deleteOperator(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/stockOnlineApply/deleteOperator`, postData))
    }
    // /stock/stockOnlineApply/addConsignee 新增收货人信息
    post_addConsignee(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/stockOnlineApply/addConsignee`, postData))
    }
    // /stock/stockOnlineApply/updateConsignee 更新收货人信息
    post_updateConsignee(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/stockOnlineApply/updateConsignee`, postData))
    }
    // /stock/stockOnlineApply/deleteConsignee 删除收货人信息
    post_deleteConsignee(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/stockOnlineApply/deleteConsignee`, postData), msg)
    }
    // /stock/stockOnlineApply/getConsigneeListBySale 获取税号下的收货人信息列表
    get_getConsigneeListBySale() {
        return this.request(() => this.$http.get(`${host.etcloudOvat}stock/stockOnlineApply/getConsigneeListBySale`))
    }

    // GET /stock/stockOnlineApply/downloadInvoiceApply 诺诺：下载申领票据到盘中
    get_downloadInvoiceApply(getData) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}stock/stockOnlineApply/downloadInvoiceApply?extensionNumber=${getData.extensionNumber}&equipNumber=${getData.equipNumber}&taxNum=${getData.taxNum}`))
    }
    // GET /stock/stockOnlineApply/getInvoiceApplyResult 诺诺：获取申领发票状态信息
    get_getInvoiceApplyResult(getData) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}stock/stockOnlineApply/getInvoiceApplyResult?taskNum=${getData}`))
    }
    // GET /stock/stockOnlineApply/getPrepareInvoiceApply 诺诺：获取准备申领发票信息
    get_getPrepareInvoiceApply(getData) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}stock/stockOnlineApply/getPrepareInvoiceApply?taxNum=${getData}`))
    }
    // GET /stock/stockOnlineApply/invoiceApplyCancel 诺诺：撤销发票申领请求
    get_invoiceApplyCancel(getData) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}stock/stockOnlineApply/invoiceApplyCancel?applyNum=${getData}`))
    }
    // POST /stock/stockOnlineApply/queryInvoiceInventory 诺诺：发票库存查询
    post_queryInvoiceInventory(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/stockOnlineApply/queryInvoiceInventory`, postData))
    }
    // POST /stock/stockOnlineApply/submitInvoiceApply 诺诺：提交发票申领
    post_submitInvoiceApply(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/stockOnlineApply/submitInvoiceApply`, postData))
    }

    // /stock/stockOnlineApply/queryOvatOnlineApplyRecord 发票申领查询
    post_queryOvatOnlineApplyRecord(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/stockOnlineApply/queryOvatOnlineApplyRecord`, postData))
    }
    // /stock/stockOnlineApply/addOnlineApplyRecord
    post_addOnlineApplyRecord(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/stockOnlineApply/addOnlineApplyRecord`, postData))
    }
    //GET /stock/invoiceAllot/parseReportOfBase64 将数据进行base64解密
    get_parseReportOfBase64(getData) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}stock/invoiceAllot/parseReportOfBase64?report=${getData}`))
    }
    //POST /ems/sysUkey/getUkeyListByDiskCodes 查询金税盘关联的开票点 查询金税盘关联的开票点
    post_ukeyListByDiskCodes(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierUkey' : 'ems/sysUkey'}/getUkeyListByDiskCodes`, postData), msg)
    }
    //POST /stock/invoiceAllot/allotServerDiskInvoice2Ukey 服务器版分配到ukey操作
    post_allotServerDiskInvoice2Ukey(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/invoiceAllot/allotServerDiskInvoice2Ukey`, postData))
    }
    //POST /stock/invoiceAllot/addAllotOperateRecord 提交分配操作记录
    post_addAllotOperateRecord(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/invoiceAllot/addAllotOperateRecord`, postData))
    }
    // /stock/invoiceAllot/qryReceiveInvoiceList 分盘领票查询
    post_qryReceiveInvoiceList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/invoiceAllot/qryReceiveInvoiceList`, postData))
    }
    // /stock/invoiceAllot/receiveAllotInvoice 分盘领票
    post_receiveAllotInvoice(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/invoiceAllot/receiveAllotInvoice`, postData))
    }
    // GET /stock/invoiceAllot/qryServerDiskOfPlugged 查询服务器上插盘情况
    get_qryServerDiskOfPlugged(getData) {
        const _url = `${host.etcloudOvat}stock/invoiceAllot/qryServerDiskOfPlugged`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    // POST /stock/invoiceCollect/qryOvatInvoiceCollect 发票收回数据补全
    post_qryOvatInvoiceCollect(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/invoiceCollect/qryOvatInvoiceCollect`, postData))
    }
    // POST /stock/invoiceCollect/returnServerDiskInvoiceFromUkey 从ukey退回发票到服务器盘操作
    post_returnServerDiskInvoiceFromUkey(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/invoiceCollect/returnServerDiskInvoiceFromUkey`, postData))
    }
    // POST /stock/invoiceCollect/addSonDiskCollectOperateRecord 提交分盘收回操作记录
    post_addSonDiskCollectOperateRecord(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/invoiceCollect/addSonDiskCollectOperateRecord`, postData))
    }
    // POST /stock/invoiceCollect/addMainDiskCollectOperateRecord 提交主盘收回操作记录
    post_addMainDiskCollectOperateRecord(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/invoiceCollect/addMainDiskCollectOperateRecord`, postData))
    }
    // POST /stock/invoiceCollect/addBackOperateRecord 提交退回操作记录
    post_addBackOperateRecord(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/invoiceCollect/addBackOperateRecord`, postData))
    }
    // stock/stockOnlineApply/getOperatorListBySale 获取税号下的经办人信息列表
    get_getOperatorListBySale() {
        return this.request(() => this.$http.get(`${host.etcloudOvat}stock/stockOnlineApply/getOperatorListBySale`))
    }
    // /stock/stockOnlineApply/updateOnlineApplyRecord 更新网上申领信息
    post_updateOnlineApplyRecord(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/stockOnlineApply/updateOnlineApplyRecord`, postData))
    }
    // POST /reportTemplate/pageQueryReportTemplate 分页查询模板文件配置
    post_pageQueryReportTemplate(postData) {
        return this.request(() => this.$http.post(`${host.etcloudBiReport}reportTemplate/pageQueryReportTemplate`, postData))
    }
    // POST /reportTemplate/queryReportTemplate 查看模板文件配置
    post_queryReportTemplate(postData) {
        return this.request(() => this.$http.post(`${host.etcloudBiReport}reportTemplate/queryReportTemplate?templateId=${postData}`))
    }
    // POST /reportTemplate/cancelPublishReportTemplate 取消发布报表模板
    post_cancelPublishReportTemplate(postData) {
        return this.request(() => this.$http.post(`${host.etcloudBiReport}reportTemplate/cancelPublishReportTemplate?templateId=${postData}`))
    }
    // POST /reportTemplate/importTemplate 上传模板文件
    post_importTemplate(postData) {
        return this.request(() =>
            this.$http.post(`${host.etcloudBiReport}reportTemplate/importTemplate`, postData, {
                headers: {
                    'Content-Type': undefined,
                },
                transformRequest: angular.identity,
            })
        )
    }
    // POST /reportTemplate/deleteReportTemplate 删除模板文件
    post_deleteReportTemplate(postData) {
        return this.request(() => this.$http.post(`${host.etcloudBiReport}reportTemplate/deleteReportTemplate?templateId=${postData}`))
    }
    // POST /sysFunction/queryChildFunction 报表模板管理发布路劲接口
    post_queryChildFunction(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}auth/sysFunction/queryChildFunction?parentFunctionId=${postData}`))
    }
    // POST /reportTemplate/importFiles 单个上传模板文件
    post_importFiles(postData) {
        return this.request(() => this.$http.post(`${host.etcloudBiReport}reportTemplate/importFiles`, postData))
    }
    // POST /reportTemplate/previewReportTemplate 预览模板文件
    post_previewReportTemplate(postData) {
        return this.request(() => this.$http.post(`${host.etcloudBiReport}reportTemplate/previewReportTemplate?templateId=${postData}`))
    }
    //POST /reportTemplate/queryReportUrl 预览模板文件
    post_queryReportUrl(postData) {
        return this.request(() => this.$http.post(`${host.etcloudBiReport}reportTemplate/queryReportUrl`, postData))
    }
    //GET  /stock/ovatInvoiceStock/queryInvoiceStockC48 查询C48库存
    get_queryInvoiceStockC48(getData) {
        const _url = `${host.etcloudOvat}stock/ovatInvoiceStock/queryInvoiceStockC48`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    // /contract/ivatContractOperate/getIvatContractList 合同管理、录入页面分页查询
    post_getIvatContractList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}contract/ivatContractOperate/getIvatContractList`, postData))
    }
    // GET /contract/ivatContractOperate/deleteContractAndInvoice 删除合同、发票及所有影像文件
    get_deleteContractAndInvoice(contractId) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}contract/ivatContractOperate/deleteContractAndInvoice?contractId=${contractId}`))
    }
    // /contract/ivatContractOperate/deleteContractFile 删除合同影像文件
    post_deleteContractFile(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}contract/ivatContractOperate/deleteContractFile`, postData))
    }
    // /contract/ivatContractOperate/deleteInvoice 删除合同的发票及发票影像
    get_deleteInvoice(getdata) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}contract/ivatContractOperate/deleteInvoice`, getdata))
    }
    // contract/ivatContractOperate/queryContractFile 查询合同影像文件(封面、合同)
    get_queryContractFile(getdata) {
        const _url = `${host.etcloudIvatApp}contract/ivatContractOperate/queryContractFile`
        const url = this.getParamUrl(getdata, _url)
        return this.request(() => this.$http.get(url))
    }
    // contract/ivatContractOperate/submitContract 提交合同
    post_submitContract(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}contract/ivatContractOperate/submitContract`, postData))
    }
    // /contract/ivatContractOperate/updateContract 更新合同封面内容
    post_updateContract(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}contract/ivatContractOperate/updateContract`, postData))
    }
    // /contract/ivatContractOperate/updateInvoice 修改发票
    post_updateInvoice(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}contract/ivatContractOperate/updateInvoice`, postData))
    }
    // GET /contract/ivatContractOperate/getContractEntryDetail 查询合同录入的详细信息
    get_getContractEntryDetail(contractId) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}contract/ivatContractOperate/getContractEntryDetail?contractId=${contractId}`))
    }
    // POST /taxpolicy/sbSwkjkmDm/getSbSwkjkmDmList 查询税务科目
    post_getSbSwkjkmDmList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudSb}taxpolicy/sbSwkjkmDm/getSbSwkjkmDmList`, postData))
    }
    // POST /contract/contractTemplate/getContractTemplateList 合同模板分页查询及预览查询
    post_getContractTemplateList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}contract/contractTemplate/getContractTemplateList`, postData))
    }
    // GET /contract/contractTemplate/delContractTemplate 合同模板删除
    get_delContractTemplate(getData) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}contract/contractTemplate/delContractTemplate?templateId=${getData}`))
    }
    // GET /contract/contractTemplate/updateContractTemplateStatus 合同模板状态修改
    get_updateContractTemplateStatus(getData) {
        const _url = `${host.etcloudIvatApp}contract/contractTemplate/updateContractTemplateStatus`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    //POST /contract/contractTemplate/updateContractTemplate 合同模板编辑
    post_updateContractTemplate(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}contract/contractTemplate/updateContractTemplate`, postData))
    }
    // GET /contract/contractTemplate/exportTo 合同模板信息导出
    get_exportTo(getData) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}contract/contractTemplate/exportTo?templateId=${getData}`))
    }
    // POST /contract/contractTemplate/addContractTemplate 合同模板新增
    post_addContractTemplate(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}contract/contractTemplate/addContractTemplate`, postData))
    }

    // POST /manage/sbKmye/qrySbKmye 查询财务报表-科目余额表信息
    post_qrySbKmye(postData) {
        return this.request(() => this.$http.post(`${host.etcloudSb}manage/sbKmye/qrySbKmye`, postData))
    }
    // POST /manage/sbKmye/modSbKmye 修改财务报表-科目余额表信息(年初余额，年末余额，本年借方累计，本年贷方累计)
    post_modSbKmye(postData) {
        return this.request(() => this.$http.post(`${host.etcloudSb}manage/sbKmye/modSbKmye`, postData))
    }
    // POST /manage/sbKmye/sbCwbbInit 财务报表初始化-申报表生成
    post_sbCwbbInit(postData) {
        return this.request(() => this.$http.post(`${host.etcloudSb}manage/sbKmye/sbCwbbInit`, postData))
    }
    // /contract/scanContract/getScanInitParam 初始化扫描参数
    post_getContractScanInitParam(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}contract/scanContract/getScanInitParam`, postData))
    }
    //POST /taxpolicy/sbKjkmDm/getSbKjkmDmList 查询会计科目
    post_getSbKjkmDmList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudSb}taxpolicy/sbKjkmDm/getSbKjkmDmList`, postData))
    }
    //get /taxpolicy/sbSwkjkmDm/getSbSwkjkmDmListByKmlbDm 分组查询税务科目
    get_getSbSwkjkmDmListByKmlbDm(getData) {
        const _url = `${host.etcloudSb}taxpolicy/sbSwkjkmDm/getSbSwkjkmDmListByKmlbDm`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    // GET /taxpolicy/sbKjkmDm/matchSbKjkmDm 手工匹配科目
    get_matchSbKjkmDm(getData) {
        const _url = `${host.etcloudSb}taxpolicy/sbKjkmDm/matchSbKjkmDm`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    // /contract/ivatContractOperate/exportToZip 合同管理影像文件导出
    get_exportContractToZip(param) {
        let url = `${host.etcloudIvatApp}contract/ivatContractOperate/exportToZip`
        url = this.getParamUrl(param, url)
        window.open(url)
    }
    // /contract/ivatContractOperate/exportToExcel 合同管理列表导出excel
    get_exportContractToExcel(param) {
        let url = `${host.etcloudIvatApp}contract/ivatContractOperate/exportToExcel`
        url = this.getParamUrl(param, url)
        window.open(url)
    }
    // GET /contract/ivatContractOperate/getContractDetail 查询合同管理的详细信息
    get_getContractDetail(id) {
        const url = `${host.etcloudIvatApp}contract/ivatContractOperate/getContractDetail?contractId=${id}`
        return this.request(() => this.$http.get(url))
    }
    // POST /manage/sbKmye/isSbCwbbInit 是否已经生成过财务报表
    post_isSbCwbbInit(postData) {
        return this.request(() => this.$http.post(`${host.etcloudSb}manage/sbKmye/isSbCwbbInit`, postData))
    }
    // GET /manage/sbKmye/preCondition 导入财务报表-科目余额表前置条件
    get_preCondition() {
        return this.request(() => this.$http.get(`${host.etcloudSb}manage/sbKmye/preCondition`))
    }
    // POST /turnout/ivatTurnoutCategory/pageGetCategory 分页查询进项税转出类型
    post_pageGetCategory(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}turnout/ivatTurnoutCategory/pageGetCategory`, postData))
    }

    get_getIvatRuleConfList(getData) {
        const _url = `${host.etcloudIvatApp}/ruleset/ivatRuleConf/getIvatRuleConfList`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    post_addIvatRuleConf(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}/ruleset/ivatRuleConf/addIvatRuleConf`, postData))
    }
    post_updateIvatRuleConf(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}/ruleset/ivatRuleConf/updateIvatRuleConf`, postData))
    }
    post_delIvatRuleConf(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}/ruleset/ivatRuleConf/delIvatRuleConf?ruleConfId=${postData}`))
    }
    // POST /turnout/ivatTurnoutCategory/updateTurnoutCategory 修改进项税转出类型
    post_updateTurnoutCategory(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}turnout/ivatTurnoutCategory/updateTurnoutCategory`, postData))
    }
    // POST /turnout/ivatTurnoutCategory/insertTurnoutCategory 新增进项税转出类型
    post_insertTurnoutCategory(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}turnout/ivatTurnoutCategory/insertTurnoutCategory`, postData))
    }
    // POST /turnout/ivatTurnoutCategory/deleteCategory 删除进项税转出类型
    post_deleteCategory(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}turnout/ivatTurnoutCategory/deleteCategory`, postData))
    }
    // GET /turnout/ivatTurnoutCategory/getCategory 单条查询进项税转出类型详情
    get_getCategory(id) {
        const url = `${host.etcloudIvatApp}turnout/ivatTurnoutCategory/getCategory?categoryId=${id}`
        return this.request(() => this.$http.get(url))
    }
    // POST /stock/invoiceAllot/storeSingerDiskStockInfo 单机版库存储存@zhaojiamin
    post_storeSingerDiskStockInfo(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}stock/invoiceAllot/storeSingerDiskStockInfo`, postData))
    }
    //POST /turnout/ivatTurnout/pageTurnout 分页查询电子底账中可进项税转出发票信息
    post_pageTurnout(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}turnout/ivatTurnout/pageTurnout`, postData))
    }
    //POST /turnout/ivatTurnout/authBatchTurnout 验证所勾选发票是否能做全额转出
    post_authBatchTurnout(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}turnout/ivatTurnout/authBatchTurnout`, postData))
    }
    //GET /turnout/ivatTurnoutCategory/qryTurnoutCategoryAll 查询全部转出类型
    get_qryTurnoutCategoryAll() {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}turnout/ivatTurnoutCategory/qryTurnoutCategoryAll`))
    }
    //POST /turnout/ivatTurnout/doBatchTurnout 用户操作批量转出
    post_doBatchTurnout(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}turnout/ivatTurnout/doBatchTurnout`, postData))
    }
    //POST /turnout/ivatTurnout/doBatchReturn 用户操作批量退回
    post_doBatchReturn(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}turnout/ivatTurnout/doBatchReturn`, postData))
    }
    //GET /turnout/ivatTurnout/authPartTurnout 部分转出时验证对应转出税额是否已经全部转出完
    get_authPartTurnout(getData) {
        const _url = `${host.etcloudIvatApp}turnout/ivatTurnout/authPartTurnout`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    //POST /turnout/ivatTurnout/doPartTurnout 用户操作部分转出
    post_doPartTurnout(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}turnout/ivatTurnout/doPartTurnout`, postData))
    }
    //POST /turnout/ivatTurnout/doPartReturn 用户操作部分退回
    post_doPartReturn(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}turnout/ivatTurnout/doPartReturn`, postData))
    }
    //GET /turnout/ivatTurnout/selectPartTurnoutRecord 部分转出退回时查询对应发票及其转出记录
    get_selectPartTurnoutRecord(getData) {
        const _url = `${host.etcloudIvatApp}turnout/ivatTurnout/selectPartTurnoutRecord`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    //POST /turnout/ivatTurnoutAccount/pageAccount 分页查询进项转出中台账记录
    post_pageAccount(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}turnout/ivatTurnoutAccount/pageAccount`, postData))
    }
    //GET /turnout/ivatTurnoutAccount/exportAccount 导出台账记录
    get_ivatTurnoutAccount(getdata) {
        const _url = `${host.etcloudIvatApp}turnout/ivatTurnoutAccount/exportAccount`
        const url = this.getParamUrl(getdata, _url)
        window.open(url)
    }
    //GET /turnout/ivatTurnoutAccount/selectInvoiceDetail 获取台账中对应发票详情
    get_selectInvoiceDetail(getData) {
        const _url = `${host.etcloudIvatApp}turnout/ivatTurnoutAccount/selectInvoiceDetail`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    //GET /turnout/ivatTurnoutCategory/qryCategoryByIds 根据转出类型ID查询转出类型名称
    get_qryCategoryByIds(getData) {
        const _url = `${host.etcloudIvatApp}turnout/ivatTurnoutCategory/qryCategoryByIds`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    //GET /turnout/ivatTurnout/qryTurnoutRecordByTurnoutId 根据转出ID查询转出记录
    get_qryTurnoutRecordByTurnoutId(getData) {
        const _url = `${host.etcloudIvatApp}turnout/ivatTurnout/qryTurnoutRecordByTurnoutId`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    //POST /ems/sysUkey/getStockUkeyListByDiskCodes 库存查询获取金税盘下的开票点
    post_getStockUkeyListByDiskCodes(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierUkey' : 'ems/sysUkey'}/getStockUkeyListByDiskCodes`, postData))
    }
    //POST /ems/sysVehicleType/getVehicleTypeList 车辆种类分页查询
    post_getVehicleTypeList(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysVehicleType/getVehicleTypeList`, postData))
    }
    //POST /ems/sysVehicleOrigin/getVehicleOriginList 车辆产地分页查询
    post_getVehicleOriginList(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysVehicleOrigin/getVehicleOriginList`, postData))
    }
    //POST /ems/sysVehicleCompany/getSysVehicleCompanyList 生产企业名称分页查询
    post_getSysVehicleCompanyList(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysVehicleCompany/getSysVehicleCompanyList`, postData))
    }
    //POST /settings/sysRollticketSpec/getSysRollticketSpecList 卷票规格列表查询
    post_getSysRollticketSpecList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierRollticketSpec' : 'settings/sysRollticketSpec'}/getSysRollticketSpecList`, postData))
    }
    //GET /settings/sysRollticketSpec/updateRollticketStates 卷票规格状态修改
    get_updateRollticketStates(getData, msg) {
        const _url = `${host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierRollticketSpec' : 'settings/sysRollticketSpec'}/updateRollticketStates`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url), msg)
    }
    //POST /settings/sysCustomer/qryByCodeOrName 根据编码或名字模糊查询
    post_qryByCodeOrName(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}settings/sysCustomer/qryByCodeOrName`, postData), msg)
    }
    // POST /settings/sysVehicleGood/pageVehicleGood 车辆编码信息分页查询
    post_pageVehicleGood(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}settings/sysVehicleGood/pageVehicleGood`, postData))
    }
    // }
    // GET /settings/sysVehicleGood/exportToExcel 车辆编码信息导出excel
    get_exportAccount(getdata) {
        const _url = `${host.etcloudOvat}settings/sysVehicleGood/exportToExcel`
        const url = this.getParamUrl(getdata, _url)
        window.open(url)
    }
    // POST /settings/sysVehicleGood/delVehicleGood 删除车辆编码信息
    get_delVehicleGood(getData) {
        const _url = `${host.etcloudOvat}settings/sysVehicleGood/delVehicleGood`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    // POST /settings/sysVehicleGood/updateVehicleGoodStatus 启用|禁用
    get_updateVehicleGoodStatus(getData) {
        const _url = `${host.etcloudOvat}settings/sysVehicleGood/updateVehicleGoodStatus`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    // GET /settings/sysVehicleGood/qryVehicleGoodInfo 车辆编码信息-详情
    get_qryVehicleGoodInfo(getData) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}settings/sysVehicleGood/qryVehicleGoodInfo?goodsId=${getData}`))
    }
    // POST /settings/sysVehicleGood/addVehicleGood 新增车辆编码信息
    post_addVehicleGood(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}settings/sysVehicleGood/addVehicleGood `, postData), msg)
    }
    // POST /settings/sysVehicleGood/updateVehicleGoodInfo 修改车辆编码信息
    post_updateVehicleGoodInfo(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}settings/sysVehicleGood/updateVehicleGoodInfo `, postData), msg)
    }

    //POST /settings/sysVehicleGood/getVehicleGoodList 车辆编码信息列表查询
    post_getVehicleGoodList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}settings/sysVehicleGood/getVehicleGoodList`, postData))
    }
    // POST /openedInvoice/synVInvoiceData 机动车发票数据同步
    post_synVInvoiceData(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}openedInvoice/synVInvoiceData`, postData))
    }
    // POST /settings/sysParam/getSysParam 查询系统参数
    post_getSysParam(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysParam/getSysParam`, postData))
    }
    // POST /settings/sysParam/updateSysParam 更新系统参数
    post_updateSysParam(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysParam/updateSysParam`, postData))
    }
    // GET /auth/collectBatch/checkCollectConfigure 查询是单机版还是服务器版
    get_checkCollectConfigure() {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}auth/collectBatch/checkCollectConfigure`))
    }
    // POST /manage/inputInvoiceCollect/manuallySubmit 发票手动提交
    post_manuallySubmit(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/inputInvoiceCollect/manuallySubmit`, postData))
    }
    // POST /manage/inputInvoiceCollect/queryInvoice 分页查询发票手工提取全票面
    post_queryInvoice(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/inputInvoiceCollect/queryInvoice`, postData))
    }
    // GET /manage/inputInvoiceCollect/queryInputInoivceElements 根据用户的校对配置确定需要手工录入的字段
    get_queryInputInoivceElements() {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}manage/inputInvoiceCollect/queryInputInoivceElements`))
    }
    // GET /manage/inputInvoiceCollect/queryInvoiceTypeByCode 根据发票代码识别发票类型
    get_queryInvoiceTypeByCode(getData) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}manage/inputInvoiceCollect/queryInvoiceTypeByCode?invoiceCode=${getData}`))
    }
    // GET /manage/inputInvoiceCollect/querySaleCodeName 获取当前机构信用代码开票方(销方)信息
    get_querySaleCodeName() {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}manage/inputInvoiceCollect/querySaleCodeName`))
    }
    // GET /manage/ivatInputInvoice/isOpenProofread 判断是否开启校对
    get_isOpenProofread() {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}manage/ivatInputInvoice/isOpenProofread`))
    }
    // POST /manage/ivatInputInvoice/submitInvoice 发票提交
    post_submitInvoice(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatInputInvoice/submitInvoice`, postData))
    }
    // POST /statistics/biRanking/selectSaleRanking 销售额排名统计
    post_selectSaleRanking(postData) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}statistics/biRanking/selectSaleRanking`, postData))
    }
    // POST /statistics/biRanking/selectSaleInfoDetail 销售明细分页查询
    post_selectSaleInfoDetail(postData) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}statistics/biRanking/selectSaleInfoDetail`, postData))
    }
    // POST /statistics/biRanking/selectTotalSale 销售总额查询
    post_selectTotalSale(postData) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}statistics/biRanking/selectTotalSale`, postData))
    }
    // GET /statistics/biRanking/exportSaleRanking 导出销售排名
    get_exportSaleRanking(getdata) {
        const _url = `${host.etcloudBiApp}statistics/biRanking/exportSaleRanking`
        let dataStr = '' // 数据拼接字符串
        Object.keys(getdata).forEach((key) => {
            dataStr += `${key}=${encodeURI(getdata[key])}&`
        })
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
        const url = `${_url}?${dataStr}`
        window.open(url)
    }
    // POST /statistics/biRanking/selectPurchaseRanking 采购排名统计
    post_selectPurchaseRanking(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}statistics/ivatRanking/selectPurchaseRanking`, postData))
    }
    // POST /statistics/biRanking/selectPurchaseInfoDetail 采购明细分页查询
    post_selectPurchaseInfoDetail(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}statistics/ivatRanking/selectPurchaseInfoDetail`, postData))
    }
    // POST /statistics/biRanking/selectTotalPurchase 采购总额查询
    post_selectTotalPurchase(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}statistics/ivatRanking/selectTotalPurchase`, postData))
    }
    // GET /statistics/biRanking/exportPurchaseRanking 导出采购排名
    get_exportPurchaseRanking(getdata) {
        const _url = `${host.etcloudIvatApp}statistics/ivatRanking/exportPurchaseRanking`
        let dataStr = '' // 数据拼接字符串
        Object.keys(getdata).forEach((key) => {
            dataStr += `${key}=${getdata[key]}&`
        })
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
        const url = `${_url}?${dataStr}`
        window.open(url)
    }
    // GET /settings/sysParam/getSysParamMap 查询系统参数(选择查询)
    get_SysParamMap() {
        return this.request(() => this.$http.get(`${host.etcloud}settings/sysParam/getSysParamMap`))
    }
    // POST /settings/sysParam/updateSysParam 更新系统参数
    post_updateSysParam(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysParam/updateSysParam`, postData))
    }
    // 获取日志信息
    post_getPageOperateLogList(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysOprateLog/getPageOperateLogList`, postDate), msg)
    }
    // POST /ems/sysProject/qryProjectList 分页查询项目信息
    post_qryProjectList(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysProject/qryProjectList`, postDate), msg)
    }
    // POST /ems/sysProject/addProject 添加项目
    post_addProject(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysProject/addProject`, postDate), msg)
    }
    // GET /ems/sysProject/getProjectById 根据Id获取项目
    get_getProjectById(projectId) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysProject/getProjectById?projectId=${projectId}`))
    }
    // POST /ems/sysProject/modProject 修改项目
    post_modProject(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysProject/modProject`, postDate), msg)
    }
    // GET /ems/sysProject/delProjectById 删除项目
    get_delProjectById(projectId) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysProject/delProjectById?projectId=${projectId}`))
    }
    // GET /ems/sysProject/getProjectlistOfCurrentOrg 获取当前机构下所有已启用的项目
    get_getProjectlistOfCurrentOrg() {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysProject/getProjectlistOfCurrentOrg`))
    }
    // POST /manage/inputInvoiceCollect/invoiceProofread 发票校对
    post_invoiceProofread(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/inputInvoiceCollect/invoiceProofread`, postData))
    }
    // GET /auth/ivatAutoCheckConfig/getAutoCheckConfigList 自动勾选配置查询
    get_getAutoCheckConfigList() {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}auth/ivatAutoCheckConfig/getAutoCheckConfigList`))
    }
    // manage/ivatInputInvoice/setInputInvoiceRule
    post_setInputInvoiceRule(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatInputInvoice/setInputInvoiceRule`, postData))
    }
    // /ruleset/ivatRuleConf/getRuleTypetMap
    get_getRuleTypetMap() {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}ruleset/ivatRuleConf/getRuleTypetMap`))
    }
    // POST /auth/ivatAutoCheckConfig/updateAutoCheckConfig 修改自动勾选配置
    post_updateAutoCheckConfig(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatAutoCheckConfig/updateAutoCheckConfig`, postData))
    }
    // GET /auth/ivatInvoiceCheck/getHeaderGatherAmtData
    get_getHeaderGatherAmtData(getData) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}auth/ivatInvoiceCheck/getHeaderGatherAmtData?tabCode=${getData}`))
    }
    //GET /ems/sysDepartment/getDeparmentOfOrg 查询机构下的部门
    get_getDeparmentOfOrg() {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysDepartment/getDeparmentOfOrg`))
    }
    // POST /expense/ivatExpense/addExpenseItem 添加报销单据
    post_addExpenseItem(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}expense/ivatExpense/addExpenseItem`, postData), msg)
    }
    // POST /expense/ivatExpense/batchSubmitExpenses 批量提交报销单
    post_batchSubmitExpenses(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}expense/ivatExpense/batchSubmitExpenses`, postData))
    }
    // GET /expense/ivatExpense/deleteExpenseItem 删除报销单据数据
    get_deleteExpenseItem(getData) {
        const _url = `${host.etcloudIvatApp}expense/ivatExpense/deleteExpenseItem`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    // GET /expense/ivatExpense/deleteOtherInvoiceFileById 删除报销单其他单据中的附件
    get_deleteOtherInvoiceFileById(getData) {
        const _url = `${host.etcloudIvatApp}expense/ivatExpense/deleteOtherInvoiceFileById`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    // GET /expense/ivatExpense/downloadOtherInvoiceFileById 下载报销单其他单据附件
    get_downloadOtherInvoiceFileById(getData) {
        const _url = `${host.etcloudIvatApp}expense/ivatExpense/downloadOtherInvoiceFileById`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    // GET /expense/ivatExpense/getExpenseBillDetail 查询报销单票据的详情（上张id，当前票据，下张id）
    get_getExpenseBillDetail(getData) {
        const _url = `${host.etcloudIvatApp}expense/ivatExpense/getExpenseBillDetail`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    //GET /expense/ivatExpense/getInvoiceBillList 查询已有票据
    get_getInvoiceBillList(getData) {
        const _url = `${host.etcloudIvatApp}expense/ivatExpense/getInvoiceBillList`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    // GET /expense/ivatExpense/getExpenseDetailById 查看报销单详情
    get_getExpenseDetailById(getData) {
        const _url = `${host.etcloudIvatApp}expense/ivatExpense/getExpenseDetailById`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    //GET /expense/ivatExpense/getInvoiceBillList 查询已有票据
    get_getInvoiceBillList() {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}expense/ivatExpense/getInvoiceBillList`))
    }
    // POST /expense/ivatExpense/modifyExpenseItem 修改报销单据信息
    post_modifyExpenseItem(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}expense/ivatExpense/modifyExpenseItem`, postData), msg)
    }
    // POST /expense/ivatExpense/qryExpenseListOfPage 分页查询报销单数据
    post_qryExpenseListOfPage(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}expense/ivatExpense/qryExpenseListOfPage`, postData))
    }
    //POST /expense/ivatExpense/uploadOtherInvoiceFile 上传报销单其他单据-附件；返回附件id列表
    post_uploadOtherInvoiceFile(postData) {
        return this.request(() =>
            this.$http.post(`${host.etcloudIvatApp}expense/ivatExpense/uploadOtherInvoiceFile`, postData, {
                headers: {
                    'Content-Type': undefined,
                },
                transformRequest: angular.identity,
            })
        )
    }
    // GET /expense/ivatExpense/withdrawExpense 撤回报销单
    get_withdrawExpense(getData) {
        const _url = `${host.etcloudIvatApp}expense/ivatExpense/withdrawExpense`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }

    //GET /manage/scanInvoice/getIvatBillByBatchNo 根据批次号获取，扫描的票据列表
    get_getIvatBillByBatchNo(getData) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}manage/scanInvoice/getIvatBillByBatchNo?batchNo=${getData}`))
    }
    //GET /common/common/getFile 获取影像文件
    get_getFile(getData) {
        const _url = `${host.etcloudIvatApp}common/common/getFile`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }

    // GET /expense/ivatExpenseDeduction/batchSettingDeductionDate 批量设置抵扣属期
    get_batchSettingDeductionDate(getData) {
        const _url = `${host.etcloudIvatApp}expense/ivatExpenseDeduction/batchSettingDeductionDate`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    // GET /expense/ivatExpenseDeduction/exportDeductions 导出报销抵扣数据
    get_exportDeductions(getData) {
        const _url = `${host.etcloudIvatApp}expense/ivatExpenseDeduction/exportDeductions`
        const url = this.getParamUrl(getData, _url)
        window.open(url)
    }
    // POST /expense/ivatExpenseDeduction/qryDeductionListOfPage 分页查询报销抵扣数据
    post_qryDeductionListOfPage(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}expense/ivatExpenseDeduction/qryDeductionListOfPage`, postData), msg)
    }
    // POST /expense/ivatExpenseDeduction/qryDeductionStatisticsDetails 查看报销抵扣明细数据
    post_qryDeductionStatisticsDetails(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}expense/ivatExpenseDeduction/qryDeductionStatisticsDetails`, postData), msg)
    }
    // POST /expense/ivatExpenseDeduction/qryDeductionStatisticsSummary 查看报销抵扣汇总数据
    post_qryDeductionStatisticsSummary(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}expense/ivatExpenseDeduction/qryDeductionStatisticsSummary`, postData), msg)
    }

    // GET /auth/confirmCheck/qryHisAllConfirmStatisticDetail 退税勾选确认-查询历史确认明细-全部明细
    get_qryHisAllConfirmStatisticDetail(getData) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}auth/confirmCheck/qryHisAllConfirmStatisticDetail?periodCode=${getData}`))
    }
    // 智能赋码列表
    get_qrySmartGoodsInfo(postData) {
        return this.request(() =>
            this.$http.get(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierSmartCoding' : 'settings/sysSmartCoding'}/qryGoodsInfo`, {
                params: postData,
            })
        )
    }
    // 智能赋码查单个
    get_qrySmartGoodsInfoById(getdata) {
        return this.request(() =>
            this.$http.get(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierSmartCoding' : 'settings/sysSmartCoding'}/qryGoodsInfoById`, {
                params: getdata,
            })
        )
    }
    // 删除智能赋码
    post_delSmartGoodsInfo(postData) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierSmartCoding' : 'settings/sysSmartCoding'}/delGoodsInfo`, postData))
    }
    // 智能赋码检测编码
    post_checkTaxCode(postData) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierSmartCoding' : 'settings/sysSmartCoding'}/checkTaxCode`, postData))
    }
    // 智能赋码保存商品
    post_saveSmartGoodsInfo(postData) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloud : host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierSmartCoding' : 'settings/sysSmartCoding'}/saveGoodsInfo`, postData))
    }
    // POST /intf/sysInterface/getSysInterfaceList 分页查询接口配置
    post_getSysInterfaceList(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}intf/sysInterface/getSysInterfaceList`, postData))
    }
    // POST /intf/sysInterface/updateSysInterface 修改接口配置信息
    post_updateSysInterface(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}intf/sysInterface/updateSysInterface`, postData))
    }
    // GET /intf/sysInterface/getSysInterface 获取接口配置信息
    get_getSysInterface(getData) {
        return this.request(() => this.$http.get(`${host.etcloud}intf/sysInterface/getSysInterface?interfaceId=${getData}`))
    }
    // POST /intf/sysInterface/delSysInterface 删除接口配置信息
    get_delSysInterface(postData) {
        return this.request(() => this.$http.get(`${host.etcloud}intf/sysInterface/delSysInterface?interfaceId=${postData}`))
    }
    // POST /intf/sysInterface/addSysInterface 新增接口配置
    post_addSysInterface(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}intf/sysInterface/addSysInterface`, postData))
    }
    // POST /intf/sysInterfaceTemplate/getSysInterfaceTemplateList 分页查询接口模板
    post_getSysInterfaceTemplateList(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}intf/sysInterfaceTemplate/getSysInterfaceTemplateList`, postData))
    }
    // GET /intf/sysInterfaceTemplate/getSysInterfaceTemplate 获取接口模板
    get_getSysInterfaceTemplate(getData) {
        return this.request(() => this.$http.get(`${host.etcloud}intf/sysInterfaceTemplate/getSysInterfaceTemplate?templateId=${getData}`))
    }
    // /statistics/biInvoiceRate/queryIsRedInvoiceList
    post_queryIsRedInvoiceList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}statistics/biInvoiceRate/queryIsRedInvoiceList`, postData))
    }
    // GET /settings/sysRollticketSpec / getSysOrgRollticketSpecList 查询卷票规格
    get_getSysOrgRollticketSpecList() {
        return this.request(() => this.$http.get(`${host.etcloudOvat}${IS_PROVIDER ? 'supplier/sysSupplierRollticketSpec' : 'settings/sysRollticketSpec'}/getSysOrgRollticketSpecList`))
    }
    //GET auth/sysFunction/getSysFunctionList //查询全部菜单
    get_getSysFunctionListt() {
        return this.request(() => this.$http.get(`${host.etcloud}auth/sysFunction/getSysFunctionList`))
    }

    //GET auth/sysFunction/getFunctionUrlMap //菜单字段映射
    get_getFunctionUrlMap() {
        return this.request(() => this.$http.get(`${host.etcloud}auth/sysFunction/getFunctionUrlMap`))
    }
    // GET /settings/sysCustomer/exportToExcel 购方信息导出excel
    get_exportCustomer(getdata) {
        const _url = `${host.etcloudOvat}settings/sysCustomer/exportToExcel`
        const url = this.getParamUrl(getdata, _url)
        window.open(url)
    }
    // POST /supplier/sysSupplier/addSysSupplier
    post_addSysSupplier(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}supplier/sysSupplier/addSysSupplier`, postData))
    }
    // POST /supplier/sysSupplier / getSysSupplierList 分页查询销方
    post_getSysSupplierList(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}supplier/sysSupplier/getSysSupplierList `, postData))
    }
    // POST /supplier/sysSupplier / checkSysSupplier 检测供应商
    post_checkSysSupplier(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}supplier/sysSupplier/checkSysSupplier `, postData))
    }
    // POST /supplier/sysSupUser/getPageUserList 分页获取用户信息
    post_getPageUserList(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}supplier/sysSupUser/getPageUserList `, postData))
    }
    // POST /supplier/sysSupplier / modifySupplierAdminUse
    post_modifySupplierAdminUser(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}supplier/sysSupplier/modifySupplierAdminUser `, postData))
    }
    // POST / supplier / sysSupplier / modifySysSupplier
    post_modifySysSupplier(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}supplier/sysSupplier/modifySysSupplier `, postData))
    }
    // GET /supplier/sysSupplier/getSysSupplierById
    get_getSysSupplierById(getData) {
        return this.request(() => this.$http.get(`${host.etcloud}supplier/sysSupplier/getSysSupplierById?supplierId=${getData}`))
    }
    // POST /purchaser/supplierPurchaserRelation / pageQryPurchasers 分页查询购方信息数据
    post_pageQryPurchasers(postData) {
        return this.request(() => this.$http.post(`${host.etcloudSupplier}purchaser/supplierPurchaserRelation/pageQryPurchasers`, postData))
    }
    // POST /purchaser/supplierPurchaserRelation / importSupplierAndPurchaserRelations 导入（供应商购方关系）
    // GET /purchaser/supplierPurchaserRelation / downloadTemplate 下载模板
    // POST /purchaser/supplierPurchaserRelation / deleteSupplierAndPurchaserRelation 删除供应商购方关系
    post_deleteSupplierAndPurchaserRelation(postData) {
        const _url = `${host.etcloudSupplier}purchaser/supplierPurchaserRelation/deleteSupplierAndPurchaserRelation`
        const url = this.getParamUrl(postData, _url)
        return this.request(() => this.$http.post(url))
    }
    // GET /supplier/sysSupCustomer / getSysCustomerByOrgId 获取供应商购方信息
    get_getSysCustomerByOrgId(getData) {
        return this.request(() => this.$http.get(`${host.etcloud}supplier/sysSupCustomer/getSysCustomerByOrgId?custOrgId=${getData}`))
    }
    // GET /supplier/sysSupplier / delSysSupplierById 删除供应商
    get_delSysSupplierById(getData) {
        return this.request(() => this.$http.get(`${host.etcloud}supplier/sysSupplier/delSysSupplierById?supplierId=${getData}`))
    }
    // GET /supplier/sysSupplier / existsSupplierData 是否存在供应商业务数据
    get_existsSupplierData(getData, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}supplier/sysSupplier/existsSupplierData?supplierId=${getData}`), msg)
    }
    // POST /supplier/supLogin / checkUserLogin 当前用户是否已登陆
    post_checkUserLogin(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}auth/login/checkUserLogin`, postData))
    }
    // POST /tenant/sysPack / addSysPack 新增功能包
    post_addSysPack(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}/tenant/sysPack/addSysPack`, postData))
    }
    // GET /tenant/sysPack / getSysPack 获取功能包信息
    get_getSysPack(getData) {
        return this.request(() => this.$http.get(`${host.etcloud}tenant/sysPack/getSysPack?pickId=${getData}`))
    }
    // POST /tenant/sysPack / updateSysPack 修改功能包信息
    post_updateSysPack(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}tenant/sysPack/updateSysPack`, postData))
    }
    // POST /tenant/sysPack / getSysPackList 分页查询功能包列表
    post_getSysPackList(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}tenant/sysPack/getSysPackList`, postData))
    }
    // POST /tenant/sysPack / publishSysPack 发布 / 下架功能包
    post_publishSysPack(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}tenant/sysPack/publishSysPack`, postData))
    }
    // GET /statistics/biDimTaxRate/getEffectiveTaxRate
    get_getEffectiveTaxRate() {
        return this.request(() => this.$http.get(`${host.etcloudBiApp}statistics/biDimTaxRate/getEffectiveTaxRate`))
    }
    // 控制台详情页获取上一条下一条id
    post_qryTaskDetailOfPage(postData) {
        return this.request(() => this.$http.post(`${host.etcloudWorkflow}ovat/workFlow/qryTaskDetailOfPage`, postData))
    }
    // GET /ovat/workFlow / getWorkFlowTracks 根据业务主键获取最新的流程轨迹 -> v.1.2
    get_getWorkFlowTracks(getData) {
        const _url = `${host.etcloudWorkflow}ovat/workFlow/getWorkFlowTracks`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    //GET /expense/expenseConf/getIvatBxPzEnable 获取可用的报销规则配置
    get_getIvatBxPzEnable() {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}expense/expenseConf/getIvatBxPzEnable`))
    }
    // GET /expense/expenseConf / getIvatBxPzDTOList 获取报销规则配置
    get_getIvatBxPzDTOList(getData) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}expense/expenseConf/getIvatBxPzDTOList?needmx=${getData}`))
    }
    // POST /expense/expenseConf / saveIvatBxPzDTOList 保存报销规则配置
    post_saveIvatBxPzDTOList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}expense/expenseConf/saveIvatBxPzDTOList`, postData))
    }
    // POST /expense/expenseConf/updateIvatBxPzDTO 保存单个规则配置 / 单个启用，禁用修改
    post_updateIvatBxPzDTO(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}expense/expenseConf/updateIvatBxPzDTO`, postData))
    }
    // POST /manage/ivatBill/batchDeleteRepeatInvoice
    post_batchDeleteRepeatInvoice(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatBill/batchDeleteRepeatInvoice`, postData))
    }
    // POST /manage/ivatBill/batchDeleteBill 批量删除
    post_batchDeleteBill(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatBill/batchDeleteBill`, postData))
    }
    // POST /manage/ivatBill/getBatchAdjustBillList 得到批量校对信息
    post_getBatchAdjustBillList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatBill/getBatchAdjustBillList`, postData))
    }
    // GET /manage/ivatBill/importToExcel 发票导出excel
    get_importIvatBillToExcel(getData) {
        const _url = `${host.etcloudIvatApp}manage/ivatBill/importToExcel`
        const url = this.getParamUrl(getData, _url)
        window.open(url)
    }
    // GET /manage/ivatBill/exportToExcel 发票导出excel
    get_exportIvatBillToExcel(getData) {
        const _url = `${host.etcloudIvatApp}manage/ivatBill/exportToExcel`
        const url = this.getParamUrl(getData, _url)
        window.open(url)
    }
    // POST /manage/ivatBill/invoiceProofread 发票校对(new)
    post_invoiceProofread(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatBill/invoiceProofread`, postData))
    }
    // GET /manage/ivatBill/modifyBillDetail 修改
    get_modifyBillDetail(getData) {
        const _url = `${host.etcloudIvatApp}manage/ivatBill/modifyBillDetail`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    // POST /manage/ivatBill/saveBill 新增发票
    post_saveBill(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatBill/saveBill`, postData))
    }
    // GET /manage/ivatBill/selectBillDetailById 详情查询
    get_selectBillDetailById(getData) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}manage/ivatBill/selectBillDetailById?invoiceId=${getData}`))
    }
    // POST /manage/ivatBill/selectPageBill 分页查询
    post_selectPageBill(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatBill/selectPageBill`, postData))
    }
    // POST /manage/ivatBill/batchCalTurnoutBill 发票管理-批量取消转出
    post_batchCalTurnoutBill(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatBill/batchCalTurnoutBill`, postData))
    }
    // POST /manage/ivatBill/batchCalReceiptBill 发票管理-批量取消收票
    post_batchCalReceiptBill(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatBill/batchCalReceiptBill`, postData))
    }
    // POST /manage/ivatBill/batchReceiptBill 发票管理-批量收票
    post_batchReceiptBill(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatBill/batchReceiptBill`, postData))
    }
    // POST /manage/ivatBill/batchTurnoutBill 发票管理-批量转出
    post_batchTurnoutBill(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatBill/batchTurnoutBill`, postData))
    }
    // GET /settings/sysSfdqDm/getSysSfdqDmList 得到省份 城市 @王小波
    get_getSysSfdqDmList(getData) {
        // return this.request(() => this.$http.get(`${host.etcloud}settings/sysSfdqDm/getSysSfdqDmList?key=${key}`))
        const _url = `${host.etcloud}settings/sysSfdqDm/getSysSfdqDmList`
        const url = this.getParamUrl(getData, _url)
        return this.request(() => this.$http.get(url))
    }
    // POST /manage/ivatBill/selectBillIdList 收集&管理-票据分页查询
    post_selectBillIdList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatBill/selectBillIdList`, postData))
    }
    // 扫码开票待开
    // POST /ovatInvoiceScanWait/batchActivationQRCodes 批量激活二维码
    post_batchActivationQRCodes(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceScanWait/batchActivationQRCodes`, postDate), msg)
    }
    // POST /ovatInvoiceScanWait/batchAddScanInvoiceWait 批量添加生成待开扫码票
    post_batchAddScanInvoiceWait(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceScanWait/batchAddScanInvoiceWait`, postDate), msg)
    }
    // POST /ovatInvoiceScanWait/batchDeleteQRCodes 批量删除二维码（扫码待开）
    post_batchDeleteQRCodes(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceScanWait/batchDeleteQRCodes`, postDate), msg)
    }
    // GET /ovatInvoiceScanWait/getInvoiceDetailById 获取待开发票的商品明细信息
    get_getInvoiceDetailById(getData) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}ovatInvoiceScanWait/getInvoiceDetailById?waitId=${getData}`))
    }
    // POST /ovatInvoiceScanWait/qryQRCodeByBillNumberOfPage 分页获取待开二维码
    post_qryQRCodeByBillNumberOfPage(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceScanWait/qryQRCodeByBillNumberOfPage`, postDate), msg)
    }
    // POST /ovatInvoiceScanWait/qryQRCodeByBillNumbers 批量获取待开二维码
    post_qryQRCodeByBillNumbers(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceScanWait/qryQRCodeByBillNumbers`, postDate), msg)
    }
    // POST /ovatInvoiceScanWait/qryScanInvoiceWaitOfPage 分页查询扫码开票数据
    post_qryScanInvoiceWaitOfPage(postDate, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceScanWait/qryScanInvoiceWaitOfPage`, postDate), msg)
    }
    // 待开发票-批量删除待开发票
    post_batchDelOvatInvoiceWait(postData) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOvatInvoiceWait' : host.etcloudOvat + 'ovatInvoiceWait'}/batchDelOvatInvoiceWait`, postData))
    }
    // 购方管理-批量删除
    post_batchDeleteSysCustomer(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}settings/sysCustomer/batchDeleteSysCustomer`, postData))
    }
    //填开管理-快捷导入-拆分结果
    post_getBillSplitCountList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}/ovatInvoiceWait/getBillSplitCountList`, postData))
    }
    // 待开发票-批量回退
    post_batchReductionOvatInvoiceWait(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceWait/batchReductionOvatInvoiceWait`, postData))
    }
    //oauth客户端接口-列表
    post_listClientDetails(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOpenapi}client/uimsClientDetails/listClientDetails`, postData))
    }
    //oauth客户端接口-新增
    post_addClientDetails(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOpenapi}client/uimsClientDetails/addClientDetails`, postData))
    }
    //oauth客户端接口-详情
    get_qryClientDetails(getData) {
        return this.request(() => this.$http.get(`${host.etcloudOpenapi}client/uimsClientDetails/qryClientDetails?clientId=${getData}`))
    }
    //oauth客户端接口-更新
    post_updateClientDetails(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOpenapi}client/uimsClientDetails/updateClientDetails`, postData))
    }
    //oauth客户端接口-更新密钥
    get_updateClientSecret(getData) {
        return this.request(() => this.$http.get(`${host.etcloudOpenapi}client/uimsClientDetails/updateClientSecret?clientId=${getData}`))
    }
    //oauth客户端接口-启用/禁用
    get_updateStatus(getData) {
        return this.request(() => this.$http.get(`${host.etcloudOpenapi}client/uimsClientDetails/updateStatus?clientId=${getData.id}&status=${getData.status}&interfaceType=${getData.interfaceType}`))
    }
    //外部接口事件类型
    get_getTenantExteralApi(getData, type) {
        return this.request(() => this.$http.get(`${host.etcloud}auth/sysExternalApi/getTenantExteralApi?tenantId=${getData}&apiType=${type}`))
    }
    // GET /verify/iIvatInvoiceVerify/bulidPdf 下载报销单其他单据附件
    post_bulidPdf(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}verify/iIvatInvoiceVerify/bulidPdf`, postData))
    }
    // GET /verify/iIvatInvoiceVerify/getFileInfoList
    get_getFileInfoList(getData) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}verify/iIvatInvoiceVerify/getFileInfoList?invoiceCode=${getData.invoiceCode}&invoiceNumber=${getData.invoiceNumber}`))
    }
    // POST /ovatInvoiceWait/getInvoiceWaitStatics
    post_getInvoiceWaitStatics(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceWait/getInvoiceWaitStatics`, postData))
    }
    // GET /ovatBill/batchAbolishBill 批量作废销售单
    get_batchAbolishBill(getData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatBill/batchAbolishBill`, getData))
    }
    // GET /ovatBill/batchDelBill 批量删除销售单
    get_batchDelBill(getData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatBill/batchDelBill`, getData))
    }
    //  购方、商品信息导入覆盖/跳过
    post_confirmData(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}dlTaskService/confirmData`, postData))
    }
    //  同步 金税盘 购方、商品信息 初始化
    post_initBatch(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}dlTaskService/initBatch_${postData.code}`, postData))
    }
    //  同步 金税盘 购方、商品信息 导入
    post_addDlBatchData(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}dlTaskService/addDlBatchData`, postData))
    }
    // POST /manage/ivatBill/batchSubmitBill 发票管理-票据提交
    post_batchSubmitBill(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatBill/batchSubmitBill`, postData))
    }
    // 电子底账手动查验
    post_batchCommitVer(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/originalInvoice/batchCommitVer`, postData))
    }
    // NOTE: 查询当前上报标记信息
    fetchDeclareSign(params, msg) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}declareTax/queryDeclareSign?diskNo=${params.diskNo}&type=${params.type}`), msg)
    }

    // NOTE: 更新标记状态
    updateDeclearSign(data) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}declareTax/updateDeclareSign`, data))
    }

    // NOTE: 查询弹窗消息
    fetchNoReaderNotice(msg) {
        return this.request(() => this.$http.get(`${host.cloud}settings/sysNotice/getNoReadPoPNotice`), msg)
    }

    // NOTE: 获取消息列表
    fetchMessageList(data, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysNotice/getNoticeByUser`, data), msg)
    }

    // NOTE: 设置所有为已读
    setAllReaded() {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysNotice/updateUserNoticeRead`))
    }

    // NOTE: 批量修改已读
    setMessageReaded(data) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysNotice/updateReadForNotice`, data))
    }

    // NOTE: 批量删除
    deleteMessage(data) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysNotice/deleteNotice`, data))
    }

    // NOTE: 查询消息详情
    fetchNoticeByNoticeId(noticeId, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}settings/sysNotice/getNotice?noticeId=${noticeId}`), msg)
    }

    // NOTE: 查询消息的总数和未读量
    fetchMessageTotal(msg) {
        return this.request(() => this.$http.get(`${host.etcloud}settings/sysNotice/getNoticeStatics`), msg)
    }

    // NOTE: 查询需要弹窗显示的信息
    fetchPopNotice() {
        return this.request(() => this.$http.get(`${host.etcloud}settings/sysNotice/getNoReadPoPNotice`))
    }

    // NOTE: 弹窗不再提醒
    updateMessageNeverMind(data) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysNotice/updateNoRemindNotice`, data))
    }

    // 进项商品统计 导出
    get_exportStatisticsGoods(data) {
        const _url = `${host.etcloudBiApp}statistics/biIvatGoodsStatistics/exportStatisticsGoods`
        const url = encodeURI(this.getParamUrl(data, _url))
        console.log(url)
        return
        window.open(url)
    }
    // 商品统计关联发票
    post_qryGoodsRelationInvoiceList(data) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}statistics/biIvatGoodsStatistics/qryGoodsRelationInvoiceList`, data))
    }
    // 商品统计列表
    post_queryGoogdStatisticsList(data) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}statistics/biIvatGoodsStatistics/qryGoodsStatisticsList`, data))
    }
    // 商品统计总计
    post_statisticsGoodsList(data) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}statistics/biIvatGoodsStatistics/statisticsGoodsList`, data))
    }
    // POST /ovatRedInfo/batchOpeningRedInfo 红字信息表批量开票-生成对应的待开发票（全部红冲）
    post_batchOpeningRedInfo(data) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatRedInfo/batchOpeningRedInfo`, data))
    }
    // POST /ovatRedInfo/batchReductionOvatRedInfo 批量回退红字信息表
    post_batchReductionOvatRedInfo(data) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatRedInfo/batchReductionOvatRedInfo`, data))
    }
    // POST /ovatRedInfo/openingRedInfo 红字信息表开票-生成对应的待开发票（支持部分红冲，全部红冲）
    post_openingRedInfo(data) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatRedInfo/openingRedInfo`, data))
    }
    // POST /ovatRedInfo/reddingFailedBackWrite 红字信息表开票-开票失败后回写
    post_openingFailedBackWrite(data) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatRedInfo/openingFailedBackWrite`, data))
    }
    // POST /openedInvoice/lockOvatInvoice锁定已开发票
    post_lockOvatInvoice(postdata) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}openedInvoice/lockOvatInvoice`, postdata))
    }
    // POST /ovatRedInfo/lockOvatRedInfo 锁定红字信息表
    post_lockOvatRedInfo(data) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatRedInfo/lockOvatRedInfo`, data))
    }
    //POST /openedInvoice/reddingInvoice 红冲发票-生成对应待开红票（支持部分红冲，全部红冲）
    post_reddingInvoice(data) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}openedInvoice/reddingInvoice`, data))
    }
    //POST /openedInvoice/saveInvoicePrintConfPage 保存打印参数
    post_saveInvoicePrintConfPage(data) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}openedInvoice/saveInvoicePrintConfPage`, data))
    }
    //GET /ovatRedInfo/getOvatInvoiceWaitByInfoId 红字信息表转待开
    get_getOvatInvoiceWaitByInfoId(getData) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}ovatRedInfo/getOvatInvoiceWaitByInfoId?infoId=${getData}`))
    }
    //POST manage/ivatBill/batchRegressionBill 发票管理回退
    post_batchRegressionBill(data) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatBill/batchRegressionBill`, data))
    }
    // POST /agentTaxDisk/agentOpenElecInvoice 托管开具电子票
    post_agentOpenElecInvoice(data) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}agentTaxDisk/agentOpenElecInvoice`, data))
    }
    // GET /settings/sysCustomer/exportToTxt 购方信息导出txt
    get_exportToTxt(getdata) {
        const _url = `${host.etcloudOvat}settings/sysCustomer/exportToTxt`
        let dataStr = '' // 数据拼接字符串
        Object.keys(getdata).forEach((key) => {
            dataStr += `${key}=${getdata[key]}&`
        })
        dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
        const newurl = `${_url}?${dataStr}`
        window.open(newurl)
    }
    // 权限管理   新增部门
    post_addDepartment(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysDepartment/addDepartment`, postData), msg)
    }
    // 权限管理   删除部门
    get_delDepartment(getdata, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysDepartment/delDepartment?departmentId=${getdata}`), msg)
    }
    // 权限管理   编辑部门信息
    post_editDepartment(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysDepartment/editDepartment`, postData), msg)
    }
    // 权限管理   分页查询部门列表
    post_qryDepartmentList(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysDepartment/qryDepartmentList`, postData))
    }
    // 权限管理   查询部门详情
    get_qryDepartmentInfo(getdata) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysDepartment/qryDepartmentInfo?departmentId=${getdata}`))
    }
    // GET /auth/ivatDeductionCheck/getHeaderData 获取勾选头部金额、税额统计数据
    get_getHeaderData(data, orgId) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}auth/ivatDeductionCheck/getHeaderData?checkFlag=${data}&orgId=${orgId}`))
    }
    // POST /auth/ivatDeductionCheck/qryInvoiceCheckOfPage 勾选发票分页查询
    post_qryInvoiceCheckOfPage(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatDeductionCheck/qryInvoiceCheckOfPage`, postData))
    }
    // GET /auth/ivatDeductionCheck/getIsCheckOrNotOperate 查询当前是否可以做勾选或取消勾选操作。true-可以；false-不可以
    get_getIsCheckOrNotOperate({ periodCode, checkType }) {
        let url = `${host.etcloudIvatApp}auth/ivatDeductionCheck/getIsCheckOrNotOperate?periodCode=${periodCode}`
        if (checkType) {
            url += `&checkType=1`
        }
        return this.request(() => this.$http.get(url))
    }
    // POST /auth/ivatDeductionCheck/updateCheckStatusLocal 发票勾选状态更改（单机版）
    post_updateCheckStatusLocal(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatDeductionCheck/updateCheckStatusLocal`, postData))
    }
    // POST /auth/ivatDeductionCheck/updateCheckStatusServer 发票勾选状态更改（服务器版）
    post_updateCheckStatusServer(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatDeductionCheck/updateCheckStatusServer`, postData))
    }
    // GET /auth/ivatDeductionCheckStatSign/invoiceStatQuery 抵扣勾选统计-统计查询
    get_invoiceStatQuery(param) {
        let url = `${host.etcloudIvatApp}auth/ivatDeductionCheckStatSign/invoiceStatQuery?month=${param.month}&type=${param.type}&isRefresh=${param.isRefresh}`
        if (param.responseStr) {
            url += `&responseStr=${param.responseStr}`
        }
        if (param.deviceType) {
            url += `&deviceType=${param.deviceType}`
        }
        if (param.diskType) {
            url += `&diskType=${param.diskType}`
        }
        return this.request(() => this.$http.get(url))
    }

    // GET /auth/ivatDeductionCheckStatSign/isDeclareTime 当前是不是申报所属期 true 申报期
    get_isDeclareTime() {
        let url = `${host.etcloudIvatApp}auth/ivatDeductionCheckStatSign/isDeclareTime`
        return this.request(() => this.$http.get(url))
    }

    // POST /auth/ivatDeductionCheckStatSign/pageQueryInvoiceDetail 抵扣勾选统计-发票明细表
    post_pageQueryInvoiceDetail(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatDeductionCheckStatSign/pageQueryInvoiceDetail`, postData))
    }

    // POST /auth/ivatDeductionCheckStatSign/pageQueryCustomsBillDetail 海关缴款书勾选统计-明细表分页查询
    post_pageQueryCustomsBillDetail(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatDeductionCheckStatSign/pageQueryCustomsBillDetail`, postData))
    }

    // GET /auth/ivatDeductionCheckStatSign/statSign 抵扣勾选统计-1申请统计 2撤销统计 3确认签名 4撤销签名
    get_statSign(param) {
        let url = `${host.etcloudIvatApp}auth/ivatDeductionCheckStatSign/statSign?applyType=${param.applyType}`
        if (param.responseStr) {
            url += `&responseStr=${param.responseStr}`
        }
        if (param.platPassword) {
            url += `&platPassword=${param.platPassword}`
        }
        if (param.deductionPassword) {
            url += `&deductionPassword=${param.deductionPassword}`
        }
        if (param.deviceType) {
            url += `&deviceType=${param.deviceType}`
        }
        if (param.type) {
            url += `&type=${param.type}`
        }
        if (param.diskType) {
            url += `&diskType=${param.diskType}`
        }
        return this.request(() => this.$http.get(url))
    }
    // GET 查询当前机构可分配的开票点
    get_qryAssignUkeyList(orgId) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysUkey/qryAssignUkeyList?orgId=${orgId}`))
    }

    // GET /settings/sysGoodsInfo/qryPublicGoodsInfo 共用商品列表查询
    post_qryPublicGoodsInfo(str) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}settings/sysGoodsInfo/qryPublicGoodsInfo`, str))
    }
    // POST /settings/sysGoodsInfo/syncGoodsInfo 商品同步
    post_syncGoodsInfo(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}settings/sysGoodsInfo/syncGoodsInfo`, postData))
    }
    // POST /settings/sysVehicleGood/syncVehicleGood 车辆编码同步
    post_syncVehicleGood(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}settings/sysVehicleGood/syncVehicleGood`, postData))
    }
    // GET /settings/sysVehicleGood/qryPublicVehicleGood 共用车辆编码列表查询
    post_qryPublicVehicleGood(str) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}settings/sysVehicleGood/qryPublicVehicleGood`, str))
    }
    // POST /settings/sysVehicleGood/syncAllVehicleGood
    post_syncAllVehicleGood(str) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}settings/sysVehicleGood/syncAllVehicleGood?allStr=${str}`))
    }
    // POST /settings/sysGoodsInfo/syncAllGoodsInfo 同步全部商品
    post_syncAllGoodsInfo(str) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}settings/sysGoodsInfo/syncAllGoodsInfo?allStr=${str}`))
    }
    // GET /ems/sysOrganization/getUserOrgListByUserId
    get_getUserOrgListByUserId(userId, userType, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysOrganization/getUserOrgListByUserId?userId=${userId}&userType=${userType}`), msg)
    }

    // POST /ems/sysOrganization/getSysOrganizationInfoList 获取机构列表及机构下角色、开票点
    post_getNotPageSysOrganizationInfoList(orgId) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysOrganization/getSysOrganizationInfoList?orgId=${orgId}`))
    }
    // POST ems/sysOrganization/getPageSysOrganizationInfo 获取机构列表及机构下角色、开票点 分页
    post_getSysOrganizationInfoList(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysOrganization/getPageSysOrganizationInfo`, postData))
    }
    //GET /auth/ivatDeductionCheck/getInvoiceByGun 二维码扫码勾选功能
    get_getInvoiceByGun(getData, msg) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}auth/ivatDeductionCheck/getInvoiceByGun?content=${getData}`), msg)
    }
    // /etcloud-ivat/auth/originalInvoice/getIvatOriginalInvoiceStatics  电子底账
    post_getIvatOriginalInvoiceStatics(str) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/originalInvoice/getIvatOriginalInvoiceStatics`, str))
    }
    // /etcloud-ivat/manage/ivatBill/getIvatBillStatics   进项发票收集管理
    post_getIvatBillStatics(str) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatBill/getIvatBillStatics`, str))
    }
    // POST /manage/scanInvoice/asyncUploadBatchDelBill *发票收集异步上传 识别进度删除
    post_asyncUploadBatchDelBill(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/scanInvoice/asyncUploadBatchDelBill`, postData), msg)
    }
    // GET /manage/scanInvoice/asyncUploadBatchDistStatusList *发票收集异步上传-查询识别进度
    get_asyncUploadBatchDistStatusList() {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}manage/scanInvoice/asyncUploadBatchDistStatusList`))
    }
    // POST /manage/scanInvoice/asyncUploadDelFile *发票收集异步上传-删除取消上传文件
    post_asyncUploadDelFile(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/scanInvoice/asyncUploadDelFile`, postData))
    }
    // POST /manage/scanInvoice/asyncUploadSaveFile *发票收集异步上传-文件上传
    post_asyncUploadSaveFile(postData) {
        return this.request(() =>
            this.$http.post(`${host.etcloudIvatApp}manage/scanInvoice/asyncUploadSaveFile`, postData, {
                headers: {
                    'Content-Type': undefined,
                },
                transformRequest: angular.identity,
            })
        )
    }
    // POST /manage/scanInvoice/asyncUploadStartDist *发票收集异步上传-确认开始识别
    post_asyncUploadStartDist(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/scanInvoice/asyncUploadStartDist`, postData), msg)
    }
    //GET /manage/scanInvoice/getUploadBatchNo 发票收集异步上传-获取上传批次号
    get_getUploadBatchNo(getdata) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}manage/scanInvoice/getUploadBatchNo`))
    }
    //POST /cancelAndReopenInvoice/writeUpdateBackReopenInvoice 重开发票结果回写
    post_writeUpdateBackReopenInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scCancelAndReopenInvoice' : host.etcloudOvat + 'cancelAndReopenInvoice'}/writeUpdateBackReopenInvoice`, postData), msg)
    }
    // /ovatBill/beforeMergeBill
    post_beforeMergeBill(postdata) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatBill/beforeMergeBill`, postdata))
    }
    //POST /erp/ovatCustomCollect/batchCollectBills 客户端采集-批量采集销售单据
    post_batchCollectBills(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}erp/ovatCustomCollect/batchCollectBills`, postdata), msg)
    }
    //GET /erp/ovatCustomCollect/getBillDetailByBillId 客户端采集-获取单据详情
    get_getBillDetailByBillId(getdata) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}erp/ovatCustomCollect/getBillDetailByBillId?billId=${getdata.billId}&kdAccountId=${getdata.kdAccountId}`))
    }
    //POST /erp/ovatCustomCollect/getCollectResult 根据采集批次号，获取采集结果
    post_getCollectResult(postdata) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}dlTaskService/getPageDlBatchInfoList`, postdata))
    }
    //POST /erp/ovatCustomCollect/qryBillOfPage 客户端采集-分页查询
    post_qryBillOfPage(postdata) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}erp/ovatCustomCollect/qryBillOfPage`, postdata))
    }
    //GET /erp/ovatCustomCollect/getCollectCountResult 采集结果，返回成功/失败条数
    get_getCollectCountResult(batchNo) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}dlTaskService/getSysDlBatch?batchNo=${batchNo}`))
    }
    //GET /client/uimsClientDataSourcesConfig/getDataSourcesConfigByTenantId 根据TenantID查询配置文件
    get_getDataSourcesConfigByTenantId(id, msg) {
        return this.request(() => this.$http.get(`${host.etcloudOpenapi}client/uimsClientDataSourcesConfig/getDataSourcesConfigByTenantId?tenantId=${id}`), msg)
    }
    //GET /client/uimsClientDataSourcesConfig/getSelectKdAccountListByTenantId 根据tanantid查询可用帐套列表
    get_getSelectKdAccountListByTenantId(id) {
        return this.request(() => this.$http.get(`${host.etcloudOpenapi}client/uimsClientDataSourcesConfig/getSelectKdAccountListByTenantId?tenantId=${id}`))
    }
    // GET /client/uimsClientDataSourcesConfig/getDataSourcesConfigByClientId    根据app id查询配置文件
    get_getDataSourcesConfigByClientId(id) {
        return this.request(() => this.$http.get(`${host.etcloudOpenapi}client/uimsClientDataSourcesConfig/getDataSourcesConfigByClientId?clientId=${id}`))
    }
    // POST /client/uimsClientDataSourcesConfig/getDataSourcesLinkState  测试连接 还未确定参数
    post_getDataSourcesLinkState(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOpenapi}client/uimsClientDataSourcesConfig/getDataSourcesLinkState`, postData))
    }
    // POST /client/uimsClientDataSourcesConfig/getInitScriptByParam 查询类型脚本
    post_getInitScriptByParam(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOpenapi}client/uimsClientDataSourcesConfig/getInitScriptByParam`, postData))
    }
    // POST /client/uimsClientDataSourcesConfig/initScript2Client  向客户端发送脚本初始化 还未确定参数
    post_initScript2Client(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOpenapi}client/uimsClientDataSourcesConfig/initScript2Client`, postData))
    }
    // POST /client/uimsClientDataSourcesConfig/addOrModDataSourcesConfig 数据采集数据源配置保存修改
    post_addOrModDataSourcesConfig(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOpenapi}client/uimsClientDataSourcesConfig/addOrModDataSourcesConfig`, postData))
    }
    // POST /client/uimsClientDataSourcesConfig/doLinkAndInitAccountClient 自动获取帐套信息
    post_doLinkAndInitAccountClient(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOpenapi}client/uimsClientDataSourcesConfig/doLinkAndInitAccountClient`, postData))
    }
    // POST /openedInvoice/getBatchElePrintUrl 电子发票批量打印第一步：获取标识
    post_getBatchElePrintUrl(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat + 'openedInvoice'}/getBatchElePrintUrl`, postData))
    }
    // POST /openedInvoice/getInvoicePrintConfPage 打印参数列表
    post_getInvoicePrintConfPage(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat + 'openedInvoice'}/getInvoicePrintConfPage`, postData))
    }
    // POST /ovatBill/billTotal 销售单统计
    post_billTotal(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat + 'ovatBill'}/billTotal`, postData))
    }
    // POST /settings/sysGoodsMapping/page 商品对照表列表查询
    post_sysGoodsMapping(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}settings/sysGoodsMapping/page`, postData))
    }
    // GET 商品对照表查询详情
    get_sysGoodsMappingQry(mappingId) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}settings/sysGoodsMapping/qry?mappingId=${mappingId}`))
    }
    // POST settings/sysGoodsMapping/add 商品对照表新增
    post_sysGoodsMappingAdd(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}settings/sysGoodsMapping/add`, postData), msg)
    }
    // POST settings/sysGoodsMapping/edit 商品对照表编辑
    post_sysGoodsMappingEdit(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}settings/sysGoodsMapping/edit`, postData), msg)
    }
    // GET 商品对照表删除
    get_sysGoodsMappingDel(mappingId, msg) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}settings/sysGoodsMapping/del?mappingId=${mappingId}`), msg)
    }
    // 发票勾选查询导入错误信息
    post_getPageDlBatchInfoListIvat(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}dl/dlTaskService/getPageDlBatchInfoList`, postData))
    }
    // 发票勾选查询导入成功发票
    post_qryDlBatchInfoSuc(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}dl/dlTaskService/qryDlBatchInfoSuc`, postData))
    }
    // POST /dl/dlTaskService/qryCustomsDlBatchInfoSuc 缴款书导入勾选校验成功的票
    post_qryCustomsDlBatchInfoSuc(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}dl/dlTaskService/qryCustomsDlBatchInfoSuc`, postData))
    }
    //GET /auth/originalInvoice/getNormalBlueInvoiceDetial 查询电子底账明细
    get_getNormalBlueInvoiceDetial(id) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}auth/originalInvoice/getNormalBlueInvoiceDetial?invoiceAccountId=${id}`))
    }
    // 报销抵扣-凭证推送-查看
    get_getExpenseVoucher(expenseId) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}expense/ivatExpenseVoucher/getExpenseVoucher?expenseId=${expenseId}`))
    }
    // 报销抵扣-凭证推送-编辑
    post_updateExpenseVoucher(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}expense/ivatExpenseVoucher/updateExpenseVoucher`, postData))
    }
    // 报销抵扣-凭证推送-推送
    post_pushExpenseVoucher(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}expense/ivatExpenseVoucher/pushExpenseVoucher`, postData))
    }
    get_checkIvatRuleConf() {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}/ruleset/ivatRuleConf/checkIvatRuleConf`))
    }
    // 商品对照表-批量删除
    get_sysGoodsMappingBatchDel(mappingIds) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}settings/sysGoodsMapping/batchDel?mappingIdList=${mappingIds}`))
    }
    // POST /ovatInvoiceWait/scanGetInvoiceTitle 根据二维码获取发票抬头
    post_scanGetInvoiceTitle(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceWait/scanGetInvoiceTitle`, postData), false)
    }
    post_getJSONObject(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}common/common/getJSONObject`, postData))
    }
    // GET /ems/sysTaxDisk/getDiskByDiskNoDiskCode 根据硬件编号和分机号获取金税盘信息
    get_getDiskByDiskNoDiskCode(no, code) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysTaxDisk/getDiskByDiskNoDiskCode?diskNo=${no}&diskCode=${code}`))
    }
    // 根据金税盘编号获取金税盘信息
    get_getDiskByCode(data, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysTaxDisk/getDiskByCode?orgId=${data.orgId}&diskCode=${data.diskCode}`), msg)
    }
    // A9获取库存 qryStock
    post_qryStock(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceRequest/qryStock`, postData))
    }
    // 分页查询金税盘POST /ems/sysTaxDisk/getSysTaxDiskList
    post_getSysTaxDiskList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}${IS_PROVIDER ? 'supplier/sysSupplierTaxDisk' : 'ems/sysTaxDisk'}/getSysTaxDiskList`, postData), msg)
    }
    // A9空白作废ovatInvoiceRequest/blankCancelInv
    post_blankCancelInv(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceRequest/blankCancelInv`, postData))
    }
    // 税控设备新增 /ems/sysInvoiceServer/saveSysInvoiceServer
    post_saveSysInvoiceServer(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysInvoiceServer/saveSysInvoiceServer`, postData))
    }
    // 税控设备编辑 /ems/sysInvoiceServer/uptSysInvoiceServer
    put_uptSysInvoiceServer(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysInvoiceServer/uptSysInvoiceServer`, postData))
    }
    // 税控设备列表 /ems/sysInvoiceServer/getPageServerList
    post_getPageServerList(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysInvoiceServer/getPageServerList`, postData))
    }
    // 纳税人识别号列表 /ems/sysInvoiceServer/getPageSaleInfoList
    post_getPageSaleInfoList(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysInvoiceServer/getPageSaleInfoList`, postData))
    }
    // 根据纳税人同步服务器金税盘 /ems/sysTaxDisk/syncDisk
    post_sysTaxDiskSyncDisk(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysTaxDisk/syncDisk`, postData))
    }
    // admin金税盘同步终端信息 /ems/sysUkey/syncUkey
    post_sysUkeySyncUkey(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysUkey/syncUkey`, postData))
    }
    // admin用户同步获取服务器终端信息获取ukey信息 /ems/sysUkey/syncUkey
    get_getSysUkeyListByDiskId(data) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysUkey/getSysUkeyListByDiskId?orgId=${data.orgId}&diskId=${data.diskId}`))
    }
    // 根据批次号获取同步结果
    get_sysServerSyncBatch(batchNo) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysServerSyncBatch/selectByPrimaryKey?batchNo=${batchNo}`))
    }
    // GET /ovatInvoiceRequest/openInvoice 根据待开id开具发票
    post_openInvoice(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceRequest/openInvoice`, postData))
    }
    //GET /ovatInvoiceRequest/cancelOpenInv 已开发票作废
    get_cancelOpenInv(id) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}ovatInvoiceRequest/cancelOpenInv?invoiceId=${id}`))
    }
    // a9红字信息表上传
    post_uploadRedInfo(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceRequest/uploadRedInfo`, postData))
    }
    //ovatInvoiceRequest/downLoadRedInfo a9红字信息表下载
    post_downLoadRedInfo(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceRequest/downLoadRedInfo`, postData))
    }
    // POST /ovatInvoiceRequest/reopenInvoice 发票重开
    post_a9ReopenInvoice(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceRequest/reopenInvoice`, postData))
    }
    // 认证统计导出海关缴款书明细
    get_exportExportCustomsPayment(getData) {
        const _url = `${host.etcloudIvatApp}statistics/ivatAuthStatistics/exportCustomsPayment`
        const url = this.getParamUrl(getData, _url)
        window.open(url)
    }
    // 认证统计导出勾选详情
    get_exportExportCheckDetail(getData) {
        const _url = `${host.etcloudIvatApp}statistics/ivatAuthStatistics/exportCheckDetail`
        const url = this.getParamUrl(getData, _url)
        window.open(url)
    }
    // 认证统计导出未勾选明细
    get_exportExportNoCheckData(getData) {
        const _url = `${host.etcloudIvatApp}statistics/ivatAuthStatistics/exportNoCheckData`
        const url = this.getParamUrl(getData, _url)
        window.open(url)
    }
    // 认证统计勾选详情
    // GET /statistics/ivatAuthStatistics/getCheckDetail
    get_ivatAuthStatisticsCheckDetail(data) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}statistics/ivatAuthStatistics/getCheckDetail?creditCode=${data.creditCode}&periodCode=${data.periodCode}`))
    }
    //statistics/ivatAuthStatistics/getCustomsPayment 获取海关缴款书明细
    post_getCustomsPayment(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}statistics/ivatAuthStatistics/getCustomsPayment`, postData))
    }
    //statistics/ivatAuthStatistics/getInvoiceDetail 认证统计获取发票明细
    post_ivatAuthStatisticsInvoiceDetail(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}statistics/ivatAuthStatistics/getInvoiceDetail`, postData))
    }
    //statistics/ivatAuthStatistics/getNoCheckData 认证统计未勾选数据
    post_noCheckData(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}statistics/ivatAuthStatistics/getNoCheckData`, postData))
    }

    // /POST /manage/ivatBill/batchVerifyBill 发票收集-发票查验
    post_batchVerifyBill(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatBill/batchVerifyBill`, postData))
    }

    // POST /auth/ivatCustomsPaymentBill/qryCustomsOfPage 分页查询缴款书数据
    post_qryCustomsOfPage(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatCustomsPaymentBill/qryCustomsOfPage`, postData))
    }

    // POST /auth/ivatCustomsPaymentBill/exportToExcel 导出海关税款书数据
    post_exportToExcel(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatCustomsPaymentBill/exportToExcel`, postData))
    }

    // POST /auth/ivatCustomsPaymentBill/getCustomsInvoiceStatics 缴款书统计
    post_getCustomsInvoiceStatics(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatCustomsPaymentBill/getCustomsInvoiceStatics`, postData))
    }

    // GET /auth/ivatCustomsPaymentCheck/getHeaderData  缴款书勾选头部统计数据
    get_CP_getHeaderData(checkFlag) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}auth/ivatCustomsPaymentCheck/getHeaderData?checkFlag=${checkFlag}`))
    }

    // POST /auth/ivatCustomsPaymentCheck/qryCheckBillOfPage  缴款书勾选分页查询
    post_qryCheckBillOfPage(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatCustomsPaymentCheck/qryCheckBillOfPage`, postData))
    }

    // POST /auth/ivatCustomsPaymentCheck/updateCheckStatusServer 缴款书勾选状态更改（服务器版）
    post_CP_updateCheckStatusServer(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatCustomsPaymentCheck/updateCheckStatusServer`, postData))
    }

    // POST /auth/ivatCustomsPaymentCheck/updateCheckStatusLocal 缴款书勾选状态更改（单机版）
    post_CP_updateCheckStatusLocal(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatCustomsPaymentCheck/updateCheckStatusLocal`, postData))
    }
    // 生成桌台二维码
    get_createQrCust(id) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysDepartment/createQrCust?departmentId=${id}`))
    }
    // post /auth/ivatDeductionCheckStatSign/dkBaseInfoQuery 抵扣基本信息获取
    post_dkBaseInfoQuery(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatDeductionCheckStatSign/dkBaseInfoQuery`, postData))
    }

    // post /auth/ivatDeductionCheckStatSign/backTaxPeriod 回退所属期
    post_backTaxPeriod(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatDeductionCheckStatSign/backTaxPeriod`, postData))
    }

    // GET /auth/ivatDrawbackCheck/getHeaderData 获取勾选头部金额/税额统计数据
    get_ivatDrawbackCheck_getHeaderData() {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}auth/ivatDrawbackCheck/getHeaderData`))
    }
    // POST /ovatBill/billRangeCommit*销售单批量提交
    post_billRangeCommit(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatBill/billRangeCommit`, postData))
    }
    // POST /ovatRedInfo/submitWorkflowRange 批量提交审核
    post_submitWorkflowRange(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatRedInfo/submitWorkflowRange`, postData))
    }
    // POST /ovatInvoiceWait/batchSubmitWaitRange 批量范围提交待开发票
    post_batchSubmitWaitRange(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceWait/batchSubmitWaitRange`, postData))
    }
    //获取扫码提交购方信息
    post_getSysDepartmentQrCust(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysDepartmentQrCust/page`, postData))
    }
    //扫码购方信息删除
    del_sysDepartmentQrCust(idList, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysDepartmentQrCust/delete?custIdList=${idList}`), msg)
    }
    //扫码购方信息更新
    get_updateForUsed(custId) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysDepartmentQrCust/updateForUsed?custId=${custId}`))
    }
    // POST /manage/ivatBillExtend/pageTurnoutAccount 进项转出台账-分页列表
    post_pageTurnoutAccount(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatBillExtend/pageTurnoutAccount`, postData))
    }
    // GET /manage/ivatBillExtend/exportTurnoutAccount 进项转出台账-导出列表
    // GET /manage/ivatBillExtend/turnoutAccountDetail 进项转出台账-票据详情
    get_turnoutAccountDetail(invoiceId) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}manage/ivatBillExtend/turnoutAccountDetail?invoiceId=${invoiceId}`))
    }
    // GET /manage/ivatBillExtend/turnoutAccountStatistics 进项转出台账-转出统计
    get_turnoutAccountStatistics(turnoutPeriod) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}manage/ivatBillExtend/turnoutAccountStatistics?turnoutPeriod=${turnoutPeriod}`))
    }
    // POST /manage/ivatBillExtend/turnoutAccountSum 进项转出台账-总计
    post_turnoutAccountSum(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatBillExtend/turnoutAccountSum`, postData))
    }

    // POST /auth/ivatDrawbackCheck/qryInvoiceCheckOfPage 获取退税勾选列表数据
    post_ivatDrawbackCheck_qryInvoiceCheckOfPage(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatDrawbackCheck/qryInvoiceCheckOfPage`, postData))
    }

    // POST /auth/ivatDrawbackCheck/updateCheckStatusLocal 退税勾选状态更改（单机版）
    post_ivatDrawbackCheck_updateCheckStatusLocal(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatDrawbackCheck/updateCheckStatusLocal`, postData))
    }

    // POST /auth/ivatDrawbackCheck/updateCheckStatusServer 退税勾选状态更改（服务器版）
    post_ivatDrawbackCheck_updateCheckStatusServer(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatDrawbackCheck/updateCheckStatusServer`, postData))
    }

    // GET /auth/ivatDrawbackCheck/getConfirmInvoice 确认勾选前，查询待确认勾选的发票（这里查U72）
    get_getConfirmInvoice() {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}auth/ivatDrawbackCheck/getConfirmInvoice`))
    }

    // POST /auth/ivatDrawbackCheck/confirmAuthLocal 勾选确认（单机版）
    post_confirmAuthLocal(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatDrawbackCheck/confirmAuthLocal`, postData))
    }

    // POST /auth/ivatDrawbackCheck/confirmAuthServer 勾选确认（服务器版）
    post_confirmAuthServer(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatDrawbackCheck/confirmAuthServer`, postData))
    }

    // GET /auth/ivatDrawbackCheck/invoiceStatQuery 退税勾选统计查询
    get_ivatDrawbackCheck_invoiceStatQuery(param) {
        let url = `${host.etcloudIvatApp}auth/ivatDrawbackCheck/invoiceStatQuery?month=${param.month}`
        if (param.responseStr) {
            url += `&responseStr=${param.responseStr}`
        }
        if (param.deviceType) {
            url += `&deviceType=${param.deviceType}`
        }
        if (param.diskType) {
            url += `&diskType=${param.diskType}`
        }
        return this.request(() => this.$http.get(url))
    }
    // GET /voucher/ivatVoucherAccountSetting/checkAccountIsConfire 财税对账设置查询是否对账
    // get_checkAccountIsConfire() {
    //     return this.request(() => this.$http.get(`${host.etcloudIvatApp}voucher/ivatVoucherAccountSetting/checkAccountIsConfire`))
    // }
    // POST /voucher/ivatVoucherAccountSetting/updateSetting 财税对账设置更新对账设置
    post_ivatVoucherAccountSetting(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}voucher/ivatVoucherAccountSetting/updateSetting`, postData))
    }
    // POST /erp/ovatCustomCollect/getMidTableMapping 获取中间表映射配
    post_getMidTableMapping(data) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}erp/ovatCustomCollect/getMidTableMapping`, data))
    }
    // POST /erp/ovatCustomCollect/SaveMidTableMapping 保存中间表映射配置
    post_saveMidTableMapping(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}erp/ovatCustomCollect/SaveMidTableMapping`, postData))
    }
    // GET /voucher/ivatVoucher/accountOpt 财税对账对账操作
    get_accountOpt(getData) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}voucher/ivatVoucher/accountOpt?voucherId=${getData.voucherId}&optEnum=${getData.optEnum}`))
    }
    // POST /voucher/ivatVoucher/batchDel 财税对账删除
    post_ivatVoucherBatchDel(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}voucher/ivatVoucher/batchDel`, postData))
    }
    // GET /voucher/ivatVoucher/getTaxPeriod 财税对账获取会计期间
    get_getTaxPeriod() {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}voucher/ivatVoucher/getTaxPeriod`))
    }
    // POST /voucher/ivatVoucher/qryByPage 财税对账采集财务数据分页查询
    post_qryByPage(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}voucher/ivatVoucher/qryByPage`, postData))
    }
    // POST /voucher/ivatVoucher/voucherStatistical 财税对账采集财务数据分页数据统计
    post_voucherStatistical(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}voucher/ivatVoucher/voucherStatistical`, postData))
    }
    // POST /dl/dlTaskService/importVoucher 财税对账采集财务数据导入
    post_importVoucher(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}dl/dlTaskService/importVoucher`, postData))
    }
    // POST /voucher/ivatVoucherInvoice/qryVoucherInvoicePageList 财税对账发票数据采集
    post_qryVoucherInvoicePageList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}voucher/ivatVoucherInvoice/qryVoucherInvoicePageList`, postData))
    }
    // GET /voucher/ivatVoucher/queryVoucherCode 财税对账获取当前会计期间的凭证号
    get_queryVoucherCode(data) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}voucher/ivatVoucher/queryVoucherCode?voucherCode=${data.voucherCode}&taxPeriod=${data.taxPeriod}`))
    }
    // POST /voucher/ivatVoucherInvoice/batchLinkVoucher 财税对账单张/批量关联发票凭证号
    post_batchLinkVoucher(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}voucher/ivatVoucherInvoice/batchLinkVoucher`, postData))
    }
    // GET /voucher/ivatVoucherInvoice/invoiceOpt 财税对账发票对账操作
    get_invoiceOpt(data) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}voucher/ivatVoucherInvoice/invoiceOpt?invoiceId=${data.invoiceId}&sources=${data.sources}&optEnum=${data.optEnum}&taxPeriod=${data.taxPeriod}`))
    }
    // POST /voucher/ivatVoucherInvoice/voucherInvoiceStatistical 财税对账发票数据采集统计
    post_voucherInvoiceStatistical(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}voucher/ivatVoucherInvoice/voucherInvoiceStatistical`, postData))
    }
    // POST /voucher/ivatVoucherAccount/qryVoucherAccountList  获取对账列表
    post_qryVoucherAccountList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}voucher/ivatVoucherAccount/qryVoucherAccountList`, postData))
    }

    // POST /voucher/ivatVoucherAccount/qryInvoiceList  调整发票--查询发票
    post_qryInvoiceList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}voucher/ivatVoucherAccount/qryInvoiceList`, postData))
    }

    // GET /voucher/ivatVoucherAccountSetting/checkAccountIsConfire 获取对账信息
    get_checkAccountIsConfire(periodCode) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}voucher/ivatVoucherAccountSetting/checkAccountIsConfire${periodCode ? '?periodCode=' + periodCode : ''}`))
    }

    // POST /voucher/ivatVoucherAccount/relationInvoice  关联发票
    post_relationInvoice(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}voucher/ivatVoucherAccount/relationInvoice`, postData))
    }

    // POST /voucher/ivatVoucherAccount/reconciliation  对账
    post_reconciliation(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}voucher/ivatVoucherAccount/reconciliation`, postData))
    }

    //  /voucher/ivatVoucherAccount/doComfire  点击确认操作-对账相符可做确认操作，确认后不再进行自动对账
    post_doComfire() {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}voucher/ivatVoucherAccount/doComfire`))
    }

    //  POST /voucher/ivatVoucherAccount/qryTotalTaxamtAccountList  获取 总税额比对模式 台账列表
    post_qryTotalTaxamtAccountList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}voucher/ivatVoucherAccount/qryTotalTaxamtAccountList`, postData))
    }

    //  POST /voucher/ivatVoucherAccount/updateVoucherDiff  调整差异
    post_updateVoucherDiff(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}voucher/ivatVoucherAccount/updateVoucherDiff`, postData))
    }

    //  POST /voucher/ivatVoucherAccount/delRelationInvoice  删除关联
    post_delRelationInvoice(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}voucher/ivatVoucherAccount/delRelationInvoice`, postData))
    }
    //  POST /auth/ivatDeductionCheck/qryAccountOkInvoice  对账勾选获取勾选发票及汇总
    post_qryAccountOkInvoice(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatDeductionCheck/qryAccountOkInvoice`, postData))
    }

    // POST /auth/ivatCustomsPaymentBill/manualInput 海关税款书手工录入
    post_manualInput(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatCustomsPaymentBill/manualInput`, postData))
    }

    // GET /auth/ivatCustomsPaymentBill/downloadXlsTemplate 批量导入-下载模板
    get_downloadXlsTemplate() {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}auth/ivatCustomsPaymentBill/downloadXlsTemplate`))
    }

    // POST /auth/ivatCustomsPaymentBill/updateAuditResult2  更新稽核状态
    post_updateAuditResult2(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatCustomsPaymentBill/updateAuditResult2`, postData))
    }

    // POST /auth/ivatCustomsPaymentBill/writeBatchImportResult  单机版-批量导入回写结果
    post_writeBatchImportResult(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatCustomsPaymentBill/writeBatchImportResult`, postData))
    }
    // GET /settings/ovatEletcEmailConf/selectConfigByLoginUser 获取电子发票设置
    get_selectConfigByLoginUser() {
        return this.request(() => this.$http.get(`${host.etcloudOvat}settings/ovatEletcEmailConf/selectConfigByLoginUser`))
    }
    // POST /settings/ovatEletcEmailConf/updateConfig 修改电子发票设置
    post_ovatEletcEmailConfUpdateConfig(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}settings/ovatEletcEmailConf/updateConfig`, postData))
    }
    // POST /cancelAndReopenInvoice/reopenInvoiceWait
    post_reopenInvoiceWait(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}cancelAndReopenInvoice/reopenInvoiceWait`, postData))
    }
    // POST /ovatInvoiceRequest/synInvoice 数据同步
    post_synInvoice(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceRequest/synInvoice`, postData))
    }
    //POST /taxdeclaration/rpaGsResult/getRpaGsResultDtoList 个税申报综合所得申报
    post_getRpaGsResultDtoList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaGsResult/getRpaGsResultDtoList`, postData))
    }
    // POST /taxdeclaration/rpaGsConfig/getRpaGsConfigDtoList  个税参数配置查询
    post_getRpaGsConfigDtoList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaGsConfig/getRpaGsConfigDtoList`, postData))
    }
    // POST /taxdeclaration/rpaGsConfig/getRpaGsConfigInsert个税参数配置新增
    post_getRpaGsConfigInsert(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaGsConfig/getRpaGsConfigInsert`, postData), msg)
    }
    // GET ems/sysSaleInfo/getAllTaxBureau  获取所有主管税局信息--百丽接口
    get_getAllTaxBureau(accessToken) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysSaleInfo/getAllTaxBureau?accessToken=${accessToken}`))
    }
    //GET ems/sysOrganization/getBelleRegion百丽--获取地区时两个参数都不传，获取管理城市时两个都要传
    get_getBelleRegion(getData) {
        let _url = `${host.etcloud}ems/sysOrganization/getBelleRegion?affiliation=${getData ? getData.affiliation : ''}&regionNo=${getData ? getData.regionNo : ''}`
        return this.request(() => this.$http.get(_url))
    }

    // GET /ems/sysSaleInfo/getTaxBureauById  根据id 获取主管税局信息--百丽接口
    get_getTaxBureauById(id) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysSaleInfo/getAllTaxBureau?id=${id}`))
    }
    //POST /taxdeclaration/rpaGsConfig/getRpaGsConfigEdit个税参数配置编辑
    post_getRpaGsConfigEdit(postData, msg) {
        return this.request1(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaGsConfig/getRpaGsConfigEdit`, postData), msg)
    }
    // GET /taxdeclaration/rpaGsConfig/getRpaGsConfigNo 个税参数配置禁用/启用
    get_getRpaGsConfigNo(params) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}taxdeclaration/rpaGsConfig/getRpaGsConfigNo?id=${params.id}&status=${params.status}`))
    }
    // GET /taxdeclaration/rpaGsConfig/getGsConfigById根据id查询个税参数配置
    get_getGsConfigById(params) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}taxdeclaration/rpaGsConfig/getGsConfigById?id=${params}`))
    }
    //GET taxdeclaration/rpaGsConfig/querySaleNameByUserId个税参数配置查询纳税人名称
    get_querySaleNameByUserId(params) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}taxdeclaration/rpaGsConfig/querySaleNameByUserId?companyName=${params}`))
    }
    // POST /taxdeclaration/rpaGsTask/getRpaGsTaskDtoList个税申报任务跟踪表查询
    post_getRpaGsTaskDtoList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaGsTask/getRpaGsTaskDtoList`, postData))
    }
    //POST  taxdeclaration/rpaGsTask/getRpaGsTaskManualDeclare个税申报任务跟踪表数据申报按钮(人工申报-弹出确定按钮提示框调用
    post_getRpaGsTaskManualDeclare(declareIdArr, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaGsTask/getRpaGsTaskManualDeclare`, declareIdArr), msg)
    }
    //GET /taxdeclaration/rpaGsTask/getRpaGsTaskDeclare个税申报任务跟踪表数据申报按钮
    post_getRpaGsTaskDeclare(declareId, msg) {
        return this.request1(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaGsTask/getRpaGsTaskDeclare`, declareId), msg)
    }
    //POST  taxdeclaration/rpaGsTask/getRpaGsTaskCollection个税申报任务跟踪表数据采集按钮
    post_getRpaGsTaskCollection(collectionIdArr, msg) {
        return this.request1(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaGsTask/getRpaGsTaskCollection`, collectionIdArr), msg)
    }
    // POST taxdeclaration/rpaGsTask/getRpaGsTaskPayment个税申报任务跟踪表缴款按钮
    post_getRpaGsTaskPayment(PayIdArr, msg) {
        return this.request1(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaGsTask/getRpaGsTaskPayment`, PayIdArr), msg)
    }
    // get /ems/sysOrganization/getOrganizationInfoByUid 获取用户的权限机构（开票点、角色）
    get_getOrganizationInfoByUid(uid, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysOrganization/getOrganizationInfoByUid?uid=${uid}`), msg)
    }
    //POST taxdeclaration/sbGlSales/getSbSalesList销项申报数据采集分页查询
    post_getSbSalesList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbGlSales/getSbSalesList`, postData))
    }
    //POST /taxdeclaration/sbGlSales/exportSaleList已开具发票采集导出模板（一般）导出页面数据
    post_exportSaleList(postData) {
        // const _url = `${host.etcloudIvatApp}taxdeclaration/sbGlSales/exportSaleList`
        // const url = encodeURI(this.getParamUrl(postData, _url))
        // window.open(url)
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbGlSales/exportSaleList`, postData))
    }
    //POST  销项 进项采集批量删除
    post_batchSalesOrIncomeDelete(postData, msg, index) {
        let url = ''
        index == 1 ? (url = `${host.etcloudIvatApp}taxdeclaration/sbGlSales/batchSalesDelete`) : (url = `${host.etcloudIvatApp}taxdeclaration/sbGlSales/batchIncomeDelete`)
        return this.request1(() => this.$http.post(url, postData), msg)
    }

    //POST taxdeclaration/sbGlSales/getSbIncomeList进项申报数据采集分页查询
    post_getSbIncomeList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbGlSales/getSbIncomeList`, postData))
    }
    // POST taxdeclaration/sbGlGene/getSbIncomeList申报数据生成分页查询
    post_postSbIncomeList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbGlGene/getSbIncomeList`, postData))
    }
    //POST taxdeclaration/sbGlGene/batchSalesDelete申报数据生成批量删除
    post_batchSalesDelete(postData, msg) {
        return this.request1(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbGlGene/batchSalesDelete`, postData), msg)
    }
    //POST taxdeclaration/sbGlTrack/sbTrackList申报任务追踪分页查询
    post_sbTrackList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbGlTrack/sbTrackList`, postData))
    }
    // POST taxdeclaration/sbGlTrack/sbTrackCollection申报任务追踪发票采集
    post_sbTrackCollection(postData, msg) {
        return this.request1(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbGlTrack/sbTrackCollection`, postData), msg)
    }
    // POST taxdeclaration/sbGlTrack/sbTrackFillIn申报任务追踪申报表填入
    post_sbTrackFillIn(postData, msg) {
        return this.request1(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbGlTrack/sbTrackFillIn`, postData), msg)
    }
    // POST taxdeclaration/sbGlTrack/sbTrackDeclare申报任务追踪申报
    post_sbTrackDeclare(postData, msg) {
        return this.request1(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbGlTrack/sbTrackDeclare`, postData), msg)
    }
    // POST taxdeclaration/sbGlTrack/sbTrackPay申报任务追踪缴款
    post_sbTrackPay(postData, msg) {
        return this.request1(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbGlTrack/sbTrackPay`, postData), msg)
    }
    //POST taxdeclaration/sbGlQuery/getSbQueryList申报数据查询分页查询
    post_getSbQueryList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbGlQuery/getSbQueryList`, postData))
    }
    //POST taxdeclaration/sbGlQuery/down批量下载申报查询-附件
    post_down(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbGlQuery/down`, postData))
    }
    //GET taxdeclaration/sbConf/getSbNo通过纳税人名称查询有关信息
    get_getSbNo(getData, msg) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}taxdeclaration/sbConf/getSbNo?companyName=${getData.companyName}`))
    }
    // POST taxdeclaration/sbConf/getSbConfigList增值税申报配置分页查询
    post_getSbConfigList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbConf/getSbConfigList`, postData))
    }
    // POST taxdeclaration/sbConf/batchConfigDelete纳税参数配置批量删除
    post_batchConfigDelete(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbConf/batchConfigDelete`, postData), msg)
    }
    // POST taxdeclaration/sbConf/sbConfigInsert增值税参数配置新增
    post_sbConfigInsert(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbConf/sbConfigInsert`, postData), msg)
    }
    // GET taxdeclaration/sbConf/getCongByTaxNo通过纳税人信息taxId查询信息
    get_getCongByTaxNo(taxId, msg) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}taxdeclaration/sbConf/getCongByTaxNo?taxId=${taxId}`))
    }
    //POST taxdeclaration/sbConf/sbConfigEdit增值税参数配置编辑
    post_sbConfigEdit(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbConf/sbConfigEdit`, postData), msg)
    }
    // POST  taxdeclaration/rpaStampDutyTask/getRpaStampDutyTaskDtoList印花税任务跟踪表查询列表
    post_getRpaStampDutyTaskDtoList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaStampDutyTask/getRpaStampDutyTaskDtoList`, postData))
    }
    // POST taxdeclaration/rpaStampDutyTask/batchDeclare印花税申报
    post_batchDeclare(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaStampDutyTask/batchDeclare`, postData))
    }
    //POST taxdeclaration/rpaStampDutyTask/batchPay印花税缴款
    post_getRpaStampDutyBatchPay(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaStampDutyTask/batchPay`, postData))
    }
    // POST taxdeclaration/rpaStampDutyTask/batchDelete印花税任务跟踪信息删除
    post_batchDelete(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaStampDutyTask/batchDelete`, postData), msg)
    }
    //POST taxdeclaration/rpaStampDutyTask/batchPay印花税缴款
    post_batchPay(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaStampDutyTask/batchPay`, postData), msg)
    }
    // POST taxdeclaration/rpaStampDutyResult/getRpaStampDutyResultDtoList印花税申报结果查询列表
    post_getRpaStampDutyResultDtoList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaStampDutyResult/getRpaStampDutyResultDtoList`, postData), msg)
    }
    // POST taxdeclaration/rpaEnterpriseTax/getEnterpriseGreateDeclarationList企业所得税-申报表生成查询
    post_getEnterpriseGreateDeclarationList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaEnterpriseTax/getEnterpriseGreateDeclarationList`, postData))
    }
    //POST taxdeclaration/rpaEnterpriseTax/delEnterpriseGreateDeclaration企业所得税-申报表生成删除
    post_delEnterpriseGreateDeclaration(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaEnterpriseTax/delEnterpriseGreateDeclaration`, postData), msg)
    }
    //POST taxdeclaration/rpaEnterpriseTax/getEnterpriseTaskList企业所得税任务跟踪表查询列表
    post_getEnterpriseTaskList(postData) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaEnterpriseTax/getEnterpriseTaskList`, postData))
    }
    //POST taxdeclaration/rpaEnterpriseTax/enterpriseTaxDeclareFillIn批量申报表填入-企业所得税
    post_enterpriseTaxDeclareFillIn(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaEnterpriseTax/enterpriseTaxDeclareFillIn`, postData), msg)
    }
    // POST taxdeclaration/rpaEnterpriseTax/enterpriseTaxDeclare批量申报-企业所得税
    post_enterpriseTaxDeclare(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaEnterpriseTax/enterpriseTaxDeclare`, postData), msg)
    }
    //POST taxdeclaration/rpaEnterpriseTax/enterpriseTaxPayment批量缴款-企业所得税
    post_enterpriseTaxPayment(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaEnterpriseTax/enterpriseTaxPayment`, postData), msg)
    }
    // POST taxdeclaration/rpaEnterpriseTax/getEnterpriseDeclarationList企业所得税-申报报表查询
    post_getEnterpriseDeclarationList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaEnterpriseTax/getEnterpriseDeclarationList`, postData), msg)
    }
    //POST taxdeclaration/sbSmallVatDeclaration/getSmallDeclarationList增值税(小规模)申报生成查询列表
    post_getSmallDeclarationList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbSmallVatDeclaration/getSmallDeclarationList`, postData), msg)
    }
    // POST taxdeclaration/sbSmallVatDeclaration/batchSalesDelete小规模申报数据生成批量删除
    post_sbSmallVatDeclaration(postData, msg) {
        return this.request1(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbSmallVatDeclaration/batchSalesDelete`, postData), msg)
    }
    //POST taxdeclaration/sbSmallVatTracking/sbTrackList申报任务追踪分页查询
    post_sbSmallVatTrackList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbSmallVatTracking/sbTrackList`, postData), msg)
    }
    //POST taxdeclaration/sbSmallVatTracking/sbTrackFillIn申报任务追踪申报表填入
    post_sbSmallVatTrackFillIn(postData, msg) {
        return this.request1(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbSmallVatTracking/sbTrackFillIn`, postData), msg)
    }
    //POST taxdeclaration/sbSmallVatTracking/sbTrackDeclare申报任务追踪申报
    post_sbSmallVatTrackDeclare(postData, msg) {
        return this.request1(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbSmallVatTracking/sbTrackDeclare`, postData), msg)
    }
    //POST taxdeclaration/sbSmallVatTracking/sbTrackPay申报任务追踪缴款
    post_sbSmallVatTrackPay(postData, msg) {
        return this.request1(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbSmallVatTracking/sbTrackPay`, postData), msg)
    }
    // POST taxdeclaration/sbSmallVatQuery/getSbQueryList申报数据查询分页查询
    post_getSmallVatSbQueryList(postData, msg) {
        return this.request1(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbSmallVatQuery/getSbQueryList`, postData), msg)
    }
    // POST taxdeclaration/sbTaxReturnPeriod/getRpaLogList税务日历查询
    post_getRpaLogList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbTaxReturnPeriod/getRpaLogList`, postData), msg)
    }
    //GET  taxdeclaration/sbTaxReturnPeriod/updateStatusById税务日历禁用/启用
    get_updateStatusById(params, msg) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}taxdeclaration/sbTaxReturnPeriod/updateStatusById?id=${params.id}&status=${params.status}`), msg)
    }
    // GET taxdeclaration/sbTaxReturnPeriod/queryByIdAndStatus根据状态返回数据集合
    get_queryByIdAndStatus(status, msg) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}taxdeclaration/sbTaxReturnPeriod/queryByIdAndStatus?status=${status}`), msg)
    }
    //POST taxdeclaration/scheduler/ivatTaxJob/syncInvoice1企业所得税定时任务
    post_syncInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/scheduler/ivatTaxJob/syncInvoice1`, postData), msg)
    }
    //POST auth/sysFunction/getFunctionListByUserAndOrgIds获取当前登陆用户的菜单权限,用于显示菜单
    post_getFunctionListByUserAndOrgIds(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}auth/sysFunction/getFunctionListByUserAndOrgIds`, postData), msg)
    }
    // POST taxdeclaration/sbConf/queryConfig查询配置中的税种
    post_queryConfigtaxId(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbConf/queryConfig`, postData), msg)
    }
    // POST /taxdeclaration/rpaGsTask/updateTaxCertificateStatus完税证明下载状态修改
    post_updateTaxCertificateStatus(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaGsTask/updateTaxCertificateStatus`, postData), msg)
    }
    // POST /taxdeclaration/rpaGsTask/reductionStatus还原功能
    post_reductionStatus(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaGsTask/reductionStatus`, postData), msg)
    }

    //托管机柜发票申领
    //经办人查询
    post_queryOperator(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}/stock/ovatInvoiceApply/queryOperator`, postData))
    }
    //发票申领
    post_invoiceApply(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}/stock/ovatInvoiceApply/invoiceApply`, postData))
    }
    //申领状态查询
    post_queryApplyState(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}/stock/ovatInvoiceApply/queryApplyState`, postData))
    }
    //申领确认
    post_applyConfirm(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}/stock/ovatInvoiceApply/applyConfirm`, postData))
    }
    //申领撤销
    post_applyRevoke(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}/stock/ovatInvoiceApply/applyRevoke`, postData))
    }
    //上报汇总
    post_reportSummary(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}/stock/ovatInvoiceApply/reportSummary`, postData))
    }
    //远程清卡
    post_deviceClear(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}/stock/ovatInvoiceApply/deviceClear`, postData))
    }
    //可下载票源查询
    post_queryInvoiceSource(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}/stock/ovatInvoiceApply/queryInvoiceSource`, postData))
    }
    //票源下载
    post_invoiceSourceDown(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}/stock/ovatInvoiceApply/invoiceSourceDown`, postData))
    }
    //库存查询
    post_queryDeviceStock(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}/stock/ovatInvoiceApply/queryDeviceStock`, postData))
    }
    //纳税人票种核定信息查询
    post_queryNsrInvoiceTypeApproval(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}/stock/ovatInvoiceApply/queryNsrInvoiceTypeApproval`, postData))
    }
    //设备信息查询
    post_queryDeviceInfo(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}/stock/ovatInvoiceApply/queryDeviceInfo`, postData))
    }
    //托管机柜发票申领
    // POST /taxdeclaration/sbEnterpriseCwbb/getSmallAssetsList小企业会计准则-资产负债表查询列表
    post_getSmallAssetsList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbEnterpriseCwbb/getSmallAssetsList`, postData), msg)
    }
    //   POST /taxdeclaration/sbEnterpriseCwbb/batchDelete删除
    post_getSmallAssetsListDelete(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbEnterpriseCwbb/batchDelete`, postData), msg)
    }
    //POST /taxdeclaration/sbEnterpriseCwbb/getSmallProfitList小企业会计准则-利润表查询列表
    post_getSmallProfitList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbEnterpriseCwbb/getSmallProfitList`, postData), msg)
    }
    //POST /taxdeclaration/sbEnterpriseCwbb/getSmallCashList小企业会计准则-现金流量表查询列表
    post_getSmallCashList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbEnterpriseCwbb/getSmallCashList`, postData), msg)
    }
    //POST /taxdeclaration/sbEnterpriseCwbb/getGlAssetsList企业会计准则-资产负债表查询列表
    post_getGlAssetsList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbEnterpriseCwbb/getGlAssetsList`, postData), msg)
    }
    //POST /taxdeclaration/sbEnterpriseCwbb/getGlCashList企业会计准则-现金流量表查询列表
    post_getGlCashList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbEnterpriseCwbb/getGlCashList`, postData), msg)
    }
    //POST /taxdeclaration/sbEnterpriseCwbb/getGlProfitList企业会计准则-利润表查询列表
    post_getGlProfitList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbEnterpriseCwbb/getGlProfitList`, postData), msg)
    }
    //POST /taxdeclaration/rpaEnterpriseTax/enterpriseTaxCwFillIn财务报表批量填入-企业所得税
    post_enterpriseTaxCwFillIn(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaEnterpriseTax/enterpriseTaxCwFillIn`, postData), msg)
    }
    //POST /taxdeclaration/rpaEnterpriseTax/enterpriseTaxCwDeclareFillIn财务报表、申报表填入及申报-企业所得税
    post_enterpriseTaxCwDeclareFillIn(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaEnterpriseTax/enterpriseTaxCwDeclareFillIn`, postData), msg)
    }
    // POST /auth/ivatDeductionCheck/getCheckInvoiceStatics勾选发票统计
    post_getCheckInvoiceStatics(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatDeductionCheck/getCheckInvoiceStatics`, postData), msg)
    }
    // POST /auth/ivatDeductionCheck/exportCheckInvoiceToExcel导出勾选发票数据
    post_exportCheckInvoiceToExcel(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatDeductionCheck/exportCheckInvoiceToExcel`, postData), msg)
    }
    //POST /ovatInvoiceError/errorRetry *重新触发
    post_errorRetry(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceError/errorRetry`, postData), msg)
    }
    //POST /ovatInvoiceError/pageErrorLog *电子票异常信息分页查询
    post_pageErrorLog(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceError/pageErrorLog`, postData), msg)
    }
    // GET /manage/ivatBill/downloadInvoiceSourceFile下载发票源文件
    get_downloadInvoiceSourceFile(getdata, msg) {
        const _url = `${host.etcloudIvatApp}manage/ivatBill/downloadInvoiceSourceFile`
        const url = this.getParamUrl(getdata, _url)
        window.open(url)
    }
    //GET /manage/ivatBill/downloadETaxInvoiceSourceFile 下载E税云发票源文件
    get_downloadETaxInvoiceSourceFile(getdata, msg) {
        const _url = `${host.etcloudIvatApp}manage/ivatBill/downloadETaxInvoiceSourceFile`
        const url = this.getParamUrl(getdata, _url)
        window.open(url)
    }
    // POST /auth/ivatDeductionCheck/updateNoDeductionReason批量更新不抵扣原因
    post_updateNoDeductionReason(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/ivatDeductionCheck/updateNoDeductionReason`, postData), msg)
    }
    // POST /qrCodeBillOpen/submitOpenInvCallbackBelleNew测试发票开具成功后回调百丽
    post_submitOpenInvCallbackBelleNew(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}qrCodeBillOpen/submitOpenInvCallbackBelleNew`, postData), msg)
    }
    // POST /queryRpaAbnormalTaskList 异常申报跟踪任务-列表查询
    post_queryRpaAbnormalTaskList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}queryRpaAbnormalTaskList`, postData), msg)
    }
    // POST /retrigger 异常申报跟踪任务-重新触发
    post_retrigger(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}retrigger`, postData), msg)
    }
    post_scanCodeInvFuilRetry(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}qrCodeBillOpen/scanCodeInvFuilRetry`, postData), msg)
    }
    // GET /ovatInvoiceError/exportOpenFailInvoiceToXLS 发票异常列表导出EXCEL
    get_exportOpenFailInvoiceToXLS(getdata, msg) {
        const _url = `${host.etcloudOvat}ovatInvoiceError/exportOpenFailInvoiceToXLS`
        const url = this.getParamUrl(getdata, _url)
        window.open(url)
    }
    // POST /taxdeclaration/rpaSummaryStatistics/selectSummaryStatisticsList申报汇总统计分页查询
    post_selectSummaryStatisticsList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaSummaryStatistics/selectSummaryStatisticsList`, postData), msg)
    }
    // GET /ovatInvoiceWait/exportInvoiceWaitToXLS
    get_exportInvoiceWaitToXLS(getdata, msg) {
        const _url = `${host.etcloudOvat}ovatInvoiceWait/exportInvoiceWaitToXLS`
        const url = this.getParamUrl(getdata, _url)
        window.open(url)
    }
    //POST /stock/biInvStockApply/queryDeviceStockBelle库存查询-NEW
    post_queryDeviceStockBelle(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}stock/biInvStockApply/queryDeviceStockBelle`, postData), msg)
    }
    //POST /stock/biInvStockApply/invoiceAutoReceive 发票批量领购-NEW
    post_invoiceAutoReceive(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}stock/biInvStockApply/invoiceAutoReceive`, postData), msg)
    }
    // POST /stock/biInvStockApply/invoiceAutoApply 发票批量申领-NEW
    post_invoiceAutoApply(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}stock/biInvStockApply/invoiceAutoApply`, postData), msg)
    }
    // POST /stock/biInvStockApply/batchUpdateApplyState 申领状态查询
    post_batchUpdateApplyState(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}stock/biInvStockApply/batchUpdateApplyState`, postData), msg)
    }
    //POST /stock/biInvStockApply/invoiceApplyNumByTaxCode 发票申领数量查询-NEW
    post_invoiceApplyNumByTaxCode(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}stock/biInvStockApply/invoiceApplyNumByTaxCode`, postData), msg)
    }

    //POST /ovatInputBatch/selectPageOvatInputBatchList 分页查询扫描录入批次信息
    post_selectPageOvatInputBatchList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInputBatch/selectPageOvatInputBatchList`, postData), msg)
    }
    //POST /manage/scanInvoice/batchDeleteOvatOcrImage 批量删除销项发票影像
    post_batchDeleteOvatOcrImage(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/scanInvoice/batchDeleteOvatOcrImage`, postData), msg)
    }
    //POST /manage/scanInvoice/batchDeleteOvatOcrImageByImageKey 根据影像key批量删除销项发票影像
    post_batchDeleteOvatOcrImageByImageKey(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/scanInvoice/batchDeleteOvatOcrImageByImageKey`, postData), msg)
    }
    //POST /manage/scanInvoice/clearInvalidOvatOcrImage 根据批次号删除无效影像图片
    post_clearInvalidOvatOcrImage(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/scanInvoice/clearInvalidOvatOcrImage`, postData), msg)
    }
    //POST /manage/scanInvoice/batchDownloadOvatInvoiceImage 批量下载销项发票影像
    post_batchDownloadOvatInvoiceImage(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/scanInvoice/batchDownloadOvatInvoiceImage`, postData), msg)
    }
    //POST /manage/scanInvoice/uploadOvatInvoiceImage 发票影像上传
    post_uploadOvatInvoiceImage(postData, msg) {
        return this.request(() =>
            this.$http.post(`${host.etcloudIvatApp}manage/scanInvoice/uploadOvatInvoiceImage`, postData, {
                headers: {
                    'Content-Type': undefined,
                },
                transformRequest: angular.identity,
            })
        )
    }
    // 根据纳税人同步服务器金税盘 /ems/sysTaxDisk/syncDisk
    post_sysTaxDiskAsyncDisk(postData) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysTaxDisk/asyncDisk`, postData))
    }

    // POST /ems/sysSaleInfo/updateIvatInfoSyncStatus 修改纳税人进项账号的同步状态
    post_updateIvatInfoSyncStatus(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysSaleInfo/updateIvatInfoSyncStatus`, postData), msg)
    }
    // manage/ivatWxBill/getBatchNo //获取照片添加批次号
    get_getBatchNo() {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}manage/ivatWxBill/getBatchNo`))
    }
    // GET /ems/sysSaleInfo/getIsElecTaxBureau 获取当前税号的进项是否是电子税局，true 电子税局
    get_getIsElecTaxBureau() {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysSaleInfo/getIsElecTaxBureau`))
    }
    //GET /auth/ivatAuthBatch/getAuthBatch 查询当前税号下所有未同步批次号 - 单机
    get_getAuthBatch() {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}auth/ivatAuthBatch/getAuthBatch`))
    }
    // post /auth/ivatAuthBatch/handleSingle 批次查询结果
    post_getHandleSingle(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}/auth/ivatAuthBatch/handleSingle`, postData), msg)
    }
    //GET /auth/ivatAuthBatch/syncByBatchNo 查询当前税号下所有未同步批次号，并进行同步
    get_syncByBatchNo() {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}auth/ivatAuthBatch/syncByBatchNo`))
    }
    // GET /ovatInvoiceError/exportFullOpenFailInvoiceToXLS 全电发票模板导出功能EXCEL
    get_exportFullOpenFailInvoiceToXLS(getdata, msg) {
        const _url = `${host.etcloudOvat}ovatInvoiceError/exportFullOpenFailInvoiceToXLS`
        const url = this.getParamUrl(getdata, _url)
        window.open(url)
    }
    // POST /taxdeclaration/rpaGsRefundTask/getRpaGsRefundTaskList 个税退付手续费任务跟踪查询
    post_getRpaGsRefundTaskList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaGsRefundTask/getRpaGsRefundTaskList`, postData), msg)
    }
    // POST /taxdeclaration/rpaGsRefundTask/doRpaGsRefund 申请退付手续费
    post_doRpaGsRefund(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaGsRefundTask/doRpaGsRefund`, postData), msg)
    }
    // POST /taxdeclaration/rpaGsRefundTask/reductionRpaGsRefundStatus 还原申请退付状态
    post_reductionRpaGsRefundStatus(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaGsRefundTask/reductionRpaGsRefundStatus`, postData), msg)
    }
    // GET /taxdeclaration/rpaGsRefundTask/buildRpaGsRefundTask 生成退款任务
    get_buildRpaGsRefundTask() {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}taxdeclaration/rpaGsRefundTask/buildRpaGsRefundTask`))
    }
    // POST /taxdeclaration/rpaGsTask/changeRpaTaskPayment 变更缴款状态
    post_rpaGsTaskChangeRpaTaskPayment(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaGsTask/changeRpaTaskPayment?isChangePayStatus=${postData.status}`, postData.idList), msg)
    }
    // POST /taxdeclaration/sbSmallVatTracking/changeRpaTaskPayment 变更缴款状态
    post_smallVatTrackingChangeRpaTaskPayment(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbSmallVatTracking/changeRpaTaskPayment?isChangePayStatus=${postData.status}`, postData.idList), msg)
    }
    // POST /taxdeclaration/rpaStampDutyTask/changeRpaTaskPayment变更缴款状态
    post_rpaStampDutyTaskChangeRpaTaskPayment(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaStampDutyTask/changeRpaTaskPayment?isChangePayStatus=${postData.status}`, postData.idList), msg)
    }
    // POST /taxdeclaration/rpaEnterpriseTax/changeRpaTaskPayment 变更缴款状态
    post_rpaEnterpriseTaxChangeRpaTaskPayment(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaEnterpriseTax/changeRpaTaskPayment?isChangePayStatus=${postData.status}`, postData.idList), msg)
    }
    // POST /taxdeclaration/sbGlTrack/changeRpaTaskPayment 变更缴款状态
    post_sbGlTrackChangeRpaTaskPayment(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbGlTrack/changeRpaTaskPayment?isChangePayStatus=${postData.status}`, postData.idList), msg)
    }
    // POST /tax4/ovatTax4AuthAmount/findListByChannelPage 授权额度表按税号和通道分组分页查询
    post_findListByChannelPage(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4AuthAmount/findListByChannelPage`, postData))
    }
    //GET /tax4/ovatTax4AuthAmount/getOvatTax4AuthDrawer 根据orgId获取对应开票点
    get_getOvatTax4AuthDrawer(orgId, manageTypes) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}tax4/ovatTax4AuthAmount/getOvatTax4AuthDrawer?orgId=${orgId}&manageTypes=${manageTypes}`))
    }
    // POST /tax4/ovatTax4Drawer/get 获取开票员管理详情
    post_ovatTax4Drawerget(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/get`, postdata), msg)
    }
    // POST /tax4/ovatTax4AuthAmount/refreshAuthAmount 刷新授权额度表
    post_refreshAuthAmount(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4AuthAmount/refreshAuthAmount`, postData))
    }
    //POST /tax4/ovatTax4AuthAmount/get 获取授权额度表详情
    post_getTax4AuthAmount(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4AuthAmount/get`, postdata), msg)
    }
    // POST /tax4/ovatTax4Drawer/findByAuthorizeId 通过认证id获取开票员详情
    post_findByAuthorizeId(authorizeId, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/findByAuthorizeId?authorizeId=${authorizeId}`))
    }
    // POST /tax4/realNameAuth/getToken 登录电子税局-深圳通道
    post_getToken(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/realNameAuth/getToken`, postData))
    }
    // POST /tax4/realNameAuth/smsValid 提交短信验证码
    post_smsValid(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/realNameAuth/smsValid`, postData))
    }
    // POST /tax4/realNameAuth/realNameAuthStatCount 实名认证管理统计数量
    post_realNameAuthStatCount(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/realNameAuth/realNameAuthStatCount`, postData))
    }
    // POST /tax4/realNameAuth/getQrCode 获取开具实人认证二维码
    post_getQrCode(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/realNameAuth/getQrCode`, postData))
    }
    // POST /tax4/realNameAuth//getScanLoginQrCode 获取扫码登录二维码
    post_getScanLoginQrCode(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/realNameAuth/getScanLoginQrCode`, postData))
    }
    // POST /tax4/realNameAuth/queryQrCodeStatus 确认认证二维码状态
    post_queryQrCodeStatus(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/realNameAuth/queryQrCodeStatus`, postData))
    }
    // POST /tax4/ovatTax4Drawer/getUserOrgEnableNameList 获取当前用户拥有权限的机构启用的开票员名称(去重)
    post_getUserOrgEnableNameList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/getUserOrgEnableNameList`, postData))
    }
    // POST /tax4/realNameAuth/realNameAuthListPage 实名认证管理分页查询
    post_realNameAuthListPage(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/realNameAuth/realNameAuthListPage`, postData))
    }
    // POST /tax4/realNameAuth/getTokenIntercept 登录电子税局-深圳通道-拦截
    post_getTokenIntercept(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/realNameAuth/getTokenIntercept`, postData))
    }
    // POST /tax4/ivatTax4InvoicePool/get 获取进项发票池发票表详情
    post_ivatGetPool(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}tax4/ivatTax4InvoicePool/get`, postData))
    }
    // POST /tax4/ivatTax4InvoicePool/getSocketRequestId 获取webSocket唯一请求id
    post_ivatSocketRequestId(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}tax4/ivatTax4InvoicePool/getSocketRequestId`, postData))
    }
    // GET /tax4/ivatTax4InvoicePool/stopTask 停止
    get_ivatStopTask(taskId) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}tax4/ivatTax4InvoicePool/stopTask?taskId=${taskId}`))
    }
    // POST /tax4/ivatTax4InvoicePool/findListByPage 进项发票池发票表分页查询
    post_ivatFindListByPagePool(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}tax4/ivatTax4InvoicePool/findListByPage`, postData))
    }
    // POST /tax4/ivatTax4InvoicePool/getInvoicePoolStatics 获取待开总计统计数量
    post_ivatInvoicePoolStatics(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}tax4/ivatTax4InvoicePool/getInvoicePoolStatics`, postData))
    }
    // POST /tax4/ovatTax4RedConfirm/getListRedConfirmBody 批量获取红字确认单详细信息
    post_getListRedConfirmBody(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/getListRedConfirmBody`, postdata), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/batchConfirmOrRejectRedConfirm 红字确认单-批量确认/拒绝
    post_batchConfirmOrRejectRedConfirm(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/batchConfirmOrRejectRedConfirm`, postdata), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/confirmOrRejectRedConfirm 红字确认单-确认/拒绝
    post_confirmOrRejectRedConfirm(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/confirmOrRejectRedConfirm`, postdata), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/getRedConfirmBody 单个获取红字确认单详细信息
    post_getRedConfirmBody(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/getRedConfirmBody`, postdata), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/downloadRedConfirmByPage 分页下载红字确认单主体数据
    post_downloadRedConfirmByPage(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/downloadRedConfirmByPage`, postdata), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/downloadRedConfirmById 根据确认单ID从下载红字确认单发票
    post_downloadRedConfirmById(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/downloadRedConfirmById`, postdata), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/checkIsAlloRestore 批量校验发票能否还原
    post_checkIsAlloRestore(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/checkIsAlloRestore`, postData), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/batchOpenRedInvoice 红字发票批量开具
    post_batchOpenRedInvoice(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/batchOpenRedInvoice`, postdata), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/openRedInvoice 红字发票单张开具
    post_openRedInvoice(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/openRedInvoice`, postdata), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/findListByPage 金四红字确认单主体表分页查询 - 红字确认单 列表查询
    post_tax4RedListByPage(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/findListByPage`, postdata), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/submitRedConfirm 单个提交
    post_submitRedConfirm(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/submitRedConfirm`, postdata), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/uploadRedConfirm 红字确认单-单张上传税局
    post_uploadRedConfirm(confirmId, uKeyId, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/uploadRedConfirm?confirmId=${confirmId}&uKeyId=${uKeyId}`), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/batchSubmitRedConfirm 红字确认单-批量提交
    post_batchSubmitRedConfirm(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/batchSubmitRedConfirm`, postdata), msg)
    }
    //POST /tax4/ovatTax4RedConfirm/batchUpdateRedConfirmFromTaxBureau 红字确认单-批量更新
    post_batchUpdateRedConfirmFromTaxBureau(confirmIds, uKeyId, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/batchUpdateRedConfirmFromTaxBureau?confirmIds=${confirmIds}&uKeyId=${uKeyId}`), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/batchUploadRedConfirm 红字确认单-批量上传税局
    post_batchUploadRedConfirm(confirmIds, uKeyId, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/batchUploadRedConfirm?confirmIds=${confirmIds}&uKeyId=${uKeyId}`), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/singleRollbackAutoCompareCheck 红字确认单-单张回退自动匹配
    post_singleRollbackAutoCompareCheck(confirmId, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/singleRollbackAutoCompareCheck?confirmId=${confirmId}`, msg))
    }
    //POST /tax4/ovatTax4RedConfirm/batchRollbackRedConfirm 批量回退关联销售单红字确认单
    post_batchRollbackRedConfirm(confirmIds, rollbackFlag, batchOperate, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/batchRollbackRedConfirm?confirmIds=${confirmIds}&rollbackFlag=${rollbackFlag}&batchOperate=${batchOperate}`, msg))
    }
    // POST /tax4/ovatTax4RedConfirm/revokeTax4RedConfirm 红字确认单撤销
    post_revokeTax4RedConfirm(confirmId, uKeyId, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/revokeTax4RedConfirm?confirmId=${confirmId}&uKeyId=${uKeyId}`), msg)
    }
    //POST /tax4/ovatTax4RedConfirm/batchRevokeTax4RedConfirm 红字确认单批量撤销
    post_batchRevokeTax4RedConfirm(confirmIds, uKeyId, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/batchRevokeTax4RedConfirm?confirmIds=${confirmIds}&uKeyId=${uKeyId}`), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/batchDelete 批量删除红字确认单
    post_tax4RedConfirmBatchDelete(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/batchDelete`, postdata), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/batchSendConfirmMail 批量发送确认提醒邮件
    post_batchSendConfirmMail(confirmIds, confirmMail, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/batchSendConfirmMail?confirmIds=${confirmIds}&confirmMail=${confirmMail}`, msg))
    }
    // POST /tax4/ovatTax4RedConfirm/redConfirmRelate 红字确认单-匹配关联
    post_redConfirmRelate(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/redConfirmRelate`, postData))
    }
    // POST /tax4/ovatTax4RedConfirm/getReasonDictionary 根据税收分类编码获取对应的数据字典
    post_getReasonDictionary(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/getReasonDictionary`, postdata), msg)
    }
    // POST /tax4/ovatTax4RedConfirmDetail/initRedConfirmDetail 恢复红字确认单初始状态
    post_initRedConfirmDetail(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirmDetail/initRedConfirmDetail`, postdata), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/delete 删除红字确认单主体表
    post_tax4RedConfirmDelete(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/delete`, postdata), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/updateOvatTax4RedConfirm 暂存/修改红字确认单信息
    post_updateOvatTax4RedConfirm(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/updateOvatTax4RedConfirm`, postdata), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/getTax4InvoiceDetailInfo 获取全电全量发票-明细
    post_getTax4InvoiceDetailInfo(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/getTax4InvoiceDetailInfo`, postdata), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/getTax4InvoiceInfo 获取全电全量发票-主体
    post_getTax4InvoiceInfo(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/getTax4InvoiceInfo`, postdata), msg)
    }
    // POST /tax4/ovatTax4RedConfirm/initTax4RedConfirmInfo 红字确认单选择-确认单初始化
    post_initTax4RedConfirmInfo(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4RedConfirm/initTax4RedConfirmInfo`, postdata), msg)
    }
    // POST /tax4/ovatTax4Drawer/queryManagementScope 获取开票员管理范围
    post_ovatTax4DrawerqueryManagementScope(drawerId, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/queryManagementScope?drawerId=${drawerId}`), msg)
    }
    // POST /tax4/ovatTax4Drawer/add 新增开票员管理
    post_ovatTax4Draweradd(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/add`, postdata), msg)
    }
    // POST /tax4/ovatTax4Drawer/update 修改开票员管理
    post_ovatTax4Drawerupdate(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/update`, postdata), msg)
    }
    // POST /tax4/ovatTax4Drawer/getEditDrawerOrgTree 获取开票员管理机构树
    getEditDrawerOrgTree(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/getEditDrawerOrgTree`, postdata), msg)
    }
    // POST /tax4/ovatTax4Drawer/getDrawersManagementScope 批量获取开票员管理范围
    post_getDrawersManagementScope(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/getDrawersManagementScope`, postdata), msg)
    }
    // POST /tax4/ovatTax4Drawer/getManageOrgTree 获取当前管理机构树
    post_getManageOrgTree(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/getManageOrgTree`, postdata), msg)
    }
    // POST /tax4/ovatTax4Drawer/getUserManageOrgTree 获取当前用户接收管理机构树
    post_getUserManageOrgTree(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/getUserManageOrgTree`, postdata), msg)
    }
    //POST /tax4/ovatTax4Drawer/getUserOrgList 获取当前用户拥有权限的机构下禁用的开票员列表
    post_ovatTax4DrawerUserOrgList(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/getUserOrgList`, postdata), msg)
    }
    // POST /tax4/ovatTax4Drawer/findListByPage 开票员管理分页查询
    post_ovatTax4DrawerfindListByPage(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/findListByPage`, postdata), msg)
    }
    // POST /tax4/ovatTax4Drawer/activateDrawer 批量激活开票员
    post_activateDrawer(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/activateDrawer`, postdata), msg)
    }
    // POST /tax4/ovatTax4Drawer/getChangeManageOrgTree 获取当前开票员变更管理机构树
    post_getChangeManageOrgTree(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/getChangeManageOrgTree`, postdata), msg)
    }
    // POST /tax4/ovatTax4Drawer/getReceiveManageOrgTree 获取当前开票员接收管理机构树
    post_getReceiveManageOrgTree(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/getReceiveManageOrgTree`, postdata), msg)
    }
    //POST /tax4/ovatTax4Drawer/getTransferManageOrgTree 获取当前开票员转交管理机构树
    post_getTransferManageOrgTree(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/getTransferManageOrgTree`, postdata), msg)
    }
    //POST /tax4/ovatTax4Drawer/transferContrast 变更授权范围-转交对比
    post_transferContrast(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/transferContrast`, postdata), msg)
    }
    // POST /tax4/ovatTax4Drawer/scopeOfAuth 变更授权范围
    post_scopeOfAuth(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/scopeOfAuth`, postdata), msg)
    }
    // POST /settings/sysConditionConfig/getOne 获取
    post_sysConditionConfigGetOne(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysConditionConfig/getOne`, postData))
    }
    //POST /tax4/ovatTax4Invoice/tax4Callback 全电发票-手工回调
    post_tax4Callback(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Invoice/tax4Callback`, postData), msg)
    }
    // POST /tax4/wait/ordinaryElectricalWait/batchRestore
    post_batchRestore(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/ordinaryElectricalWait/batchRestore`, postData), msg)
    }
    // POST /tax4/ovatTax4Invoice/findListByPage 金四发票表分页查询
    post_findListByPage(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Invoice/findListByPage`, postdata), msg)
    }
    //POST /tax4/ovatTax4Invoice/getInvoiceStatics 获取已开总计统计数量
    post_getTax4InvoiceStatics(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Invoice/getInvoiceStatics`, postdata), msg)
    }
    // POST tax4/ordinaryElectricalOpened/getBatchTax4PrintUrl 电子发票批量打印第一步：获取标识
    post_getBatchTax4PrintUrl(postData) {
        return this.request(() => this.$http.post(`${host.etcloudOvat + 'tax4/open/ordinaryElectricalOpened'}/getBatchTax4PrintUrl`, postData))
    }
    // POST tax4/ordinaryElectricalOpened/singleInvoice 批量/单个邮箱发送信息
    post_batchSendTax4Invoice(postData, msg) {
        return this.request(() => this.$http.post(`${IS_PROVIDER ? host.etcloudSupplier + 'ovat/scOpenedInvoice' : host.etcloudOvat + 'tax4/open/ordinaryElectricalOpened'}/singleInvoice`, postData), msg)
    }
    //POST /tax4/open/totalElectricalOpened/batchUpdateUkeyId 修改开票点
    post_batchUpdateUkeyId(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/open/totalElectricalOpened/batchUpdateUkeyId`, postdata), msg)
    }
    // POST /tax4/ovatTax4Invoice/getInvoiceBillList 查询发票关联的销售单分页列表
    post_getInvoiceBillList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Invoice/getInvoiceBillList`, postData))
    }
    // POST /tax4/wait/ordinaryElectricalWait/getOne 查询待开发票详情
    post_tax4OrdinaryGetOne(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/ordinaryElectricalWait/getOne`, postdata), msg)
    }
    // POST /tax4/wait/specialElectricalWait/getOne 查询待开发票详情
    post_tax4SpecialGetOne(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/specialElectricalWait/getOne`, postdata), msg)
    }
    //GET /common/common/getSnowFlakeId 获取雪花算法生成的ID
    get_getSnowFlakeId(msg) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}common/common/getSnowFlakeId`), msg)
    }
    // POST /tax4/wait/ordinaryElectricalWait/manuallyAdd 手工新增金四发票
    post_tax4OrdinaryManuallyAdd(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/ordinaryElectricalWait/manuallyAdd`, postdata), msg)
    }
    // POST /tax4/wait/ordinaryElectricalWait/batchSubmit 批量提交发票
    post_tax4OrdinaryBatchSubmit(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/ordinaryElectricalWait/batchSubmit`, postdata), msg)
    }
    // POST /tax4/wait/ordinaryElectricalWait/invoice 开票
    post_tax4OrdinaryInvoice(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/ordinaryElectricalWait/invoice`, postdata), msg)
    }
    // POST /tax4/wait/specialElectricalWait/manuallyAdd 手工新增金四发票
    post_tax4SpecialManuallyAdd(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/specialElectricalWait/manuallyAdd`, postdata), msg)
    }
    // POST /tax4/wait/specialElectricalWait/batchSubmit 批量提交发票
    post_tax4SpecialBatchSubmit(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/specialElectricalWait/batchSubmit`, postdata), msg)
    }
    // POST /tax4/wait/specialElectricalWait/invoice 开票
    post_tax4SpecialInvoice(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/specialElectricalWait/invoice`, postdata), msg)
    }
    // POST /tax4/wait/ordinaryElectricalWait/getOvatInvoiceWaitList 查询待开发票列表
    post_tax4OrdinaryList(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/ordinaryElectricalWait/getOvatInvoiceWaitList`, postdata), msg)
    }
    // POST /tax4/wait/specialElectricalWait/getOvatInvoiceWaitList 查询待开发票列表
    post_tax4SpecialList(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/specialElectricalWait/getOvatInvoiceWaitList`, postdata), msg)
    }
    //POST /tax4/wait/ordinaryElectricalWait/getInvoiceWaitStatics 获取待开总计统计数量
    post_tax4OrdinaryWaitStatics(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/ordinaryElectricalWait/getInvoiceWaitStatics`, postdata), msg)
    }
    //POST /tax4/wait/specialElectricalWait/getInvoiceWaitStatics 获取待开总计统计数量
    post_tax4SpecialWaitStatics(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/specialElectricalWait/getInvoiceWaitStatics`, postdata), msg)
    }
    // POST /tax4/wait/specialElectricalWait/batchUpdateWaitInvUkeyId 全电专
    post_batchUpdateWaitInvUkeyId(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/specialElectricalWait/batchUpdateWaitInvUkeyId`, postData))
    }
    // POST /tax4/wait/ordinaryElectricalWait/getMatchInvoice 自动匹配发票
    post_ordinaryGetMatchInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/ordinaryElectricalWait/getMatchInvoice`, postData))
    }
    //POST /tax4/wait/ordinaryElectricalWait/batchInvoice 批量开票
    post_tax4OrdinaryBatchInvoice(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/ordinaryElectricalWait/batchInvoice`, postdata), msg)
    }
    // POST /tax4/wait/ordinaryElectricalWait/batchDelete 批量删除发票
    post_tax4OrdinaryBatchDelete(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/ordinaryElectricalWait/batchDelete`, postdata), msg)
    }
    // POST /tax4/wait/specialElectricalWait/getMatchInvoice 自动匹配发
    post_specialGetMatchInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/specialElectricalWait/getMatchInvoice`, postData))
    }
    //POST /tax4/wait/specialElectricalWait/batchInvoice 批量开票
    post_tax4SpecialBatchInvoice(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/specialElectricalWait/batchInvoice`, postdata), msg)
    }
    // POST /tax4/wait/specialElectricalWait/batchDelete 批量删除发票
    post_tax4SpecialBatchDelete(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/specialElectricalWait/batchDelete`, postdata), msg)
    }
    // POST /tax4/wait/ordinaryElectricalWait/batchReduction 批量回退待开发票状态
    post_tax4OrdinaryBatchReduction(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/ordinaryElectricalWait/batchReduction`, postdata), msg)
    }
    // POST /tax4/wait/specialElectricalWait/batchReduction 批量回退待开发票状态
    post_tax4SpecialBatchReduction(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/specialElectricalWait/batchReduction`, postdata), msg)
    }
    //POST /tax4/wait/ordinaryElectricalWait/tax4InvoiceReductionCheck 全电待开回退校验
    post_tax4InvoiceReductionCheck(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/ordinaryElectricalWait/tax4InvoiceReductionCheck`, postData))
    }
    //POST /tax4/wait/ordinaryElectricalWait/refreshOpenStatus 刷新开票状态
    post_tax4OrdinaryRefreshOpenStatus(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/ordinaryElectricalWait/refreshOpenStatus`, postdata), msg)
    }
    //POST /tax4/wait/specialElectricalWait/refreshOpenStatus 刷新开票状态
    post_tax4SpecialRefreshOpenStatus(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/specialElectricalWait/refreshOpenStatus`, postdata), msg)
    }
    //POST /tax4/wait/ordinaryElectricalWait/checkAssociation 关联校验
    post_checkAssociation(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/ordinaryElectricalWait/checkAssociation`, postdata), msg)
    }
    //POST /tax4/wait/ordinaryElectricalWait/makeAssociations 关联
    post_makeAssociations(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/ordinaryElectricalWait/makeAssociations`, postdata), msg)
    }
    //POST /tax4/wait/ordinaryElectricalWait/pageOpenedInvoiceMain 单张手工关联发票列表
    post_pageOpenedInvoiceMain(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/ordinaryElectricalWait/pageOpenedInvoiceMain`, postdata), msg)
    }
    // POST /tax4/ovatTax4InvoicePool/get 获取销项发票池发票表详情
    post_getPool(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4InvoicePool/get`, postData))
    }
    // POST /tax4/ovatTax4InvoicePool/downOfdInvoiceFile 下载ofd发票文件到服务器
    post_downOfdInvoiceFile(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4InvoicePool/downOfdInvoiceFile`, postData))
    }
    // POST /tax4/ovatTax4InvoicePool/downPdfInvoiceFile 下载pdf发票文件到服务器
    post_downPdfInvoiceFile(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4InvoicePool/downPdfInvoiceFile`, postData))
    }
    // POST /tax4/ovatTax4InvoicePool/downXmlInvoiceFile 下载xml发票文件到服务器  PDF:1,OFD:2,XML:3
    post_downXmlInvoiceFile(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4InvoicePool/downXmlInvoiceFile`, postData))
    }
    // POST /tax4/ovatTax4InvoicePool/getSocketRequestId 获取webSocket唯一请求id
    post_getSocketRequestId(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4InvoicePool/getSocketRequestId`, postData), msg)
    }
    // GET /tax4/ovatTax4InvoicePool/stopTask 暂停
    get_stopTask(taskId) {
        return this.request(() => this.$http.get(`${host.etcloudOvat}tax4/ovatTax4InvoicePool/stopTask?taskId=${taskId}`))
    }
    // POST /tax4/ovatTax4InvoicePool/findListByPage 销项发票池发票表分页查询
    post_findListByPagePool(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4InvoicePool/findListByPage`, postData))
    }
    // POST /tax4/ovatTax4InvoicePool/getInvoicePoolStatics 获取待开总计统计数量
    post_getInvoicePoolStatics(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4InvoicePool/getInvoicePoolStatics`, postData))
    }
    //POST /tax4/ovatTax4InvoicePool/updateStatusOne 状态更新
    post_updateStatusOne(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4InvoicePool/updateStatusOne`, postData))
    }
    //POST /tax4/ovatTax4InvoicePool/batchUpdateStatusOne 批量状态更新
    post_batchUpdateStatusOne(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4InvoicePool/batchUpdateStatusOne`, postData))
    }
    // POST /tax4/ovatTax4InvoicePool/syncOvatInvoice 同步
    post_syncOvatInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4InvoicePool/syncOvatInvoice`, postData))
    }
    // POST /settings/sysConditionConfig/list 获取列表
    post_sysConditionConfigList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysConditionConfig/list`, postData))
    }
    // POST /settings/sysConditionConfig/updateOne 修改
    post_sysConditionConfigUpdateOne(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysConditionConfig/updateOne`, postData))
    }
    // POST /settings/sysConditionConfig/addOne 新增
    post_sysConditionConfigAddOne(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysConditionConfig/addOne`, postData))
    }
    // POST /settings/sysConditionConfig/delete 删除
    post_sysConditionConfigDelete(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysConditionConfig/delete`, postData))
    }
    // POST /tax4/ovatTax4Drawer/getOrgList 获取当前机构下可使用开票员列表
    post_getActiveSucceedOrgList(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/getActiveSucceedOrgList`, postdata), msg)
    }
    // POST /ems/sysTaxDisk/existUkeyCodeNewUkeyCode  返回新ukeyCode
    post_existUkeyCodeNewUkeyCode(ukeyCode, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysTaxDisk/existUkeyCodeNewUkeyCode?ukeyCode=${ukeyCode}`), msg)
    }
    // POST /tax4/wait/ordinaryElectricalWait/qryInvoiceCopyList 复制蓝票查询
    post_tax4OrdinaryCopyList(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/ordinaryElectricalWait/qryInvoiceCopyList`, postdata), msg)
    }
    // POST /ems/sysTaxDisk/addTax4Ukey 新增金四开票点信息
    post_addTax4Ukey(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysTaxDisk/addTax4Ukey`, postdata), msg)
    }
    // POST /ems/sysTaxDisk/updateTax4Ukey 修改金四开票点信息
    post_updateTax4Ukey(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysTaxDisk/updateTax4Ukey`, postdata), msg)
    }
    // POST /tax4/ovatTax4Drawer/queryDrawerByUkeyIds 通过认证id获取开票员详情
    post_queryDrawerByUkeyIds(ukeyIds, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/queryDrawerByUkeyIds?ukeyIds=${ukeyIds}`), msg)
    }
    // POST /tax4/ivatTax4InvoicePool/syncOvatInvoice 同步
    post_ivatSyncOvatInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}tax4/ivatTax4InvoicePool/syncOvatInvoice`, postData))
    }
    // POST /tax4/ovatTax4ElecErrorLog/findErrorListByPage 全电发票开票下载交付异常日志表分页查询-new
    post_findErrorListByPage(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4ElecErrorLog/findErrorListByPage`, postData))
    }
    // POST /tax4/ovatTax4ElecErrorLog/retry 全电发票开票异常日志表批量重试
    post_retryg(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4ElecErrorLog/retry`, postData), msg)
    }
    // POST /tax4/ovatTax4AutoLogin/updateScheduleJob 更新定时任务
    post_updateScheduleJob(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4AutoLogin/updateScheduleJob`, postData), msg)
    }
    // GET /tax4/ovatTax4AutoLogin/getScheduleJob 通过脚本查询对应的定时任务
    get_getScheduleJob() {
        return this.request(() => this.$http.get(`${host.etcloudOvat}tax4/ovatTax4AutoLogin/getScheduleJob?script=drawerAutoLoginJob`))
    }
    // POST /tax4/belleRegister/findListByPage 分页查询
    post_belleRegister(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/belleRegister/findListByPage`, postData), msg)
    }
    // POST /tax4/belleRegister/batchUpdate 批量修改
    post_batchUpdate(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/belleRegister/batchUpdate`, postData), msg)
    }
    // etcloud/etcloud-bi/tax4/invoiceStatistics/qryOpenedInvoiceGoodsDetailList
    post_qryOpenedInvoiceGoodsTax4DetailList(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}tax4/invoiceStatistics/qryOpenedInvoiceGoodsDetailList`, postData), msg)
    }
    // etcloud/etcloud-bi/tax4/invoiceStatistics/qryOpenedOvatInvoiceList
    post_qryOpenedOvatInvoiceTax4List(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudBiApp}tax4/invoiceStatistics/qryOpenedOvatInvoiceList`, postData), msg)
    }
    // GET etcloud/etcloud-bi/tax4/invoiceStatistics/exportGoodsDetailToXLS 商品明细报表导出excel
    get_exportGoodsTax4DetailToXLS(getdata, msg) {
        const _url = `${host.etcloudBiApp}tax4/invoiceStatistics/exportGoodsDetailToXLS`
        const url = this.getParamUrl(getdata, _url)
        window.open(url)
    }
    // GET etcloud/etcloud-bi/tax4/invoiceStatistics/exportOpenedOvatInvoiceToXLS 已开发票报表导出excel
    get_exportOpenedOvatInvoiceTax4ToXLS(getdata, msg) {
        const _url = `${host.etcloudBiApp}tax4/invoiceStatistics/exportOpenedOvatInvoiceToXLS`
        const url = this.getParamUrl(getdata, _url)
        window.open(url)
    }
    // POST /tax4/wait/ordinaryElectricalWait/batchMatchInvoices 批量回退前做匹配
    post_ordinaryBatchMatchInvoices(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/ordinaryElectricalWait/batchMatchInvoices`, postData))
    }
    // POST /tax4/wait/specialElectricalWait/batchMatchInvoices 批量回退前做匹配
    post_specialBatchMatchInvoices(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/specialElectricalWait/batchMatchInvoices`, postData))
    }
    // POST /tax4/ovatTax4Drawer/deleteTaxAccount 批量删除税务账号
    post_deleteTaxAccount(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/deleteTaxAccount`, postdata), msg)
    }
    // POST /tax4/wait/ordinaryElectricalWait/decryptInv 解密接口
    post_decryptInv(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/wait/ordinaryElectricalWait/decryptInv`, postdata), msg)
    }
    //POST /ovatInvoiceError/batchDeleteErrorLog *批量删除异常日志
    post_batchDeleteErrorLog(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}ovatInvoiceError/batchDeleteErrorLog`, postData), msg)
    }
    // POST /manage/ivatBill/syncInvoice2System 业务系统-发票同步
    post_syncInvoice2System(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatBill/syncInvoice2System`, postData), msg)
    }
    // GET /taxconfig/sysSaleInfo/getSaleInfo  获取销方信息管理
    get_getSaleInfoSys(postDate, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysSaleInfo/getSaleInfo?saleId=${postDate}`), msg)
    }
    // POST /auth/collectBatch/queryIvatCollectBatchResult 查询进项发票电子底账采集结果查询
    post_queryIvatCollectBatchResult(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}auth/collectBatch/queryIvatCollectBatchResult`, postData), msg)
    }
    // POST /tax4/ivatTax4InvoicePool/batchDownloadTax4InvoiceApply 提交申请
    post_batchDownloadTax4InvoiceApply(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}tax4/ivatTax4InvoicePool/batchDownloadTax4InvoiceApply`, postData))
    }
    // POST /tax4/ivatTax4InvoicePool/batchTaskProgressQuery 发票文件下载记录查询
    post_batchTaskProgressQuery(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}tax4/ivatTax4InvoicePool/batchTaskProgressQuery`, postData))
    }
    // POST /tax4/ivatTax4InvoicePool/batchDownloadInvoice 发票文件下载记录-下载到本地
    post_batchDownloadInvoice(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}tax4/ivatTax4InvoicePool/batchDownloadInvoice`, postData))
    }
    // 新增机构
    post_syncOrganization(data, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysOrganization/syncOrganization`,data), msg)
    }
    // POST /tax4/ovatTax4Drawer/batchActivateDrawer 批量激活开票员
    post_batchActivateDrawer(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/batchActivateDrawer`, postData), msg)
    }
    // POST /taxdeclaration/rpaGsConfig/changeConfigEmployee 变更跟进人
    post_changeConfigEmployee(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/rpaGsConfig/changeConfigEmployee`, postData), msg)
    }
    // POST /taxdeclaration/sbConf/changeTaxpayerEmployee 变更跟进人
    post_changeTaxpayerEmployee(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbConf/changeTaxpayerEmployee`, postData), msg)
    }
    // POST /tax4/ivatInvoiceEntry/findListByPage 发票入账列表分页查询
    post_ivatInvoiceEntry(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}tax4/ivatInvoiceEntry/findListByPage`, postData))
    }
    // POST /tax4/ivatInvoiceEntry/queryInvoiceEntry 发票入账查询
    post_queryInvoiceEntry(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}tax4/ivatInvoiceEntry/queryInvoiceEntry`, postData), msg)
    }
    // POST /tax4/ivatInvoiceEntry/saveInvoiceEntry 发票入账保存
    post_saveInvoiceEntry(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}tax4/ivatInvoiceEntry/saveInvoiceEntry`, postData), msg)
    }
    // POST /tax4/ivatInvoiceEntry/adjustInvoiceEntry 发票入账调整
    post_adjustInvoiceEntry(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}tax4/ivatInvoiceEntry/adjustInvoiceEntry`, postData), msg)
    }
    // POST /manage/ivatBill/batchUpdateBillPaymentMonth 批量更新入账月份
    post_batchUpdateBillPaymentMonth(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}manage/ivatBill/batchUpdateBillPaymentMonth`, postData), msg)
    }
    // GET /settings/sysParam/getSysParam 查询系统参数(选择查询)
    get_getSysParam(paramCode) {
        return this.request(() => this.$http.get(`${host.etcloud}settings/sysParam/getSysParam?paramCode=${paramCode}`))
    }
    // GET /taxdeclaration/sbConf/getIvatEmployeeList 获取跟进人集
    get_getIvatEmployeeList(postDate, msg) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}taxdeclaration/sbConf/getIvatEmployeeList`), msg)
    }
    //POST /tax4/ovatTax4Drawer/ukeyLoginCheck 校验开票点对应的开票员的登录状态
    post_ukeyLoginCheck(ukeyId, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4Drawer/ukeyLoginCheck?ukeyId=${ukeyId}`), msg)
    }
    //POST taxdeclaration/sbConf/getNonOrOpenDeclareList
    post_getNonOrOpenDeclareList(postdata, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}taxdeclaration/sbConf/getNonOrOpenDeclareList`, postdata), msg)
    }
    //tax4/ivatInvoiceEntry/exportInvoiceEntryAsyn
    post_exportInvoiceEntryAsyn(data, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}tax4/ivatInvoiceEntry/exportInvoiceEntryAsyn`, data), msg)
    }
    //tax4/belleRegister/downloadRegisterUpdateTemplate
    post_downloadRegisterUpdateTemplate(data, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}tax4/belleRegister/downloadRegisterUpdateTemplate`, data), msg)
    }
    // POST /settings/sysParam/syncSysParam 同步系统参数(选择查询)
    post_syncSysParam(data, msg) {
        return this.request(() => this.$http.post(`${host.etcloud}settings/sysParam/syncSysParam`,data),msg)
    }
    // POST /tax4/ovatTax4InvoicePool/queryCollectRecord 销项发票池归集记录分页查询
    post_queryOvatCollectRecord(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/ovatTax4InvoicePool/queryCollectRecord`, postData))
    }
    // POST /tax4/ivatTax4InvoicePool/queryCollectRecord 进项发票池归集记录分页查询
    post_queryIvatCollectRecord(postData, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}tax4/ivatTax4InvoicePool/queryCollectRecord`, postData))
    }

    //tax4/ivatDeductionScheme/queryDeductionScheme  查询抵扣方案
    post_queryDeductionScheme(data, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}tax4/ivatDeductionScheme/queryDeductionScheme`, data), msg)
    }
    get_delDeductionScheme(schemeId, msg) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}tax4/ivatDeductionScheme/delDeductionScheme?schemeId=${schemeId}`), msg)
    }

    post_addDeductionScheme(data, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}tax4/ivatDeductionScheme/addDeductionScheme`, data), msg)
    }

    post_queryDeductionRuleList(data, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}tax4/ivatDeductionScheme/queryDeductionRuleList`, data), msg)
    }

    get_delDeductionRule(configId, msg) {
        return this.request(() => this.$http.get(`${host.etcloudIvatApp}tax4/ivatDeductionScheme/delDeductionRule?configId=${configId}`), msg)
    }

    //addDeductionSchemeRule
    post_addDeductionSchemeRule(data, msg) {
        return this.request(() => this.$http.post(`${host.etcloudIvatApp}tax4/ivatDeductionScheme/addDeductionSchemeRule`, data), msg)
    }
    // etcloud-sys/ems/sysUserCustomized/getUserCustomizedInfo
    get_getUserCustomizedInfo(id, msg) {
        return this.request(() => this.$http.get(`${host.etcloud}ems/sysUserCustomized/getUserCustomizedInfo?type=${id}`), msg)
    }
    //tax4/realNameAuth/queryNewQrCodeStatus
    post_queryNewQrCodeStatus(data, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/realNameAuth/queryNewQrCodeStatus`, data), msg)
    }
    // /ems/sysIncrementRecord/syncBelleAllOrg
    post_syncBelleAllOrg( msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysIncrementRecord/syncBelleAllOrg`), msg)
    }
    // post /ems/sysOrganization/org2Electronic 机构列表同步到电子会计档案系统
    post_syncArchiveOrg( msg) {
        return this.request(() => this.$http.post(`${host.etcloud}ems/sysOrganization/org2Electronic`), msg)
    }
    // tax4/drawerLockLog/findListByPage
    post_drawerLockLogfindListByPage(data, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/drawerLockLog/findListByPage`, data), msg)
    }
    // post /tax4/drawerLockLog/unlock 解锁
    post_unlock(data, msg) {
        return this.request(() => this.$http.post(`${host.etcloudOvat}tax4/drawerLockLog/unlock`, data), msg)
    }
}

httpRequest.$inject = ['$q', '$http', '$state', 'logger', '$uibModal']
export default httpRequest



// WEBPACK FOOTER //
// ./src/common/services/httpService.js